webpackJsonp([1],{

/***/ "+9Ma":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ConceptosEditar"},[_c('md-layout',{attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"60","md-flex-medium":"60","md-flex-large":"40","md-flex-xlarge":"30"}},[_c('md-card',{staticClass:"w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Registrar concepto de nómina")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-column":"","md-flex":"100"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_desc }},[_c('label',[_vm._v("Concepto")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.concepto.desc_con),callback:function ($$v) {_vm.concepto.desc_con=$$v},expression:"concepto.desc_con"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tipo }},[_c('label',[_vm._v("Tipo")]),_vm._v(" "),_c('md-select',{attrs:{"name":"tipo_con","id":"tipo_con","required":""},model:{value:(_vm.concepto.tipo_con),callback:function ($$v) {_vm.concepto.tipo_con=$$v},expression:"concepto.tipo_con"}},[_c('md-option',{attrs:{"value":"ingreso"}},[_vm._v("Ingreso")]),_vm._v(" "),_c('md-option',{attrs:{"value":"egreso"}},[_vm._v("Egreso")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_importe }},[_c('label',[_vm._v("Importe")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.concepto.importe_cnh),callback:function ($$v) {_vm.concepto.importe_cnh=$$v},expression:"concepto.importe_cnh"}})],1)],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('router-link',{attrs:{"tag":"md-button","to":"/conceptos"}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-accent md-primary",nativeOn:{"click":function($event){_vm.guardarConcepto()}}},[_vm._v("Guardar concepto")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "06Xo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AsistenciasPuntos",
  methods: {
    moment: function moment(a, b) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(a, b);
    },
    obtenerTurnosPendientesAsistencias: function obtenerTurnosPendientesAsistencias() {
      var _this = this;

      this.$http.post("asistencias/turnos", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "turnos" in response.body) {
          _this.turnos = response.body.turnos;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    irAPaseDeListaDelTurno: function irAPaseDeListaDelTurno(id_ptu) {
      this.$router.push({
        name: "AsistenciasPuntoSeleccionado",
        params: { turno: __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(id_ptu)) }
      });
    }
  },
  mounted: function mounted() {
    this.obtenerTurnosPendientesAsistencias();
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data: function data() {
    return {
      msg: "Inicio",
      turnos: null
    };
  }
});

/***/ }),

/***/ "0EqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ClientesListado m-t-16"},[_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Clientes registrados")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Cuenta")]),_vm._v(" "),_c('md-table-head',[_vm._v("Razón social")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.clientes),function(cliente,index){return _c('md-table-row',{key:index},[_c('md-table-cell',[_vm._v(_vm._s(cliente.cuenta))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(cliente.nombre.toUpperCase()))]),_vm._v(" "),_c('md-table-cell',[(_vm.admin_cobranza)?_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.irAEditarCliente(cliente.cliente)}}},[_c('md-icon',[_vm._v("edit")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"top"}},[_vm._v("Editar")])],1):_vm._e()],1)],1)}))],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2VY+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2dYt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanesDetalle_vue__ = __webpack_require__("wNPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b5fd605_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlanesDetalle_vue__ = __webpack_require__("Sskl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanesDetalle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b5fd605_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlanesDetalle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3U5Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net__ = __webpack_require__("FNwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PuestosListado",
  methods: {
    obtenerConceptos: function obtenerConceptos() {
      var _this = this;

      this.$http.post("puestos", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "puestos" in response.body) {
          _this.puestos = response.body.puestos;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    modalEditarPuesto: function modalEditarPuesto(puesto) {
      this.puesto = puesto;
      this.$refs["modalEditarPuesto"].open();
    },
    cerrarModalEditarPuesto: function cerrarModalEditarPuesto() {
      this.puesto = null;
      this.$refs["modalEditarPuesto"].close();
    },
    guardarCambiosPuesto: function guardarCambiosPuesto() {
      var _this2 = this;

      if (this.validarCamposPuesto()) {
        this.$http.post("puestos/actualizar", {
          id: this.puesto.puesto,
          data: this.puesto,
          token: this.$session.get("token")
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false
            });
            _this2.cerrarModalEditarPuesto();
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      }
    },
    validarCamposPuesto: function validarCamposPuesto() {
      !this.puesto.nombre_pue ? this.val.v_nombre = true : this.val.v_nombre = false;
      !this.puesto.descripcion_pue ? this.val.v_descripcion = true : this.val.v_descripcion = false;
      !this.puesto.depto_pue ? this.val.v_depto = true : this.val.v_depto = false;
      !this.puesto.estatus_pue ? this.val.v_estatus = true : this.val.v_estatus = false;
      if (this.val.v_nombre || this.val.v_descripcion || this.val.v_depto || this.val.v_estatus) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  beforeMount: function beforeMount() {
    this.obtenerConceptos();
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".md-table table").DataTable();
  },
  data: function data() {
    return {
      puestos: [],
      puesto: {
        nombre_pue: null,
        descripcion_pue: null,
        depto_pue: null,
        estatus_pue: null
      },
      val: {
        v_nombre: null,
        v_descripcion: null,
        v_depto: null,
        v_estatus: null
      }
    };
  }
});

/***/ }),

/***/ "3XSK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AsistenciasTiemposExtra"},[_c('md-layout',{staticClass:"m-t-24",attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"90","md-flex-xlarge":"70"}},[_c('md-table-card',{staticClass:"w-100"},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("\n            Asignación de tiempos extra\n          ")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("#emp")]),_vm._v(" "),_c('md-table-head',[_vm._v("Empleado")]),_vm._v(" "),_c('md-table-head',[_vm._v("Fecha reg. falta")]),_vm._v(" "),_c('md-table-head',[_vm._v("Punto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Turno")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.tiemposextra),function(tex){return _c('md-table-row',{key:tex.id_tex},[_c('md-table-cell',[(tex.nombre)?_c('div',[_vm._v("\n                  "+_vm._s(tex.id_emn)+"\n                ")]):_vm._e()]),_vm._v(" "),_c('md-table-cell',[(tex.nombre)?_c('div',[_vm._v("\n                  "+_vm._s(tex.nombre)+"\n                ")]):_c('div',[_vm._v("\n                  VACANTE\n                ")])]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.moment(tex.fecha_asi,'YYYY-MM-DD h:mm:ss').format('YYYY-MM-DD h:mm A')))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(tex.nombre_pun))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.moment(tex.inicio_ptu,'h:mm:ss').format('h:mm A'))+" - "+_vm._s(_vm.moment(tex.termino_ptu,'h:mm:ss').format('h:mm A')))]),_vm._v(" "),_c('md-table-cell',[_c('md-button',{staticClass:"md-raised md-accent",staticStyle:{"width":"auto"},nativeOn:{"click":function($event){_vm.buscarEmpleadoCubriraPunto(tex)}}},[_vm._v("Asignar cubre vacante")])],1)],1)}))],1)],1)],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalBuscarEmpleado",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-content',[_c('h2',[_vm._v("\n        Tiempo extra en punto: "+_vm._s(_vm.emp_tex.nombre_pun)+" "),_c('br'),_vm._v("Turno: "+_vm._s(_vm.moment(_vm.emp_tex.inicio_ptu,'h:mm:ss').format('h:mm A'))+" - "+_vm._s(_vm.moment(_vm.emp_tex.termino_ptu,'h:mm:ss').format('h:mm A'))),_c('br'),_vm._v(" Cubre a: "+_vm._s(_vm.emp_tex.nombre)+"\n      ")]),_vm._v(" "),_c('md-input-container',[_c('md-autocomplete',{attrs:{"fetch":_vm.fetchFunction,"print-attribute":"nombre","debounce":300,"minChars":2},on:{"selected":function($event){_vm.funcionSelect($event)}},model:{value:(_vm.autocompleteValue),callback:function ($$v) {_vm.autocompleteValue=$$v},expression:"autocompleteValue"}})],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModal('modalBuscarEmpleado')}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised",nativeOn:{"click":function($event){_vm.asignarEmpleado()}}},[_vm._v("Asignar tiempo extra")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3fve":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PlanesNuevo"},[_c('md-layout',{attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"90","md-flex-large":"70","md-flex-xlarge":"60"}},[_c('md-card',{staticClass:"w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Registrar plan de pago")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-column":"","md-flex":"100"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nombre }},[_c('label',[_vm._v("Nombre del plan")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.plan.nombre_pln),callback:function ($$v) {_vm.plan.nombre_pln=$$v},expression:"plan.nombre_pln"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_salario_qnal }},[_c('label',[_vm._v("Salario semanal")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.salario_qnal_pnh),callback:function ($$v) {_vm.plan.salario_qnal_pnh=$$v},expression:"plan.salario_qnal_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_falta_just }},[_c('label',[_vm._v("Falta justificada")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.falta_just_pnh),callback:function ($$v) {_vm.plan.falta_just_pnh=$$v},expression:"plan.falta_just_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_falta_injust }},[_c('label',[_vm._v("Falta injustificada")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.falta_injust_pnh),callback:function ($$v) {_vm.plan.falta_injust_pnh=$$v},expression:"plan.falta_injust_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_permiso }},[_c('label',[_vm._v("Permiso")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.permiso_pnh),callback:function ($$v) {_vm.plan.permiso_pnh=$$v},expression:"plan.permiso_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_permiso_falle }},[_c('label',[_vm._v("Permiso fallecimiento")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.permiso_falle_pnh),callback:function ($$v) {_vm.plan.permiso_falle_pnh=$$v},expression:"plan.permiso_falle_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_permiso_naci }},[_c('label',[_vm._v("Permiso nacimiento")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.permiso_naci_pnh),callback:function ($$v) {_vm.plan.permiso_naci_pnh=$$v},expression:"plan.permiso_naci_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_hora_tie_ext }},[_c('label',[_vm._v("Hora de tiempo extra")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.hora_tie_ext_pnh),callback:function ($$v) {_vm.plan.hora_tie_ext_pnh=$$v},expression:"plan.hora_tie_ext_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tie_ext }},[_c('label',[_vm._v("Tiempo extra")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.tie_ext_pnh),callback:function ($$v) {_vm.plan.tie_ext_pnh=$$v},expression:"plan.tie_ext_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_dia_festivo }},[_c('label',[_vm._v("Día festivo")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.dia_festivo_pnh),callback:function ($$v) {_vm.plan.dia_festivo_pnh=$$v},expression:"plan.dia_festivo_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_dia_tresuno }},[_c('label',[_vm._v("Día 28")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.dia_tresuno_pnh),callback:function ($$v) {_vm.plan.dia_tresuno_pnh=$$v},expression:"plan.dia_tresuno_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_dia_dosocho }},[_c('label',[_vm._v("Día 31")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.dia_dosocho_pnh),callback:function ($$v) {_vm.plan.dia_dosocho_pnh=$$v},expression:"plan.dia_dosocho_pnh"}})],1)],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('router-link',{attrs:{"tag":"md-button","to":"/planes"}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised",nativeOn:{"click":function($event){_vm.guardarPlan()}}},[_vm._v("Guardar")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff"}}

/***/ }),

/***/ "5s3/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PlanesNuevo",
  methods: {
    guardarPlan: function guardarPlan() {
      var _this = this;

      if (this.validarCamposPlan()) {
        this.$http.post("planes/guardar", {
          data: this.plan,
          token: this.$session.get("token")
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: "Bienvenido " + response.body.msg,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false
            });
            _this.$router.push("/planes");
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      }
    },
    validarCamposPlan: function validarCamposPlan() {
      !this.plan.salario_qnal_pnh ? this.val.v_salario_qnal = true : this.val.v_salario_qnal = false;
      !this.plan.falta_just_pnh ? this.val.v_falta_just = true : this.val.v_falta_just = false;
      !this.plan.falta_injust_pnh ? this.val.v_falta_injust = true : this.val.v_falta_injust = false;
      !this.plan.permiso_pnh ? this.val.v_permiso = true : this.val.v_permiso = false;
      !this.plan.permiso_falle_pnh ? this.val.v_permiso_falle = true : this.val.v_permiso_falle = false;
      !this.plan.permiso_naci_pnh ? this.val.v_permiso_naci = true : this.val.v_permiso_naci = false;
      !this.plan.hora_tie_ext_pnh ? this.val.v_hora_tie_ext = true : this.val.v_hora_tie_ext = false;
      !this.plan.tie_ext_pnh ? this.val.v_tie_ext = true : this.val.v_tie_ext = false;
      !this.plan.dia_festivo_pnh ? this.val.v_dia_festivo = true : this.val.v_dia_festivo = false;
      !this.plan.dia_tresuno_pnh ? this.val.v_dia_tresuno = true : this.val.v_dia_tresuno = false;
      !this.plan.dia_dosocho_pnh ? this.val.v_dia_dosocho = true : this.val.v_dia_dosocho = false;
      if (this.val.v_salario_qnal || this.val.v_falta_just || this.val.v_falta_injust || this.val.v_permiso || this.val.v_permiso_falle || this.val.v_permiso_naci || this.val.v_hora_tie_ext || this.val.v_tie_ext || this.val.v_dia_festivo || this.val.v_dia_tresuno || this.val.v_dia_dosocho) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Por favor llene todos los campos",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        console.log("validacion de form trabajo retorno true");
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data: function data() {
    return {
      msg: "Inicio",
      plan: {
        nombre_pln: null,
        salario_qnal_pnh: null,
        falta_just_pnh: null,
        falta_injust_pnh: null,
        permiso_pnh: null,
        permiso_falle_pnh: null,
        permiso_naci_pnh: null,
        hora_tie_ext_pnh: null,
        tie_ext_pnh: null,
        dia_festivo_pnh: null,
        dia_tresuno_pnh: null,
        dia_dosocho_pnh: null
      },
      val: {
        v_salario_qnal: null,
        v_falta_just: null,
        v_falta_injust: null,
        v_permiso: null,
        v_permiso_falle: null,
        v_permiso_naci: null,
        v_hora_tie_ext: null,
        v_tie_ext: null,
        v_dia_festivo: null,
        v_dia_tresuno: null,
        v_dia_dosocho: null
      }
    };
  }
});

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "7FkD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inicio_vue__ = __webpack_require__("8vcv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58b57182_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Inicio_vue__ = __webpack_require__("n+S8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inicio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58b57182_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Inicio_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7Wrc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net__ = __webpack_require__("FNwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EmpleadosListado",
  methods: {
    abrirModalSubirContrato: function abrirModalSubirContrato(e, i) {
      this.empleado = e;
      this.index = i;
      this.$refs["modalSubirContrato"].open();
    },
    prepararContratoSubir: function prepararContratoSubir(e) {
      this.archivo_contrato = e[0];
    },
    hayContratoAnexado: function hayContratoAnexado() {
      if (this.archivo_contrato) {
        return true;
      } else {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Debe seleccionar el archivo de su investigación",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      }
    },
    guardarArchivoContrato: function guardarArchivoContrato() {
      var _this = this;

      if (this.hayContratoAnexado()) {
        //this.cerrarModal("modalSubirContrato");
        //this.abrirModal("subiendoArchivo");
        var formData = new FormData();
        formData.append("token", this.$session.get("token"));
        formData.append("empleado", __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(this.empleado.id_emn)));
        formData.append("archivo", this.archivo_contrato);
        this.$http.post("empleados/subirContrato", formData).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            _this.empleados[_this.index].archivo_enc = "a";
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              pos: "top-right",
              actionText: "Cerrar",
              showAction: false,
              duration: 20000
            });
            _this.cerrarModal("modalSubirContrato");
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#CC3D30",
              actionTextColor: "#FFF"
            });
          }
          //this.cerrarModal("subiendoArchivo");
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor para guardar el contrato. Inténtelo de nuevo.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#CC3D30",
            actionTextColor: "#FFF"
          });
          _this.cerrarModal("subiendoArchivo");
        });
      }
    },
    cerrarModal: function cerrarModal(a) {
      this.$refs[a].close();
    },
    abrirVentanaGenerarContrato: function abrirVentanaGenerarContrato(e) {
      window.open("http://api.grupoalarcom.mx/contratos/pdf?a=e&n=" + __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(e)), "_blank");
    },
    obtenerEmpleados: function obtenerEmpleados() {
      var _this2 = this;

      this.$http.post("empleados", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "empleados" in response.body) {
          _this2.empleados = response.body.empleados;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    cambiarEstatusEmpleado: function cambiarEstatusEmpleado() {
      var _this3 = this;

      this.$http.post("empleados/estatus", {
        token: this.$session.get("token"),
        empleado: this.empleado.empleado,
        data: this.empleado,
        obs: this.observaciones_ene
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            pos: "top-right"
          });
          _this3.$refs["modalEditarEstatus"].close();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    abrirModalEditarEstatus: function abrirModalEditarEstatus(empleado) {
      this.empleado = empleado;
      this.observaciones_ene = null;
      this.estatus_old = this.empleado.estatus_ene;
      this.$refs["modalEditarEstatus"].open();
    },
    cerrarModalEditarEstatus: function cerrarModalEditarEstatus() {
      this.empleado.estatus_ene = this.estatus_old;
      this.$refs["modalEditarEstatus"].close();
    },
    irEditarEmpleado: function irEditarEmpleado(empleado) {
      this.$router.push({
        name: "EmpleadosEditar",
        params: { empleado: __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(empleado)) }
      });
    },
    irDetalleEmpleado: function irDetalleEmpleado(empleado) {
      this.$router.push({
        name: "EmpleadosDetalle",
        params: { empleado: empleado }
      });
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  beforeMount: function beforeMount() {
    this.obtenerEmpleados();
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".md-table table").DataTable();
  },
  data: function data() {
    return {
      empleados: [],
      archivo_contrato: null,
      single: null,
      index: null,
      empleado: {
        id_emn: null,
        nombre_emn: null,
        ap_pat_emn: null,
        ap_mat_emn: null
      },
      observaciones_ene: null,
      estatus_old: null
    };
  }
});

/***/ }),

/***/ "8NWe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EditarCliente",
  methods: {
    obtenerCliente: function obtenerCliente() {
      var _this = this;

      this.$http.post("clientes/obtener", {
        token: this.$session.get("token"),
        id: this.$route.params.cliente
      }).then(function (response) {
        if (response.status === 200 && "cliente" in response.body) {
          _this.cliente = response.body.cliente;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
          _this.$router.push("/clientes");
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        _this.$router.push("/clientes");
      });
    },
    actualizarCliente: function actualizarCliente() {
      var _this2 = this;

      if (this.validarCamposCliente()) {
        this.$http.post("clientes/actualizar", {
          token: this.$session.get("token"),
          data: this.cliente,
          id: this.$route.params.cliente
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false
            });
            _this2.$router.push("/clientes");
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      }
    },
    validarCamposCliente: function validarCamposCliente() {
      !this.cliente.nombre ? this.val.v_nombre = true : this.val.v_nombre = false;
      !this.cliente.cuenta ? this.val.v_cuenta = true : this.val.v_cuenta = false;
      if (this.val.v_nombre || this.val.v_cuenta) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    } else if (tipo != "administrador" || tipo != "cobranza") {
      this.$router.push("/clientes");
    }
  },
  created: function created() {
    var tipo = this.$session.get("tipo");

    this.obtenerCliente();
  },
  data: function data() {
    return {
      cliente: {
        cuenta: null,
        nombre: null,
        rfc: null,
        email: null,
        telefono: null,
        estado: null,
        municipio: null,
        ciudad: null,
        calle: null,
        colonia: null,
        numero: null,
        codigo_postal: null,
        fecha_ingreso: null,
        notas: null,
        ruta: null
      },
      val: {
        v_cuenta: null,
        v_nombre: null
      }
    };
  }
});

/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "8vcv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "inicio",
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data: function data() {
    return {
      msg: "Inicio"
    };
  }
});

/***/ }),

/***/ "9TiH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AdelantosNominaAdministrativo",
  methods: {
    obtenerEmpleadosCandidatos: function obtenerEmpleadosCandidatos() {
      var _this = this;

      this.$http.post("adelantos/pueden", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "empleados" in response.body) {
          _this.empleados = response.body.empleados;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    hizoBlur: function hizoBlur(nombre, empleado, tope, importe) {
      if (tope / 2 <= importe) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "A " + nombre + " se le ha asignado mas del 50% de su salario quincenal",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      }
      this.adelantos[empleado] = importe;
      console.log(this.adelantos);
    },
    guardarAdelantos: function guardarAdelantos() {
      var _this2 = this;

      this.$http.post("adelantos/guardar", {
        token: this.$session.get("token"),
        data: this.adelantos
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false
          });
          _this2.obtenerEmpleadosCandidatos();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    } else if (this.$session.get("tipo") != "administrador") {
      this.$router.push("/");
    }
  },
  created: function created() {
    this.obtenerEmpleadosCandidatos();
  },
  data: function data() {
    return {
      valor: "",
      msg: "AdelantosNominaAdministrativo",
      empleados: [],
      adelantos: []
    };
  }
});

/***/ }),

/***/ "A80F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PuntosNuevo",
  methods: {
    obtenerContratos: function obtenerContratos() {
      var _this = this;

      this.$route.params.id;
      this.$http.post("contratos", {
        token: this.$session.get("token"),
        id: this.$route.params.cliente,
        tipo: "servicios_guardias"
      }).then(function (response) {
        if (response.status === 200 && "contratos" in response.body) {
          _this.contratos = response.body.contratos;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        _this.$router.push("/punto/cliente");
      });
    },
    obtenerCliente: function obtenerCliente() {
      var _this2 = this;

      this.$route.params.id;
      this.$http.post("clientes/obtener", {
        token: this.$session.get("token"),
        id: this.$route.params.cliente
      }).then(function (response) {
        if (response.status === 200 && "cliente" in response.body) {
          _this2.cliente = response.body.cliente;
          _this2.punto.id_cli_pun = response.body.cliente.id_cliente;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
          _this2.$router.push("/punto/cliente");
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        _this2.$router.push("/punto/cliente");
      });
    },
    copiarInformacionCliente: function copiarInformacionCliente() {
      this.punto.calle_pun = this.cliente.calle;
      this.punto.num_ext_pun = this.cliente.numero;
      this.punto.colonia_pun = this.cliente.colonia;
      this.punto.cp_pun = this.cliente.codigo_postal;
      this.punto.municipio_pun = this.cliente.municipio;
      this.punto.estado_pun = this.cliente.estado;
      this.punto.notas_pun = this.cliente.notas;
    },
    guardarPunto: function guardarPunto() {
      var _this3 = this;

      if (this.validarInformacion() && this.existenTurnosRegistrados()) {
        this.$http.post("puntos/guardar", {
          token: this.$session.get("token"),
          data: this.punto,
          cnt: this.punto.id_cnt_pun,
          turnos: this.turnos
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right"
            });
            _this3.abrirVentanaContrato(response.body.punto);
            _this3.$router.push("/puntos");
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      }
    },
    validarInformacion: function validarInformacion() {
      !this.punto.nombre_pun ? this.val.v_nombre = true : this.val.v_nombre = false;
      !this.punto.guardias_pun ? this.val.v_guardias = true : this.val.v_guardias = false;
      !this.punto.presupuesto_pun ? this.val.v_presupuesto = true : this.val.v_presupuesto = false;
      !this.punto.calle_pun ? this.val.v_calle = true : this.val.v_calle = false;
      !this.punto.num_ext_pun ? this.val.v_num_ext = true : this.val.v_num_ext = false;
      !this.punto.id_cnt_pun ? this.val.v_id_cnt = true : this.val.v_id_cnt = false;
      if (this.val.v_nombre || this.val.v_guardias || this.val.v_presupuesto || this.val.v_calle || this.val.v_num_ext) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    },
    agregarTurno: function agregarTurno() {
      if (this.validarSelectsTurno()) {
        this.turnos.push({
          inicio_tur: this.turno.inicio_tur,
          fin_tur: this.turno.fin_tur
        });
        this.turno.inicio_tur = null;
        this.turno.fin_tur = null;
        this.val.v_inicio_tur = null;
        this.val.v_fin_tur = null;
      }
    },
    removerTurno: function removerTurno(index) {
      this.turnos.splice(index, 1);
    },
    abrirVentanaContrato: function abrirVentanaContrato(id_p) {
      window.open("http://api.grupoalarcom.mx/pdf/contratos?punto=" + id_p, "_blank");
    },
    existenTurnosRegistrados: function existenTurnosRegistrados() {
      if (this.turnos.length > 0) {
        return true;
      } else {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Para registrar el punto debe asignar los turnos",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      }
    },
    validarSelectsTurno: function validarSelectsTurno() {
      !this.turno.inicio_tur ? this.val.v_inicio_tur = true : this.val.v_inicio_tur = false;
      !this.turno.fin_tur ? this.val.v_fin_tur = true : this.val.v_fin_tur = false;
      if (this.val.v_fin_tur || this.val.v_inicio_tur) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Por favor seleccione los horarios del turno",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created: function created() {
    this.obtenerCliente();
  },
  mounted: function mounted() {
    this.obtenerContratos();
  },
  data: function data() {
    return {
      msg: "Inicio",
      contratos: [],
      cliente: {
        cuenta: null,
        nombre: null,
        rfc: null,
        email: null,
        telefono: null,
        estado: null,
        municipio: null,
        ciudad: null,
        calle: null,
        colonia: null,
        numero: null,
        codigo_postal: null,
        notas: null
      },
      punto: {
        id_cli_pun: null,
        nombre_pun: null,
        guardias_pun: null,
        presupuesto_pun: null,
        calle_pun: null,
        num_ext_pun: null,
        colonia_pun: null,
        cp_pun: null,
        municipio_pun: null,
        estado_pun: null,
        id_cnt_pun: null,
        notas_pun: null
      },
      turno: {
        inicio_tur: null,
        fin_tur: null
      },
      turnos: [],
      val: {
        v_nombre: null,
        v_guardias: null,
        v_presupuesto: null,
        v_calle: null,
        v_num_ext: null,
        v_inicio_tur: null,
        v_fin_tur: null,
        v_id_cnt: null
      }
    };
  }
});

/***/ }),

/***/ "AMwP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidenciasPendientesListado_vue__ = __webpack_require__("Fdas");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec1fc1ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IncidenciasPendientesListado_vue__ = __webpack_require__("nseC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidenciasPendientesListado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec1fc1ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IncidenciasPendientesListado_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AcWF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuntosEditar_vue__ = __webpack_require__("jmP/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_624c319d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuntosEditar_vue__ = __webpack_require__("wp6J");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuntosEditar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_624c319d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuntosEditar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Af+t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net__ = __webpack_require__("FNwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ClientesListado",
  methods: {
    obtenerClientes: function obtenerClientes() {
      var _this = this;

      this.$http.post("clientes", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "clientes" in response.body) {
          _this.clientes = response.body.clientes;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    irAEditarCliente: function irAEditarCliente(id) {
      this.$router.push({ name: "ClientesEditar", params: { cliente: id } });
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created: function created() {
    var tipo = this.$session.get("tipo");
    this.admin_cobranza = tipo === "administrador" || tipo === "cobranza" ? true : false;
  },
  beforeMount: function beforeMount() {
    this.obtenerClientes();
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".md-table table").DataTable();
  },
  data: function data() {
    return {
      clientes: [],
      admin_cobranza: false
    };
  }
});

/***/ }),

/***/ "BH+U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IncidenciasListado"},[_c('h1',[_vm._v("Incidencias")]),_vm._v(" "),_c('md-table-card',{staticClass:"w-100"},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Incidencias registradas")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Fecha")]),_vm._v(" "),_c('md-table-head',[_vm._v("Incidencia")]),_vm._v(" "),_c('md-table-head',[_vm._v("Punto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Estatus")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.incidencias),function(i){return _c('md-table-row',{key:i},[_c('md-table-cell',[_vm._v(_vm._s(i.fecha_ipu))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(i.obs_ipu))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(i.nombre_pun))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(i.estatus_ipu.toUpperCase()))]),_vm._v(" "),_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button md-raised md-accent",nativeOn:{"click":function($event){_vm.abrirModalEstatusIncidencia(i)}}},[_c('md-icon',{staticStyle:{"color":"white"}},[_vm._v("edit")])],1)],1)],1)}))],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalEstatusIncidencia",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-content',[_c('p',[_vm._v(_vm._s(_vm.incidencia.obs_ipu))]),_vm._v(" "),_c('md-input-container',[_c('label',{attrs:{"for":"estatus_ipu"}},[_vm._v("Estatus")]),_vm._v(" "),_c('md-select',{attrs:{"name":"estatus_ipu","id":"estatus_ipu"},model:{value:(_vm.incidencia.estatus_ipu),callback:function ($$v) {_vm.incidencia.estatus_ipu=$$v},expression:"incidencia.estatus_ipu"}},[_c('md-option',{attrs:{"value":"pendiente"}},[_vm._v("Pendiente")]),_vm._v(" "),_c('md-option',{attrs:{"value":"atendido"}},[_vm._v("Atendida")])],1)],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerraModal('modalEstatusIncidencia')}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{nativeOn:{"click":function($event){_vm.guardarEstatus()}}},[_vm._v("Cambiar estatus")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FF/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PuestosListado"},[_c('md-layout',{staticClass:"m-t-24",attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"75","md-flex-xlarge":"50"}},[_c('md-table-card',{staticClass:"w-100"},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Puestos registrados")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Puesto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Depto.")]),_vm._v(" "),_c('md-table-head',[_vm._v("Descripción")]),_vm._v(" "),_c('md-table-head',[_vm._v("Estatus")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.puestos),function(puesto){return _c('md-table-row',{key:puesto},[_c('md-table-cell',[_vm._v(_vm._s(puesto.nombre_pue))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(puesto.depto_pue.toUpperCase()))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(puesto.descripcion_pue))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(puesto.estatus_pue.toUpperCase()))]),_vm._v(" "),_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.modalEditarPuesto(puesto)}}},[_c('md-icon',[_vm._v("edit")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Editar puesto")])],1)],1)],1)}))],1)],1)],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalEditarPuesto",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.puesto.nombre_pue))]),_vm._v(" "),_c('md-dialog-content',[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nombre }},[_c('label',[_vm._v("Puesto")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.puesto.nombre_pue),callback:function ($$v) {_vm.puesto.nombre_pue=$$v},expression:"puesto.nombre_pue"}})],1),_vm._v(" "),_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_descripcion }},[_c('label',[_vm._v("Descripción")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.puesto.descripcion_pue),callback:function ($$v) {_vm.puesto.descripcion_pue=$$v},expression:"puesto.descripcion_pue"}})],1),_vm._v(" "),_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_depto }},[_c('label',{attrs:{"for":"depto_pue"}},[_vm._v("Departamento")]),_vm._v(" "),_c('md-select',{attrs:{"name":"depto_pue","id":"depto_pue","required":""},model:{value:(_vm.puesto.depto_pue),callback:function ($$v) {_vm.puesto.depto_pue=$$v},expression:"puesto.depto_pue"}},[_c('md-option',{attrs:{"value":"administrativo"}},[_vm._v("Administrativo")]),_vm._v(" "),_c('md-option',{attrs:{"value":"operativo"}},[_vm._v("Operativo")]),_vm._v(" "),_c('md-option',{attrs:{"value":"otro"}},[_vm._v("Otro")])],1)],1),_vm._v(" "),_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_estatus }},[_c('label',{attrs:{"for":"estatus_pue"}},[_vm._v("Estatus")]),_vm._v(" "),_c('md-select',{attrs:{"name":"estatus_pue","id":"estatus_pue","required":""},model:{value:(_vm.puesto.estatus_pue),callback:function ($$v) {_vm.puesto.estatus_pue=$$v},expression:"puesto.estatus_pue"}},[_c('md-option',{attrs:{"value":"activo"}},[_vm._v("Activo")]),_vm._v(" "),_c('md-option',{attrs:{"value":"inactivo"}},[_vm._v("Inactivo")])],1)],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModalEditarPuesto()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised",nativeOn:{"click":function($event){_vm.guardarCambiosPuesto()}}},[_vm._v("Guardar cambios")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FVXa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContratosNuevo_vue__ = __webpack_require__("Y7i6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e682a96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ContratosNuevo_vue__ = __webpack_require__("K3oT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContratosNuevo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e682a96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ContratosNuevo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FWho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AsistenciasTiemposExtra"},[_c('md-layout',{staticClass:"m-t-24",attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"90","md-flex-xlarge":"70"}},[_c('md-table-card',{staticClass:"w-100"},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("\n            Tiempos extra pendientes de validar\n          ")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Registrado")]),_vm._v(" "),_c('md-table-head',[_vm._v("Faltó")]),_vm._v(" "),_c('md-table-head',[_vm._v("Fecha inasistencia")]),_vm._v(" "),_c('md-table-head',[_vm._v("Tipo falta")]),_vm._v(" "),_c('md-table-head',[_vm._v("Cubrió")]),_vm._v(" "),_c('md-table-head',[_vm._v("Otorgó")]),_vm._v(" "),_c('md-table-head',[_vm._v("Punto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Turno")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.tiemposextra),function(tex){return _c('md-table-row',{key:tex.id_tex},[_c('md-table-cell',[_vm._v("\n                "+_vm._s(_vm.moment(tex.fecha_tex,'YYYY-MM-DD h:mm:ss').format('YYYY-MM-DD h:mm A'))+"\n              ")]),_vm._v(" "),_c('md-table-cell',[(tex.emp_falto)?_c('div',[_vm._v(_vm._s(tex.emp_falto))]):_c('div',[_vm._v("VACANTE")])]),_vm._v(" "),_c('md-table-cell',[_vm._v("\n                "+_vm._s(_vm.moment(tex.fecha_asi,'YYYY-MM-DD h:mm:ss').format('YYYY-MM-DD h:mm A'))+"\n              ")]),_vm._v(" "),_c('md-table-cell',[(tex.tipo_asd === 'asistio')?_c('div',[_vm._v(" Asistencia ")]):_vm._e(),_vm._v(" "),(tex.tipo_asd === 'falta_just_pnh')?_c('div',[_vm._v(" FALTA JUSTIFICADA ")]):_vm._e(),_vm._v(" "),(tex.tipo_asd === 'falta_injust_pnh')?_c('div',[_vm._v(" FALTA INJUSTIFICADA ")]):_vm._e(),_vm._v(" "),(tex.tipo_asd === 'permiso_pnh')?_c('div',[_vm._v(" PERMISO ")]):_vm._e(),_vm._v(" "),(tex.tipo_asd === 'permiso_falle_pnh')?_c('div',[_vm._v(" PERMISO FALLECIMIENTO ")]):_vm._e(),_vm._v(" "),(tex.tipo_asd === 'permiso_naci_pnh')?_c('div',[_vm._v(" PERMISO NACIMIENTO ")]):_vm._e()]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(tex.emp_asignado))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(tex.emp_otorga))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(tex.nombre_pun))]),_vm._v(" "),_c('md-table-cell',[_vm._v("\n                "+_vm._s(_vm.moment(tex.inicio_ptu,'h:mm:ss').format('h:mm A'))+" a "+_vm._s(_vm.moment(tex.termino_ptu,'h:mm:ss').format('h:mm A'))+"\n              ")]),_vm._v(" "),_c('md-table-cell',[_c('md-button',{staticClass:"md-accent md-raised",staticStyle:{"width":"auto"},nativeOn:{"click":function($event){_vm.abrirModalValidarTiempoExtra(tex)}}},[_vm._v("VALIDAR ")])],1)],1)}))],1)],1)],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalTiempoExtraPorValidar",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-content',[_c('h2',[_vm._v(" Validación de tiempo extra ")]),_vm._v(" "),(_vm.tiempo_extra.emp_falto)?_c('div',[_c('strong',[_vm._v("Faltó: ")]),_vm._v(" "+_vm._s(_vm.tiempo_extra.emp_falto))]):_c('div',[_c('strong',[_vm._v("Faltó: ")]),_vm._v(" VACANTE")]),_vm._v(" "),_c('strong',[_vm._v("Cubrió: ")]),_vm._v(" "+_vm._s(_vm.tiempo_extra.emp_asignado)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Fecha de inasistencia: ")]),_vm._v(" "+_vm._s(_vm.moment(_vm.tiempo_extra.fecha_asi,'YYYY-MM-DD h:mm:ss').format('YYYY-MM-DD h:mm A'))),_c('br'),_vm._v(" "),(_vm.tiempo_extra.tipo_asd === 'asistio')?_c('div',[_c('strong',[_vm._v("Tipo de falta: ")]),_vm._v(" Asistencia ")]):_vm._e(),_vm._v(" "),(_vm.tiempo_extra.tipo_asd === 'falta_just_pnh')?_c('div',[_c('strong',[_vm._v("Tipo de falta: ")]),_vm._v(" FALTA JUSTIFICADA ")]):_vm._e(),_vm._v(" "),(_vm.tiempo_extra.tipo_asd === 'falta_injust_pnh')?_c('div',[_c('strong',[_vm._v("Tipo de falta: ")]),_vm._v(" FALTA INJUSTIFICADA ")]):_vm._e(),_vm._v(" "),(_vm.tiempo_extra.tipo_asd === 'permiso_pnh')?_c('div',[_c('strong',[_vm._v("Tipo de falta: ")]),_vm._v(" PERMISO ")]):_vm._e(),_vm._v(" "),(_vm.tiempo_extra.tipo_asd === 'permiso_falle_pnh')?_c('div',[_c('strong',[_vm._v("Tipo de falta: ")]),_vm._v(" PERMISO FALLECIMIENTO ")]):_vm._e(),_vm._v(" "),(_vm.tiempo_extra.tipo_asd === 'permiso_naci_pnh')?_c('div',[_c('strong',[_vm._v("Tipo de falta: ")]),_vm._v(" PERMISO NACIMIENTO ")]):_vm._e(),_vm._v(" "),_c('strong',[_vm._v("Punto: ")]),_vm._v(" "+_vm._s(_vm.tiempo_extra.nombre_pun)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Turno del punto: ")]),_vm._v(" "+_vm._s(_vm.moment(_vm.tiempo_extra.inicio_ptu,'h:mm:ss').format('h:mm A'))+" a "+_vm._s(_vm.moment(_vm.tiempo_extra.termino_ptu,'h:mm:ss').format('h:mm A'))),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Otorgó: ")]),_vm._v(" "+_vm._s(_vm.tiempo_extra.emp_otorga)),_c('br'),_vm._v(" "),_c('md-radio',{attrs:{"id":"vtex1","name":"vtex","md-value":"aceptado"},model:{value:(_vm.estatus_tex),callback:function ($$v) {_vm.estatus_tex=$$v},expression:"estatus_tex"}},[_vm._v("Aprobado")]),_vm._v(" "),_c('md-radio',{staticClass:"md-warn",attrs:{"id":"vtex2","name":"vtex","md-value":"negado"},model:{value:(_vm.estatus_tex),callback:function ($$v) {_vm.estatus_tex=$$v},expression:"estatus_tex"}},[_vm._v("No aprobado")]),_vm._v(" "),(_vm.estatus_tex==='negado')?_c('div',[_c('md-input-container',[_c('label',[_vm._v("Observaciones")]),_vm._v(" "),_c('md-textarea',{model:{value:(_vm.observaciones_tex),callback:function ($$v) {_vm.observaciones_tex=$$v},expression:"observaciones_tex"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModal('modalTiempoExtraPorValidar')}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised",nativeOn:{"click":function($event){_vm.guardarValidaxionTiempoExtra()}}},[_vm._v("Guardar validación")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fdas":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net__ = __webpack_require__("FNwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'IncidenciasListado',
	methods: {
		obtenerIncidencias: function obtenerIncidencias() {
			var _this = this;

			this.$http.post('incidencias', {
				'token': this.$session.get('token'),
				estatus: 'pendientes'
			}).then(function (response) {
				if (response.status === 200 && 'incidencias' in response.body) {
					_this.incidencias = response.body.incidencias;
				}
			}, function (response) {
				__WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
					text: 'No se pudo establecer conexión con el servidor al obtener las incidencias.',
					actionText: 'Cerrar',
					pos: 'top-right',
					showAction: false,
					backgroundColor: '#F44336',
					actionTextColor: '#FFF'
				});
			});
		}
	},
	beforeCreate: function beforeCreate() {
		if (!this.$session.exists()) {
			this.$router.push('/login');
		}
	},
	created: function created() {
		this.obtenerIncidencias();
	},
	updated: function updated() {
		this.tabla = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.md-table table').DataTable();
	},
	data: function data() {
		return {
			msg: 'IncidenciasListado',
			incidencias: [],
			tabla: null
		};
	}
});

/***/ }),

/***/ "Fx8z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AsistenciasValidarTiemposExtra",
  methods: {
    moment: function moment(a, b) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(a, b);
    },
    obtenerTiemposExtraPorValidar: function obtenerTiemposExtraPorValidar() {
      var _this = this;

      this.$http.post("tiemposextra/pendientes", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "tiemposextra" in response.body) {
          _this.tiemposextra = response.body.tiemposextra;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    abrirModalValidarTiempoExtra: function abrirModalValidarTiempoExtra(tex) {
      this.tiempo_extra = tex;
      this.abrirModal("modalTiempoExtraPorValidar");
    },
    guardarValidaxionTiempoExtra: function guardarValidaxionTiempoExtra() {
      var _this2 = this;

      if (this.validarTEX()) {
        this.$http.post("tiemposextra/validar", {
          token: this.$session.get("token"),
          data: {
            id_tex: this.tiempo_extra.id_tex,
            estatus_tex: this.estatus_tex,
            obs_estatus_tex: this.observaciones_tex
          }
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
          _this2.tiempo_extra.id_tex = null;
          _this2.tiempo_extra.fecha_tex = null;
          _this2.tiempo_extra.id_emn_falto = null;
          _this2.tiempo_extra.emp_falto = null;
          _this2.tiempo_extra.emp_asignado = null;
          _this2.tiempo_extra.emp_otorga = null;
          _this2.tiempo_extra.emp_valida = null;
          _this2.tiempo_extra.estatus_tex = null;
          _this2.tiempo_extra.obs_estatus_tex = null;
          _this2.tiempo_extra.tipo_asd = null;
          _this2.tiempo_extra.fecha_asi = null;
          _this2.tiempo_extra.nombre_pun = null;
          _this2.tiempo_extra.inicio_ptu = null;
          _this2.tiempo_extra.termino_ptu = null;
          _this2.estatus_tex = null;
          _this2.tiemposextra = null;
          _this2.obtenerTiemposExtraPorValidar();
          _this2.cerrarModal("modalTiempoExtraPorValidar");
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      }
    },
    validarTEX: function validarTEX() {
      if (!this.estatus_tex) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Por favor seleccione una opción de validación.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    },
    abrirModal: function abrirModal(ref) {
      this.$refs[ref].open();
    },
    cerrarModal: function cerrarModal(ref) {
      this.$refs[ref].close();
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created: function created() {
    this.obtenerTiemposExtraPorValidar();
  },
  data: function data() {
    return {
      msg: "AsistenciasValidarTiemposExtra",
      tiemposextra: [],
      tiempo_extra: {
        id_tex: null,
        fecha_tex: null,
        id_emn_falto: null,
        emp_falto: null,
        emp_asignado: null,
        emp_otorga: null,
        emp_valida: null,
        estatus_tex: null,
        obs_estatus_tex: null,
        tipo_asd: null,
        fecha_asi: null,
        nombre_pun: null,
        inicio_ptu: null,
        termino_ptu: null
      },
      estatus_tex: null,
      observaciones_tex: null
    };
  }
});

/***/ }),

/***/ "GPGV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConceptosListado_vue__ = __webpack_require__("p1l0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37dd5362_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ConceptosListado_vue__ = __webpack_require__("SOkO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConceptosListado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37dd5362_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ConceptosListado_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HNY1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominaResumen_vue__ = __webpack_require__("qUo6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6faa9f8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NominaResumen_vue__ = __webpack_require__("ugFE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominaResumen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6faa9f8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NominaResumen_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IZr/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AsistenciasPuntos"},[_c('md-layout',{attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"80","md-flex-large":"60","md-flex-xlarge":"40"}},[_c('md-table-card',{staticClass:"w-100"},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("\n            Seleccione el turno al que desea tomar asistencia\n          ")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Punto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Turno")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.turnos),function(turno){return _c('md-table-row',{key:turno.id_ptu},[_c('md-table-cell',[_vm._v(_vm._s(turno.nombre_pun))]),_vm._v(" "),_c('md-table-cell',[_vm._v("\n                "+_vm._s(_vm.moment(turno.inicio_ptu,'h:mm:ss').format('h:mm A'))+" - "+_vm._s(_vm.moment(turno.termino_ptu,'h:mm:ss').format('h:mm A'))+"\n              ")]),_vm._v(" "),_c('md-table-cell',[_c('md-button',{staticClass:"md-raised md-accent",staticStyle:{"width":"auto"},nativeOn:{"click":function($event){_vm.irAPaseDeListaDelTurno(turno.id_ptu)}}},[_vm._v("Pasar lista")])],1)],1)}))],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J1pZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanesEditar_vue__ = __webpack_require__("mAfs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0864bc9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlanesEditar_vue__ = __webpack_require__("Kvi2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanesEditar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0864bc9d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlanesEditar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JPfg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EditarCliente"},[_c('md-layout',{attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"90","md-flex-large":"80","md-flex-xlarge":"70"}},[_c('md-card',{staticClass:"w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Editar cliente")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-align":"center","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"70","md-flex-medium":"70","md-flex-large":"70","md-flex-xlarge":"70"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nombre }},[_c('label',[_vm._v("Razón social")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.cliente.nombre),callback:function ($$v) {_vm.cliente.nombre=$$v},expression:"cliente.nombre"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"30","md-flex-medium":"30","md-flex-large":"30","md-flex-xlarge":"30"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_cuenta }},[_c('label',[_vm._v("Cuenta")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.cliente.cuenta),callback:function ($$v) {_vm.cliente.cuenta=$$v},expression:"cliente.cuenta"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"33","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',[_c('label',[_vm._v("R.F.C.")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.rfc),callback:function ($$v) {_vm.cliente.rfc=$$v},expression:"cliente.rfc"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"33","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('md-input',{attrs:{"type":"email"},model:{value:(_vm.cliente.email),callback:function ($$v) {_vm.cliente.email=$$v},expression:"cliente.email"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"33","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',[_c('label',[_vm._v("Teléfono")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-#####'),expression:"'(###) ###-#####'"}],model:{value:(_vm.cliente.telefono),callback:function ($$v) {_vm.cliente.telefono=$$v},expression:"cliente.telefono"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"70","md-flex-medium":"35","md-flex-large":"35","md-flex-xlarge":"35"}},[_c('md-input-container',[_c('label',[_vm._v("Calle")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.calle),callback:function ($$v) {_vm.cliente.calle=$$v},expression:"cliente.calle"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"30","md-flex-medium":"15","md-flex-large":"15","md-flex-xlarge":"15"}},[_c('md-input-container',[_c('label',[_vm._v("# ext")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.numero),callback:function ($$v) {_vm.cliente.numero=$$v},expression:"cliente.numero"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"70","md-flex-medium":"35","md-flex-large":"35","md-flex-xlarge":"35"}},[_c('md-input-container',[_c('label',[_vm._v("Colonia")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.colonia),callback:function ($$v) {_vm.cliente.colonia=$$v},expression:"cliente.colonia"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"30","md-flex-medium":"15","md-flex-large":"15","md-flex-xlarge":"15"}},[_c('md-input-container',[_c('label',[_vm._v("C. P.")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.codigo_postal),callback:function ($$v) {_vm.cliente.codigo_postal=$$v},expression:"cliente.codigo_postal"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"40","md-flex-medium":"40","md-flex-large":"40","md-flex-xlarge":"40"}},[_c('md-input-container',[_c('label',[_vm._v("Municipio")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.municipio),callback:function ($$v) {_vm.cliente.municipio=$$v},expression:"cliente.municipio"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"40","md-flex-medium":"40","md-flex-large":"40","md-flex-xlarge":"40"}},[_c('md-input-container',[_c('label',[_vm._v("Estado")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.estado),callback:function ($$v) {_vm.cliente.estado=$$v},expression:"cliente.estado"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"20","md-flex-small":"20","md-flex-medium":"20","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',[_c('label',{attrs:{"for":"ruta"}},[_vm._v("Ruta")]),_vm._v(" "),_c('md-select',{attrs:{"name":"ruta","id":"ruta"},model:{value:(_vm.cliente.ruta),callback:function ($$v) {_vm.cliente.ruta=$$v},expression:"cliente.ruta"}},[_c('md-option',{attrs:{"value":"centro"}},[_vm._v("Centro")]),_vm._v(" "),_c('md-option',{attrs:{"value":"norte"}},[_vm._v("Norte")]),_vm._v(" "),_c('md-option',{attrs:{"value":"sur"}},[_vm._v("Sur")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"100","md-flex-xlarge":"100"}},[_c('md-input-container',[_c('md-icon',[_vm._v("edit")]),_vm._v(" "),_c('label',[_vm._v("Notas")]),_vm._v(" "),_c('md-textarea',{model:{value:(_vm.cliente.notas),callback:function ($$v) {_vm.cliente.notas=$$v},expression:"cliente.notas"}})],1)],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('router-link',{attrs:{"tag":"md-button","to":"/clientes"}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.actualizarCliente()}}},[_vm._v("Actualizar cliente")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "K3oT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ContratosNuevo"},[_c('md-layout',{staticClass:"m-t-24",attrs:{"md-gutter":"24","md-align":"center","md-flex":"100"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"30","md-flex-xlarge":"20"}},[(_vm.contrato.tipo_cnt === 'laboral_guardia' || _vm.contrato.tipo_cnt === null)?_c('div',[_vm._v("\n        Para que el sistema automáticamente llene el contrato con la información del empleado deberá de poner entre una llaves { } los siguientes campos:\n        "),_c('ul',[_c('li',[_vm._v("nombre_empleado")]),_vm._v(" "),_c('li',[_vm._v("ape_paterno_empleado")]),_vm._v(" "),_c('li',[_vm._v("ape_materno_empleado")]),_vm._v(" "),_c('li',[_vm._v("fecha_nacimiento_empleado")]),_vm._v(" "),_c('li',[_vm._v("domicilio_empleado")])])]):_vm._e(),_vm._v(" "),(_vm.contrato.tipo_cnt === 'servicios_monitoreo' || _vm.contrato.tipo_cnt === 'servicios_guardias')?_c('div',[_vm._v("\n        Para que el sistema automáticamente llene el contrato con la información de la empresa deberá de poner entre una llaves { } los siguientes campos:\n        "),_c('ul',[_c('li',[_vm._v("razon_social_cliente")]),_vm._v(" "),_c('li',[_vm._v("rfc_cliente")]),_vm._v(" "),_c('li',[_vm._v("email_cliente")]),_vm._v(" "),_c('li',[_vm._v("telefono_cliente")]),_vm._v(" "),_c('li',[_vm._v("domicilio_cliente")])])]):_vm._e()]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"70","md-flex-xlarge":"70"}},[_c('md-card',{staticClass:"w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Nuevo contrato")])]),_vm._v(" "),_c('md-card-content'),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-gutter":"24","md-align":"center","md-flex":"100"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"50","md-flex-large":"60","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_titulo }},[_c('label',[_vm._v("Nombre del contrato")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.contrato.titulo_cnt),callback:function ($$v) {_vm.contrato.titulo_cnt=$$v},expression:"contrato.titulo_cnt"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tipo }},[_c('label',{attrs:{"for":"tipo_cnt"}},[_vm._v("Tipo")]),_vm._v(" "),_c('md-select',{attrs:{"name":"tipo_cnt","id":"tipo_cnt","required":""},model:{value:(_vm.contrato.tipo_cnt),callback:function ($$v) {_vm.contrato.tipo_cnt=$$v},expression:"contrato.tipo_cnt"}},[_c('md-option',{attrs:{"value":"laboral_guardia"}},[_vm._v("Contrato laboral guardia")]),_vm._v(" "),_c('md-option',{attrs:{"value":"servicios_monitoreo"}},[_vm._v("Prestación servicios monitoreo")]),_vm._v(" "),_c('md-option',{attrs:{"value":"servicios_guardias"}},[_vm._v("Prestación servicios guardias")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_duracion }},[_c('label',{attrs:{"for":"duracion_cnt"}},[_vm._v("Duración")]),_vm._v(" "),_c('md-select',{attrs:{"name":"duracion_cnt","id":"duracion_cnt","required":""},model:{value:(_vm.contrato.duracion_cnt),callback:function ($$v) {_vm.contrato.duracion_cnt=$$v},expression:"contrato.duracion_cnt"}},[_c('md-option',{attrs:{"value":"indeterminado"}},[_vm._v("Indeterminado")]),_vm._v(" "),_c('md-option',{attrs:{"value":"1"}},[_vm._v("1 mes")]),_vm._v(" "),_c('md-option',{attrs:{"value":"2"}},[_vm._v("2 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3"}},[_vm._v("3 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4"}},[_vm._v("4 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5"}},[_vm._v("5 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6"}},[_vm._v("6 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7"}},[_vm._v("7 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8"}},[_vm._v("8 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9"}},[_vm._v("9 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10"}},[_vm._v("10 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11"}},[_vm._v("11 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12"}},[_vm._v("12 meses")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-large":"100","md-flex-xlarge":"100"}},[_c('wysiwyg',{staticStyle:{"background":"white!important"},model:{value:(_vm.contrato.contenido_cnt),callback:function ($$v) {_vm.contrato.contenido_cnt=$$v},expression:"contrato.contenido_cnt"}})],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('router-link',{attrs:{"tag":"md-button","to":"/contratos"}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.guardarContrato()}}},[_vm._v("Guardar")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KHUK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmpleadosDetalle_vue__ = __webpack_require__("l24A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37b9e393_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmpleadosDetalle_vue__ = __webpack_require__("UV8U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmpleadosDetalle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37b9e393_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmpleadosDetalle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.0","/Applications/MAMP/htdocs/victor/nomina"]],"_development":true,"_from":"elliptic@6.4.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.0","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.0","saveSpec":null,"fetchSpec":"6.4.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_spec":"6.4.0","_where":"/Applications/MAMP/htdocs/victor/nomina","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),

/***/ "KqSD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmpleadosNuevo_vue__ = __webpack_require__("yZBI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6371ec5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmpleadosNuevo_vue__ = __webpack_require__("g+xY");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmpleadosNuevo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6371ec5a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmpleadosNuevo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kvi2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PlanesNuevo"},[_c('md-layout',{attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"90","md-flex-large":"70","md-flex-xlarge":"60"}},[_c('md-card',{staticClass:"w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Editar plan de pago")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-column":"","md-flex":"100"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nombre }},[_c('label',[_vm._v("Nombre del plan")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.plan.nombre_pln),callback:function ($$v) {_vm.plan.nombre_pln=$$v},expression:"plan.nombre_pln"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_salario_qnal }},[_c('label',[_vm._v("Salario semanal")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.salario_qnal_pnh),callback:function ($$v) {_vm.plan.salario_qnal_pnh=$$v},expression:"plan.salario_qnal_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_falta_just }},[_c('label',[_vm._v("Falta justificada")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.falta_just_pnh),callback:function ($$v) {_vm.plan.falta_just_pnh=$$v},expression:"plan.falta_just_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_falta_injust }},[_c('label',[_vm._v("Falta injustificada")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.falta_injust_pnh),callback:function ($$v) {_vm.plan.falta_injust_pnh=$$v},expression:"plan.falta_injust_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_permiso }},[_c('label',[_vm._v("Permiso")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.permiso_pnh),callback:function ($$v) {_vm.plan.permiso_pnh=$$v},expression:"plan.permiso_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_permiso_falle }},[_c('label',[_vm._v("Permiso fallecimiento")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.permiso_falle_pnh),callback:function ($$v) {_vm.plan.permiso_falle_pnh=$$v},expression:"plan.permiso_falle_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_permiso_naci }},[_c('label',[_vm._v("Permiso nacimiento")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.permiso_naci_pnh),callback:function ($$v) {_vm.plan.permiso_naci_pnh=$$v},expression:"plan.permiso_naci_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_hora_tie_ext }},[_c('label',[_vm._v("Hora de tiempo extra")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.hora_tie_ext_pnh),callback:function ($$v) {_vm.plan.hora_tie_ext_pnh=$$v},expression:"plan.hora_tie_ext_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tie_ext }},[_c('label',[_vm._v("Tiempo extra")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.tie_ext_pnh),callback:function ($$v) {_vm.plan.tie_ext_pnh=$$v},expression:"plan.tie_ext_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_doble_turno }},[_c('label',[_vm._v("Doble turno")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.doble_turno_pnh),callback:function ($$v) {_vm.plan.doble_turno_pnh=$$v},expression:"plan.doble_turno_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_dia_festivo }},[_c('label',[_vm._v("Día festivo")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.dia_festivo_pnh),callback:function ($$v) {_vm.plan.dia_festivo_pnh=$$v},expression:"plan.dia_festivo_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_dia_tresuno }},[_c('label',[_vm._v("Día 28")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.dia_tresuno_pnh),callback:function ($$v) {_vm.plan.dia_tresuno_pnh=$$v},expression:"plan.dia_tresuno_pnh"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_dia_dosocho }},[_c('label',[_vm._v("Día 31")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.plan.dia_dosocho_pnh),callback:function ($$v) {_vm.plan.dia_dosocho_pnh=$$v},expression:"plan.dia_dosocho_pnh"}})],1)],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.regresarAPlanes()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised",nativeOn:{"click":function($event){_vm.actualizarPlan()}}},[_vm._v("Guardar cambios")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L4t1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EmpleadosNuevo"},[_c('h1',[_vm._v("Editar empleado")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24","md-align":"center"}},[_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"50","md-flex-large":"45","md-flex-xlarge":"40"}},[_c('md-card',{staticClass:"m-b-24"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Información general del empleado")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nombre }},[_c('label',[_vm._v("Nombre")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.nombre_emn),callback:function ($$v) {_vm.empleado.nombre_emn=$$v},expression:"empleado.nombre_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_ap_pat }},[_c('label',[_vm._v("Ap. paterno")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.ap_pat_emn),callback:function ($$v) {_vm.empleado.ap_pat_emn=$$v},expression:"empleado.ap_pat_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_ap_mat }},[_c('label',[_vm._v("Ap. materno")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.ap_mat_emn),callback:function ($$v) {_vm.empleado.ap_mat_emn=$$v},expression:"empleado.ap_mat_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_fecha_nac }},[_c('label',[_vm._v("Formato día/mes/año")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],attrs:{"placeholder":"Fecha de nacimiento","required":""},model:{value:(_vm.empleado.fecha_nac_emn),callback:function ($$v) {_vm.empleado.fecha_nac_emn=$$v},expression:"empleado.fecha_nac_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_sexo }},[_c('label',{attrs:{"for":"sexo_emn"}},[_vm._v("Sexo")]),_vm._v(" "),_c('md-select',{attrs:{"name":"sexo_emn","id":"sexo_emn","required":""},model:{value:(_vm.empleado.sexo_emn),callback:function ($$v) {_vm.empleado.sexo_emn=$$v},expression:"empleado.sexo_emn"}},[_c('md-option',{attrs:{"value":"masculino"}},[_vm._v("Masculino")]),_vm._v(" "),_c('md-option',{attrs:{"value":"femenino"}},[_vm._v("Femenino")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_estado_civil }},[_c('label',{attrs:{"for":"estado_civil_emn"}},[_vm._v("Estado civíl")]),_vm._v(" "),_c('md-select',{attrs:{"name":"estado_civil_emn","id":"estado_civil_emn"},model:{value:(_vm.empleado.estado_civil_emn),callback:function ($$v) {_vm.empleado.estado_civil_emn=$$v},expression:"empleado.estado_civil_emn"}},[_c('md-option',{attrs:{"value":"soltero"}},[_vm._v("Soltero")]),_vm._v(" "),_c('md-option',{attrs:{"value":"casado"}},[_vm._v("Casado")]),_vm._v(" "),_c('md-option',{attrs:{"value":"divorciado"}},[_vm._v("Divorciado")]),_vm._v(" "),_c('md-option',{attrs:{"value":"unión libre"}},[_vm._v("Unión libre")]),_vm._v(" "),_c('md-option',{attrs:{"value":"viudo"}},[_vm._v("Viudo")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"80","md-flex-medium":"80","md-flex-large":"80","md-flex-xlarge":"80"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_direccion }},[_c('label',[_vm._v("Dirección")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.direccion_emn),callback:function ($$v) {_vm.empleado.direccion_emn=$$v},expression:"empleado.direccion_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"20","md-flex-medium":"20","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_num_ext }},[_c('label',[_vm._v("# ext.")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.num_ext_emn),callback:function ($$v) {_vm.empleado.num_ext_emn=$$v},expression:"empleado.num_ext_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"80","md-flex-medium":"80","md-flex-large":"80","md-flex-xlarge":"80"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_colonia }},[_c('label',[_vm._v("Colonia")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.colonia_emn),callback:function ($$v) {_vm.empleado.colonia_emn=$$v},expression:"empleado.colonia_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"20","md-flex-medium":"20","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_codigo_postal }},[_c('label',[_vm._v("C.P.")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.codigo_postal_emn),callback:function ($$v) {_vm.empleado.codigo_postal_emn=$$v},expression:"empleado.codigo_postal_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_municipio }},[_c('label',[_vm._v("Municipio")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.municipio_emn),callback:function ($$v) {_vm.empleado.municipio_emn=$$v},expression:"empleado.municipio_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_estado }},[_c('label',[_vm._v("Estado")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.estado_emn),callback:function ($$v) {_vm.empleado.estado_emn=$$v},expression:"empleado.estado_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"33","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tel }},[_c('label',[_vm._v("Teléfono")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],attrs:{"required":""},model:{value:(_vm.empleado.tel_emn),callback:function ($$v) {_vm.empleado.tel_emn=$$v},expression:"empleado.tel_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"33","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_cel }},[_c('label',[_vm._v("Celular")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],model:{value:(_vm.empleado.cel_emn),callback:function ($$v) {_vm.empleado.cel_emn=$$v},expression:"empleado.cel_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"33","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_email }},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.email_emn),callback:function ($$v) {_vm.empleado.email_emn=$$v},expression:"empleado.email_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"22"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_escolaridad }},[_c('label'),_vm._v(" "),_c('label',{attrs:{"for":"escolaridad_emn"}},[_vm._v("Escolaridad")]),_vm._v(" "),_c('md-select',{attrs:{"name":"escolaridad_emn","id":"escolaridad_emn"},model:{value:(_vm.empleado.escolaridad_emn),callback:function ($$v) {_vm.empleado.escolaridad_emn=$$v},expression:"empleado.escolaridad_emn"}},[_c('md-option',{attrs:{"value":"primaria"}},[_vm._v("Primaria")]),_vm._v(" "),_c('md-option',{attrs:{"value":"secundaria"}},[_vm._v("Secundaria")]),_vm._v(" "),_c('md-option',{attrs:{"value":"preparatoria"}},[_vm._v("Preparatoria")]),_vm._v(" "),_c('md-option',{attrs:{"value":"licenciatura"}},[_vm._v("Licenciatura")]),_vm._v(" "),_c('md-option',{attrs:{"value":"otro"}},[_vm._v("Otro")])],1)],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nss }},[_c('label',[_vm._v("NSS")]),_vm._v(" "),_c('md-input',{attrs:{"maxlength":"11"},model:{value:(_vm.empleado.nss_emn),callback:function ($$v) {_vm.empleado.nss_emn=$$v},expression:"empleado.nss_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_curp }},[_c('label',[_vm._v("CURP")]),_vm._v(" "),_c('md-input',{attrs:{"maxlength":"18","required":""},model:{value:(_vm.empleado.curp_emn),callback:function ($$v) {_vm.empleado.curp_emn=$$v},expression:"empleado.curp_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_rfc }},[_c('label',[_vm._v("RFC")]),_vm._v(" "),_c('md-input',{attrs:{"maxlength":"13"},model:{value:(_vm.empleado.rfc_emn),callback:function ($$v) {_vm.empleado.rfc_emn=$$v},expression:"empleado.rfc_emn"}})],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_peso }},[_c('label',[_vm._v("Peso KGS")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","placeholder":"Peso"},model:{value:(_vm.empleado.peso_emn),callback:function ($$v) {_vm.empleado.peso_emn=$$v},expression:"empleado.peso_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_estatura }},[_c('label',[_vm._v("Estatura MTS")]),_vm._v(" "),_c('md-input',{attrs:{"placeholder":"Estatura","type":"number","step":".01"},model:{value:(_vm.empleado.estatura_emn),callback:function ($$v) {_vm.empleado.estatura_emn=$$v},expression:"empleado.estatura_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_camisa }},[_c('label',[_vm._v("Camisa")]),_vm._v(" "),_c('md-select',{attrs:{"name":"camisa_emn","id":"camisa_emn"},model:{value:(_vm.empleado.camisa_emn),callback:function ($$v) {_vm.empleado.camisa_emn=$$v},expression:"empleado.camisa_emn"}},[_c('md-option',{attrs:{"value":"32"}},[_vm._v("32")]),_vm._v(" "),_c('md-option',{attrs:{"value":"34"}},[_vm._v("34")]),_vm._v(" "),_c('md-option',{attrs:{"value":"36"}},[_vm._v("36")]),_vm._v(" "),_c('md-option',{attrs:{"value":"38"}},[_vm._v("38")]),_vm._v(" "),_c('md-option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('md-option',{attrs:{"value":"42"}},[_vm._v("42")]),_vm._v(" "),_c('md-option',{attrs:{"value":"44"}},[_vm._v("44")]),_vm._v(" "),_c('md-option',{attrs:{"value":"46"}},[_vm._v("46")]),_vm._v(" "),_c('md-option',{attrs:{"value":"48"}},[_vm._v("48")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_pantalon }},[_c('label',[_vm._v("Pantalón")]),_vm._v(" "),_c('md-select',{attrs:{"name":"pantalon_emn","id":"pantalon_emn"},model:{value:(_vm.empleado.pantalon_emn),callback:function ($$v) {_vm.empleado.pantalon_emn=$$v},expression:"empleado.pantalon_emn"}},[_c('md-option',{attrs:{"value":"28"}},[_vm._v("28")]),_vm._v(" "),_c('md-option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('md-option',{attrs:{"value":"32"}},[_vm._v("32")]),_vm._v(" "),_c('md-option',{attrs:{"value":"34"}},[_vm._v("34")]),_vm._v(" "),_c('md-option',{attrs:{"value":"36"}},[_vm._v("36")]),_vm._v(" "),_c('md-option',{attrs:{"value":"38"}},[_vm._v("38")]),_vm._v(" "),_c('md-option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('md-option',{attrs:{"value":"42"}},[_vm._v("42")]),_vm._v(" "),_c('md-option',{attrs:{"value":"44"}},[_vm._v("44")]),_vm._v(" "),_c('md-option',{attrs:{"value":"46"}},[_vm._v("46")]),_vm._v(" "),_c('md-option',{attrs:{"value":"48"}},[_vm._v("48")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_calzado }},[_c('label',[_vm._v("Calzado")]),_vm._v(" "),_c('md-select',{attrs:{"name":"calzado_emn","id":"calzado_emn"},model:{value:(_vm.empleado.calzado_emn),callback:function ($$v) {_vm.empleado.calzado_emn=$$v},expression:"empleado.calzado_emn"}},[_c('md-option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('md-option',{attrs:{"value":"2.5"}},[_vm._v("2.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3.5"}},[_vm._v("3.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4.5"}},[_vm._v("4.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5.5"}},[_vm._v("5.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6"}},[_vm._v("6")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6.5"}},[_vm._v("6.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7"}},[_vm._v("7")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7.5"}},[_vm._v("7.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8"}},[_vm._v("8")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8.5"}},[_vm._v("8.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9"}},[_vm._v("9")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9.5"}},[_vm._v("9.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10.5"}},[_vm._v("10.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11"}},[_vm._v("11")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11.5"}},[_vm._v("11.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12"}},[_vm._v("12")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12.5"}},[_vm._v("12.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"13"}},[_vm._v("13")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_complexion }},[_c('label',[_vm._v("Complexión")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.complexion_emn),callback:function ($$v) {_vm.empleado.complexion_emn=$$v},expression:"empleado.complexion_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_ojos }},[_c('label',[_vm._v("Ojos")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.ojos_emn),callback:function ($$v) {_vm.empleado.ojos_emn=$$v},expression:"empleado.ojos_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_piel }},[_c('label',[_vm._v("Piel")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.piel_emn),callback:function ($$v) {_vm.empleado.piel_emn=$$v},expression:"empleado.piel_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_cabello }},[_c('label',[_vm._v("Cabello")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.cabello_emn),callback:function ($$v) {_vm.empleado.cabello_emn=$$v},expression:"empleado.cabello_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tipo_sangre }},[_c('label',[_vm._v("Sangre")]),_vm._v(" "),_c('md-select',{attrs:{"name":"tipo_sangre_emn","id":"tipo_sangre_emn"},model:{value:(_vm.empleado.tipo_sangre_emn),callback:function ($$v) {_vm.empleado.tipo_sangre_emn=$$v},expression:"empleado.tipo_sangre_emn"}},[_c('md-option',{attrs:{"value":"A−"}},[_vm._v("A−")]),_vm._v(" "),_c('md-option',{attrs:{"value":"A+"}},[_vm._v("A+")]),_vm._v(" "),_c('md-option',{attrs:{"value":"B−"}},[_vm._v("B−")]),_vm._v(" "),_c('md-option',{attrs:{"value":"B+"}},[_vm._v("B+")]),_vm._v(" "),_c('md-option',{attrs:{"value":"AB−"}},[_vm._v("AB−")]),_vm._v(" "),_c('md-option',{attrs:{"value":"AB+"}},[_vm._v("AB+")]),_vm._v(" "),_c('md-option',{attrs:{"value":"O-"}},[_vm._v("O-")]),_vm._v(" "),_c('md-option',{attrs:{"value":"O+"}},[_vm._v("O+")]),_vm._v(" "),_c('md-option',{attrs:{"value":"otro"}},[_vm._v("NO SABE")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"75","md-flex-small":"75","md-flex-medium":"75","md-flex-large":"75","md-flex-xlarge":"75"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_experiencia }},[_c('label',[_vm._v("Experiencia")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.experiencia_emn),callback:function ($$v) {_vm.empleado.experiencia_emn=$$v},expression:"empleado.experiencia_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"25","md-flex-small":"25","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_anos_exp }},[_c('label',[_vm._v("Años experiencia")]),_vm._v(" "),_c('md-input',{attrs:{"placeholder":"Años exp."},model:{value:(_vm.empleado.anos_exp_emn),callback:function ($$v) {_vm.empleado.anos_exp_emn=$$v},expression:"empleado.anos_exp_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"100","md-flex-xlarge":"100"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_observaciones }},[_c('label',[_vm._v("Observaciones")]),_vm._v(" "),_c('md-textarea',{model:{value:(_vm.empleado.observaciones_emn),callback:function ($$v) {_vm.empleado.observaciones_emn=$$v},expression:"empleado.observaciones_emn"}})],1)],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('router-link',{attrs:{"tag":"md-button","to":"/empleados"}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.actualizarEmpleado()}}},[_vm._v("Guardar cambios")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"50","md-flex-large":"45","md-flex-xlarge":"40"}},[_c('md-card',[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Información familiar y de contacto")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nombre_conyuge }},[_c('label',[_vm._v("Nombre del cónyuge")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.nombre_conyuge_emn),callback:function ($$v) {_vm.empleado.nombre_conyuge_emn=$$v},expression:"empleado.nombre_conyuge_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tel_conyuge }},[_c('label',[_vm._v("Teléfono del cónyuge")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],model:{value:(_vm.empleado.tel_conyuge_emn),callback:function ($$v) {_vm.empleado.tel_conyuge_emn=$$v},expression:"empleado.tel_conyuge_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_hijos }},[_c('label',[_vm._v("Hijos")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","steps":"1"},model:{value:(_vm.empleado.hijos_emn),callback:function ($$v) {_vm.empleado.hijos_emn=$$v},expression:"empleado.hijos_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_dependientes }},[_c('label',[_vm._v("Dependientes")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","steps":"1"},model:{value:(_vm.empleado.dependientes_emn),callback:function ($$v) {_vm.empleado.dependientes_emn=$$v},expression:"empleado.dependientes_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"100","md-flex-xlarge":"100"}},[_c('md-button',{staticClass:"md-raised md-accent",nativeOn:{"click":function($event){_vm.conyugueCopiarAContacto()}}},[_vm._v("\n\t\t\t\t\t\t\t\tUsar información de cónyugue como contacto\n\t\t\t\t\t\t\t")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"70","md-flex-medium":"70","md-flex-large":"70","md-flex-xlarge":"70"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_persona_contacto }},[_c('label',[_vm._v("Persona de contacto")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.persona_contacto_emn),callback:function ($$v) {_vm.empleado.persona_contacto_emn=$$v},expression:"empleado.persona_contacto_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"30","md-flex-medium":"30","md-flex-large":"30","md-flex-xlarge":"30"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tel_contacto }},[_c('label',[_vm._v("Tel. contacto")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],attrs:{"required":""},model:{value:(_vm.empleado.tel_contacto_emn),callback:function ($$v) {_vm.empleado.tel_contacto_emn=$$v},expression:"empleado.tel_contacto_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"75","md-flex-small":"75","md-flex-medium":"75","md-flex-large":"75","md-flex-xlarge":"75"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_direccion_contacto }},[_c('label',[_vm._v("Dirección de contacto")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.direccion_contacto_emn),callback:function ($$v) {_vm.empleado.direccion_contacto_emn=$$v},expression:"empleado.direccion_contacto_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"25","md-flex-small":"25","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_num_contacto }},[_c('label',[_vm._v("# ext")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.num_contacto_emn),callback:function ($$v) {_vm.empleado.num_contacto_emn=$$v},expression:"empleado.num_contacto_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"75","md-flex-medium":"75","md-flex-large":"75","md-flex-xlarge":"75"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_colonia_contacto }},[_c('label',[_vm._v("Colonia de contacto")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.colonia_contacto_emn),callback:function ($$v) {_vm.empleado.colonia_contacto_emn=$$v},expression:"empleado.colonia_contacto_emn"}})],1)],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('router-link',{attrs:{"tag":"md-button","to":"/empleados"}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.actualizarEmpleado()}}},[_vm._v("Guardar cambios")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LAue":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdelantosNominaSupervisor_vue__ = __webpack_require__("gbz0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ee7f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AdelantosNominaSupervisor_vue__ = __webpack_require__("Wc7H");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdelantosNominaSupervisor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58ee7f5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AdelantosNominaSupervisor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LGdy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConceptosNuevo',
  methods: {
    guardarConcepto: function guardarConcepto() {
      var _this = this;

      if (this.validarCamposConcepto()) {
        this.$http.post('conceptos/guardar', {
          data: this.concepto,
          token: this.$session.get('token')
        }).then(function (response) {
          if (response.status === 200 && 'msg' in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: 'Bienvenido ' + response.body.msg,
              actionText: 'Cerrar',
              pos: 'top-right',
              showAction: false
            });
            _this.$router.push('/conceptos');
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: 'Cerrar',
              showAction: false,
              pos: 'top-right',
              backgroundColor: '#F44336',
              actionTextColor: '#FFF'
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: 'No se pudo establecer conexión con el servidor.',
            actionText: 'Cerrar',
            showAction: false,
            pos: 'top-right',
            backgroundColor: '#F44336',
            actionTextColor: '#FFF'
          });
        });
      }
    },
    validarCamposConcepto: function validarCamposConcepto() {
      !this.concepto.desc_con ? this.val.v_desc = true : this.val.v_desc = false;
      !this.concepto.importe_cnh ? this.val.v_importe = true : this.val.v_importe = false;
      !this.concepto.tipo_con ? this.val.v_tipo = true : this.val.v_tipo = false;
      if (this.val.v_desc || this.val.v_importe || this.val.v_tipo) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: 'Por favor llene todos los campos marcados con *',
          actionText: 'Cerrar',
          showAction: false,
          pos: 'top-right',
          duration: 10000,
          backgroundColor: '#CC3D30',
          actionTextColor: '#FFF'
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push('/login');
    }
  },
  data: function data() {
    return {
      msg: 'Inicio',
      concepto: {
        desc_con: null,
        importe_cnh: null,
        tipo_con: null
      },
      val: {
        v_desc: null,
        v_importe: null,
        v_tipo: null
      }
    };
  }
});

/***/ }),

/***/ "LMGC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AsistenciasTiemposExtra_vue__ = __webpack_require__("Nb+Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32bf2422_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AsistenciasTiemposExtra_vue__ = __webpack_require__("3XSK");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AsistenciasTiemposExtra_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32bf2422_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AsistenciasTiemposExtra_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ff16936_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("tHtd");
function injectStyle (ssrContext) {
  __webpack_require__("jR06")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ff16936_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MFu0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuestosListado_vue__ = __webpack_require__("3U5Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_093486f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuestosListado_vue__ = __webpack_require__("FF/R");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuestosListado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_093486f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuestosListado_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MZaw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AsistenciasValidarTiemposExtra_vue__ = __webpack_require__("Fx8z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a4a7480_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AsistenciasValidarTiemposExtra_vue__ = __webpack_require__("FWho");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AsistenciasValidarTiemposExtra_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a4a7480_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AsistenciasValidarTiemposExtra_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N+BA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidenciasAtendidasListado_vue__ = __webpack_require__("sgaX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d151c81e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IncidenciasAtendidasListado_vue__ = __webpack_require__("XLfn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidenciasAtendidasListado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d151c81e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IncidenciasAtendidasListado_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N5Y+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PlanesListado"},[_c('md-layout',{staticClass:"m-t-24",attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"60","md-flex-xlarge":"40"}},[_c('md-table-card',{staticClass:"w-100"},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Planes de pago registrados")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Plan")]),_vm._v(" "),_c('md-table-head',[_vm._v("Salario qnal")]),_vm._v(" "),_c('md-table-head',[_vm._v("Estatus")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones ")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.planes),function(plan){return _c('md-table-row',{key:plan},[_c('md-table-cell',[_vm._v(_vm._s(plan.nombre_pln))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(plan.salario_qnal_pnh)))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(plan.estatus_pln.toUpperCase()))]),_vm._v(" "),_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.irEditarPlan(plan.plan)}}},[_c('md-icon',[_vm._v("edit")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Editar plan")])],1)],1)],1)}))],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_session__ = __webpack_require__("18Sv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_session___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_session__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material__ = __webpack_require__("Lgyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_mask__ = __webpack_require__("1I9z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_css__ = __webpack_require__("tzNG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_node_snackbar_dist_snackbar_css__ = __webpack_require__("2VY+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_node_snackbar_dist_snackbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_node_snackbar_dist_snackbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_wysiwyg__ = __webpack_require__("V2hT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_wysiwyg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_wysiwyg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_wysiwyg_dist_vueWysiwyg_css__ = __webpack_require__("O5me");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_wysiwyg_dist_vueWysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_wysiwyg_dist_vueWysiwyg_css__);



//Componentes adicionales





//Estilos



//Inicio editor de texto


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_wysiwyg___default.a, {});
//Fin editor de texto

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_session___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_v_mask__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.root = 'http://api.grupoalarcom.mx/';
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.options.emulateJSON = true;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].material.registerTheme('default', {
  primary: {
    color: 'blue',
    hue: 'A200'
  },
  accent: {
    color: 'grey',
    hue: '600'
  },
  warn: 'amber',
  danger: 'red'
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]
  }
});

/***/ }),

/***/ "Nb+Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AsistenciasPuntos",
  methods: {
    moment: function moment(a, b) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(a, b);
    },
    obtenerTiemposExtraPendientes: function obtenerTiemposExtraPendientes() {
      var _this = this;

      this.$http.post("tiemposextra", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "tiemposextra" in response.body) {
          _this.tiemposextra = response.body.tiemposextra;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    buscarEmpleadoCubriraPunto: function buscarEmpleadoCubriraPunto(tex) {
      this.emp_tex = tex;
      this.abrirModal("modalBuscarEmpleado");
    },
    asignarEmpleado: function asignarEmpleado() {
      var _this2 = this;

      if (this.texEmpleado) {
        this.$http.post("tiemposextra/asignar", {
          token: this.$session.get("token"),
          data: {
            asistencia: this.emp_tex.id_asd,
            recibe: this.texEmpleado.id_emn
          }
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
          _this2.obtenerTiemposExtraPendientes();
          _this2.emp_tex.nombre = null;
          _this2.emp_tex.id_emn = null;
          _this2.texEmpleado = null;
          _this2.cerrarModal("modalBuscarEmpleado");
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Seleccione el empleado al que se le asignará el tiempo extra.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      }
    },
    abrirModal: function abrirModal(ref) {
      this.$refs[ref].open();
    },
    cerrarModal: function cerrarModal(ref) {
      this.$refs[ref].close();
    },
    fetchFunction: function fetchFunction(param) {
      return this.$http.post("empleados/buscar", {
        token: this.$session.get("token"),
        query: param.q
      }).then(function (response) {
        return response.body;
      }, function (response) {});
    },
    funcionSelect: function funcionSelect(e) {
      this.texEmpleado = e;
    }
  },
  created: function created() {
    this.obtenerTiemposExtraPendientes();
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data: function data() {
    return {
      msg: "Inicio",
      tiemposextra: null,
      emp_tex: {
        nombre: null,
        id_emn: null
      },
      texEmpleado: null,
      empleado: null,
      autocompleteValue: null
    };
  }
});

/***/ }),

/***/ "O5me":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "QlS8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ClientesNuevo"},[_c('md-layout',{attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"90","md-flex-large":"80","md-flex-xlarge":"70"}},[_c('md-card',{staticClass:"w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Registrar cliente")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-align":"center","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"70","md-flex-medium":"70","md-flex-large":"70","md-flex-xlarge":"70"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nombre }},[_c('label',[_vm._v("Razón social")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.cliente.nombre),callback:function ($$v) {_vm.cliente.nombre=$$v},expression:"cliente.nombre"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"30","md-flex-medium":"30","md-flex-large":"30","md-flex-xlarge":"30"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_cuenta }},[_c('label',[_vm._v("Cuenta")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.cliente.cuenta),callback:function ($$v) {_vm.cliente.cuenta=$$v},expression:"cliente.cuenta"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"33","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',[_c('label',[_vm._v("R.F.C.")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.rfc),callback:function ($$v) {_vm.cliente.rfc=$$v},expression:"cliente.rfc"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"33","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('md-input',{attrs:{"type":"email"},model:{value:(_vm.cliente.email),callback:function ($$v) {_vm.cliente.email=$$v},expression:"cliente.email"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"33","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',[_c('label',[_vm._v("Teléfono")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-#####'),expression:"'(###) ###-#####'"}],model:{value:(_vm.cliente.telefono),callback:function ($$v) {_vm.cliente.telefono=$$v},expression:"cliente.telefono"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"70","md-flex-medium":"35","md-flex-large":"35","md-flex-xlarge":"35"}},[_c('md-input-container',[_c('label',[_vm._v("Calle")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.calle),callback:function ($$v) {_vm.cliente.calle=$$v},expression:"cliente.calle"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"30","md-flex-medium":"15","md-flex-large":"15","md-flex-xlarge":"15"}},[_c('md-input-container',[_c('label',[_vm._v("# ext")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.numero),callback:function ($$v) {_vm.cliente.numero=$$v},expression:"cliente.numero"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"70","md-flex-medium":"35","md-flex-large":"35","md-flex-xlarge":"35"}},[_c('md-input-container',[_c('label',[_vm._v("Colonia")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.colonia),callback:function ($$v) {_vm.cliente.colonia=$$v},expression:"cliente.colonia"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"30","md-flex-medium":"15","md-flex-large":"15","md-flex-xlarge":"15"}},[_c('md-input-container',[_c('label',[_vm._v("C. P.")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.codigo_postal),callback:function ($$v) {_vm.cliente.codigo_postal=$$v},expression:"cliente.codigo_postal"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"40","md-flex-medium":"40","md-flex-large":"40","md-flex-xlarge":"40"}},[_c('md-input-container',[_c('label',[_vm._v("Municipio")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.municipio),callback:function ($$v) {_vm.cliente.municipio=$$v},expression:"cliente.municipio"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"40","md-flex-medium":"40","md-flex-large":"40","md-flex-xlarge":"40"}},[_c('md-input-container',[_c('label',[_vm._v("Estado")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.cliente.estado),callback:function ($$v) {_vm.cliente.estado=$$v},expression:"cliente.estado"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"20","md-flex-small":"20","md-flex-medium":"20","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',[_c('label',{attrs:{"for":"ruta"}},[_vm._v("Ruta")]),_vm._v(" "),_c('md-select',{attrs:{"name":"ruta","id":"ruta"},model:{value:(_vm.cliente.ruta),callback:function ($$v) {_vm.cliente.ruta=$$v},expression:"cliente.ruta"}},[_c('md-option',{attrs:{"value":"centro"}},[_vm._v("Centro")]),_vm._v(" "),_c('md-option',{attrs:{"value":"norte"}},[_vm._v("Norte")]),_vm._v(" "),_c('md-option',{attrs:{"value":"sur"}},[_vm._v("Sur")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"100","md-flex-xlarge":"100"}},[_c('md-input-container',[_c('md-icon',[_vm._v("edit")]),_vm._v(" "),_c('label',[_vm._v("Notas")]),_vm._v(" "),_c('md-textarea',{model:{value:(_vm.cliente.notas),callback:function ($$v) {_vm.cliente.notas=$$v},expression:"cliente.notas"}})],1)],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('router-link',{attrs:{"tag":"md-button","to":"/clientes"}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.guardarCliente()}}},[_vm._v("Guardar cliente")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RDfC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdelantosNominaValidar_vue__ = __webpack_require__("dJhL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d63cbeb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AdelantosNominaValidar_vue__ = __webpack_require__("vMTS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdelantosNominaValidar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d63cbeb2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AdelantosNominaValidar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rbrr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContratosEditar_vue__ = __webpack_require__("fXg2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_030300ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ContratosEditar_vue__ = __webpack_require__("dXWB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContratosEditar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_030300ad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ContratosEditar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SOkO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ConceptosListado m-t-16"},[_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Conceptos de nómina registrados")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Concepto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Tipo")]),_vm._v(" "),_c('md-table-head',[_vm._v("Importe")]),_vm._v(" "),_c('md-table-head',[_vm._v("Estatus")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.conceptos),function(concepto){return _c('md-table-row',{key:concepto},[_c('md-table-cell',[_vm._v(_vm._s(concepto.desc_con))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(concepto.tipo_con.toUpperCase()))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(concepto.importe_cnh)))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(concepto.estatus_con.toUpperCase()))]),_vm._v(" "),_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.modalEditarConcepto(concepto)}}},[_c('md-icon',[_vm._v("edit")])],1)],1)],1)}))],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalEditarConcepto",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.concepto.desc_con))]),_vm._v(" "),_c('md-dialog-content',[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_desc }},[_c('label',[_vm._v("Concepto")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.concepto.desc_con),callback:function ($$v) {_vm.concepto.desc_con=$$v},expression:"concepto.desc_con"}})],1),_vm._v(" "),_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tipo }},[_c('label',[_vm._v("Tipo")]),_vm._v(" "),_c('md-select',{attrs:{"name":"tipo_con","id":"tipo_con","required":""},model:{value:(_vm.concepto.tipo_con),callback:function ($$v) {_vm.concepto.tipo_con=$$v},expression:"concepto.tipo_con"}},[_c('md-option',{attrs:{"value":"percepcion"}},[_vm._v("Percepción")]),_vm._v(" "),_c('md-option',{attrs:{"value":"deduccion"}},[_vm._v("Deducción")])],1)],1),_vm._v(" "),_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_importe }},[_c('label',[_vm._v("Importe")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.concepto.importe_cnh),callback:function ($$v) {_vm.concepto.importe_cnh=$$v},expression:"concepto.importe_cnh"}})],1),_vm._v(" "),_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tipo }},[_c('label',[_vm._v("Estatus")]),_vm._v(" "),_c('md-select',{attrs:{"name":"estatus_con","id":"estatus_con","required":""},model:{value:(_vm.concepto.estatus_con),callback:function ($$v) {_vm.concepto.estatus_con=$$v},expression:"concepto.estatus_con"}},[_c('md-option',{attrs:{"value":"activo"}},[_vm._v("Activo")]),_vm._v(" "),_c('md-option',{attrs:{"value":"inactivo"}},[_vm._v("Inactivo")])],1)],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModalEditarConcepto()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised",nativeOn:{"click":function($event){_vm.guardarCambiosConcepto()}}},[_vm._v("Guardar cambios")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "STfl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NominaDiasFestivos"},[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24","md-align":"center"}},[_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"100","md-flex-small":"80","md-flex-medium":"60","md-flex-large":"40","md-flex-xlarge":"30"}},[_c('md-table-card',{staticClass:"m-t-16"},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Días festivos")]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button md-raised md-accent",nativeOn:{"click":function($event){_vm.abrirModal()}}},[_c('md-icon',[_vm._v("add")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Agregar día festivo")])],1)],1),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head'),_vm._v(" "),_c('md-table-head',[_vm._v("Fecha")]),_vm._v(" "),_c('md-table-head',[_vm._v("Motivo")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.dias),function(d){return _c('md-table-row',{key:d.dia},[_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.eliminarDia(d.dia)}}},[_c('md-icon',[_vm._v("delete")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"right"}},[_vm._v("Eliminar "+_vm._s(d.fecha_dia))])],1)],1),_vm._v(" "),_c('md-table-cell',[_vm._v(" "+_vm._s(d.fecha_dia)+" ")]),_vm._v(" "),_c('md-table-cell',[_vm._v(" "+_vm._s(d.motivo_dia)+" ")])],1)}))],1)],1)],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalNuevoDia",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-title',[_vm._v("Registrar día festivo")]),_vm._v(" "),_c('md-dialog-content',[_c('md-input-container',{class:{ 'md-input-invalid': _vm.v.fecha_dia }},[_c('label',[_vm._v("dia/mes/año")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],attrs:{"required":"","placeholder":"Fecha"},model:{value:(_vm.dia.fecha_dia),callback:function ($$v) {_vm.dia.fecha_dia=$$v},expression:"dia.fecha_dia"}})],1),_vm._v(" "),_c('md-input-container',{class:{ 'md-input-invalid': _vm.v.motivo_dia }},[_c('label',[_vm._v("Motivo")]),_vm._v(" "),_c('md-input',{attrs:{"maxlength":"255","required":""},model:{value:(_vm.dia.motivo_dia),callback:function ($$v) {_vm.dia.motivo_dia=$$v},expression:"dia.motivo_dia"}})],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModalDia()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.guardarDia()}}},[_vm._v("Guardar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sskl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inicio"},[_c('h1',[_vm._v("Información del plan")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Tgpj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EmpleadosListado m-t-16"},[_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Empleados registrados")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("# emp")]),_vm._v(" "),_c('md-table-head',[_vm._v("Nombre")]),_vm._v(" "),_c('md-table-head',[_vm._v("Puesto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Estatus")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.empleados),function(e,index){return _c('md-table-row',{key:index},[_c('md-table-cell',[_vm._v(_vm._s(e.id_emn))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(e.nombre_emn+' '+e.ap_pat_emn+' '+e.ap_mat_emn))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(e.nombre_pue.toUpperCase())+",\n            "),_c('small',[_vm._v(_vm._s(e.depto_pue.toUpperCase()))])]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(e.estatus_ene.toUpperCase()))]),_vm._v(" "),_c('md-table-cell',[(e.archivo_enc)?_c('div',[_c('md-button',{staticClass:"md-icon-button"},[_c('md-icon',{nativeOn:{"click":function($event){_vm.irEditarEmpleado(e.id_emn)}}},[_vm._v("edit")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Editar empleado")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.abrirModalEditarEstatus(e)}}},[(e.estatus_ene === 'activo')?_c('md-icon',[_vm._v("pause")]):_c('md-icon',[_vm._v("play_arrow")]),_vm._v(" "),(e.estatus_ene === 'activo')?_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Suspender empleado")]):_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Reactivar empleado")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.irDetalleEmpleado(e.empleado)}}},[_c('md-icon',[_vm._v("folder")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Expediente del empleado")])],1)],1):_vm._e(),_vm._v(" "),(!e.archivo_enc && e.estatus_ene ==='activo')?_c('div',[_c('md-button',{staticClass:"md-raised md-icon-button md-warn",nativeOn:{"click":function($event){_vm.abrirModalSubirContrato(e,index)}}},[_c('md-icon',[_vm._v("description")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Subir contrato firmado")])],1)],1):_vm._e()])],1)}))],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalEditarEstatus",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.empleado.nombre_emn+' '+_vm.empleado.ap_pat_emn+' '+_vm.empleado.ap_mat_emn))]),_vm._v(" "),_c('md-dialog-content',[_c('md-input-container',[_c('label',{attrs:{"for":"estatus"}},[_vm._v("Estatus")]),_vm._v(" "),_c('md-select',{attrs:{"name":"estatus","id":"estatus"},model:{value:(_vm.empleado.estatus_ene),callback:function ($$v) {_vm.empleado.estatus_ene=$$v},expression:"empleado.estatus_ene"}},[_c('md-option',{attrs:{"value":"activo"}},[_vm._v("Activo")]),_vm._v(" "),_c('md-option',{attrs:{"value":"incapacitado"}},[_vm._v("Incapacitado")]),_vm._v(" "),_c('md-option',{attrs:{"value":"renuncio"}},[_vm._v("Renuncio")]),_vm._v(" "),_c('md-option',{attrs:{"value":"despedido"}},[_vm._v("Despedido")])],1)],1),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Observaciones")]),_vm._v(" "),_c('md-textarea',{model:{value:(_vm.observaciones_ene),callback:function ($$v) {_vm.observaciones_ene=$$v},expression:"observaciones_ene"}})],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModalEditarEstatus()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.cambiarEstatusEmpleado()}}},[_vm._v("Guardar cambios")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalSubirContrato",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-content',[_c('div',{staticClass:"md-subheading"},[_vm._v("GENERAR CONTRATO PARA "+_vm._s(_vm.empleado.nombre_emn + ' '+_vm.empleado.ap_pat_emn + ' ' + _vm.empleado.ap_mat_emn)),_c('br')]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-accent",nativeOn:{"click":function($event){_vm.abrirVentanaGenerarContrato(_vm.empleado.id_emn)}}},[_vm._v("Generar contrato en PDF")]),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Subir contrato firmado")]),_vm._v(" "),_c('md-file',{attrs:{"accept":"application/pdf"},on:{"selected":function($event){_vm.prepararContratoSubir($event)}},model:{value:(_vm.single),callback:function ($$v) {_vm.single=$$v},expression:"single"}})],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModal('modalSubirContrato')}}},[_vm._v("Cerrar")]),_vm._v(" "),(_vm.archivo_contrato != null)?_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.guardarArchivoContrato()}}},[_vm._v("Subir contrato")]):_vm._e()],1)],1),_vm._v(" "),_c('md-dialog',{ref:"subiendoArchivo",attrs:{"md-open-from":"#custom","md-close-to":"#custom","md-click-outside-to-close":false,"md-esc-to-close":false}},[_c('md-progress',{attrs:{"md-indeterminate":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UV8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inicio"},[_c('md-layout',{staticClass:"m-t-24",attrs:{"md-flex":"100","md-align":"center","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"20","md-flex-xlarge":"15"}},[_c('md-card',{staticClass:"md-accent m-b-24"},[_c('md-card-media-cover',[_c('md-card-media',[_c('img',{attrs:{"src":_vm.foto}})]),_vm._v(" "),_c('md-card-area',[_c('md-card-actions',[_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.abrirModal('modalCambiarFotoEmpleado')}}},[_c('md-icon',[_vm._v("photo_camera")])],1)],1)],1)],1),_vm._v(" "),_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("\n            "+_vm._s(_vm.empleado.nombre_emn)+" "+_vm._s(_vm.empleado.ap_pat_emn)+" "+_vm._s(_vm.empleado.ap_mat_emn)+"\n            "),_c('small',[_vm._v("#"+_vm._s(_vm.empleado.id_emn))])]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v(_vm._s(_vm.empleado.sexo_emn.toUpperCase())+", "+_vm._s(_vm.empleado.edad)+" AÑOS")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v(_vm._s(_vm.empleado.estatus_ene.toUpperCase())+" DESDE "+_vm._s(_vm.empleado.desde_ene))]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_c('strong',[_vm._v("PUESTO: ")]),_vm._v(_vm._s(_vm.empleado.nombre_pue)+",\n            "),_c('small',[_vm._v(_vm._s(_vm.empleado.descripcion_pue))])])]),_vm._v(" "),_c('md-card-actions',[_c('md-button',{staticClass:"md-raised",nativeOn:{"click":function($event){_vm.irEditarEmpleado()}}},[_vm._v("Editar")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"75","md-flex-large":"75","md-flex-xlarge":"75"}},[_c('md-tabs',{attrs:{"md-fixed":""}},[_c('md-tab',{attrs:{"id":"general","md-label":"General"}},[_c('div',{staticClass:"m-t-8",attrs:{"id":"datos-generales"}},[_c('div',{staticClass:"md-title"},[_c('md-icon',[_vm._v("face")]),_vm._v(" Información general\n            ")],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Sexo: ")]),_vm._v(" "+_vm._s(_vm.empleado.sexo_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Fecha de nacimiento: ")]),_vm._v(" "+_vm._s(_vm.empleado.fecha_nac_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Edad: ")]),_vm._v(" "+_vm._s(_vm.empleado.edad)+" años\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Estado civil: ")]),_vm._v(" "+_vm._s(_vm.empleado.estado_civil_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Escolaridad: ")]),_vm._v(" "+_vm._s(_vm.empleado.escolaridad_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Tipo de sangre: ")]),_vm._v(" "+_vm._s(_vm.empleado.tipo_sangre_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("NSS: ")]),_vm._v(" "+_vm._s(_vm.empleado.nss_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Cuenta bancaria: ")]),_vm._v(" "+_vm._s(_vm.empleado.cuenta_ban_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("CURP: ")]),_vm._v(" "+_vm._s(_vm.empleado.curp_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("RFC: ")]),_vm._v(" "+_vm._s(_vm.empleado.rfc_emn)+"\n              ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"m-t-24",attrs:{"id":"domicilio"}},[_c('div',{staticClass:"md-title"},[_c('md-icon',[_vm._v("home")]),_vm._v(" Domicilio\n            ")],1),_vm._v("\n            "+_vm._s(_vm.empleado.direccion_emn)+" #"+_vm._s(_vm.empleado.num_ext_emn)+". COLONIA "+_vm._s(_vm.empleado.colonia_emn)+", C.P. "+_vm._s(_vm.empleado.codigo_postal_emn)),_c('br'),_vm._v(" "+_vm._s(_vm.empleado.municipio_emn)+", "+_vm._s(_vm.empleado.estado_emn)),_c('br')]),_vm._v(" "),_c('div',{staticClass:"m-t-24",attrs:{"id":"contacto"}},[_c('div',{staticClass:"md-title"},[_c('md-icon',[_vm._v("phone")]),_vm._v(" Contacto\n            ")],1),_vm._v(" "),(_vm.empleado.tel_emn)?_c('div',[_c('strong',[_vm._v("Teléfono: ")]),_vm._v(" "),_c('a',{attrs:{"href":'tel:'+ _vm.empleado.tel_emn}},[_vm._v(_vm._s(_vm.empleado.tel_emn))])]):_vm._e(),_vm._v(" "),(_vm.empleado.cel_emn)?_c('div',[_c('strong',[_vm._v("Celular: ")]),_vm._v(" "),_c('a',{attrs:{"href":'tel:'+_vm.empleado.cel_emn}},[_vm._v(_vm._s(_vm.empleado.cel_emn))])]):_vm._e(),_vm._v(" "),(_vm.empleado.email_emn)?_c('div',[_c('strong',[_vm._v("Correo electrónicos: ")]),_vm._v(" "),_c('a',{attrs:{"href":'mailto:'+ _vm.empleado.email_emn}},[_vm._v(_vm._s(_vm.empleado.email_emn))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"m-t-24",attrs:{"id":"familiar"}},[_c('div',{staticClass:"md-title"},[_c('md-icon',[_vm._v("wc")]),_vm._v(" "),_c('md-icon',[_vm._v("notifications_active")]),_vm._v(" Información familiar y de emergencia\n            ")],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Persona de contacto: ")]),_vm._v(" "+_vm._s(_vm.empleado.persona_contacto_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Teléfono de contacto: ")]),_vm._v(" "),_c('a',{attrs:{"href":'tel:'+ _vm.empleado.tel_emn}},[_vm._v(_vm._s(_vm.empleado.tel_contacto_emn))])]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100"}},[_c('strong',[_vm._v("Dirección de contacto: ")]),_vm._v(" "+_vm._s(_vm.empleado.direccion_contacto_emn)+" #"+_vm._s(_vm.empleado.num_contacto_emn)+", COLONIA "+_vm._s(_vm.empleado.colonia_contacto_emn)+"\n              ")])],1),_vm._v(" "),_c('md-layout',{staticClass:"m-t-8",attrs:{"md-flex":"100","md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Nombre del cónyugye: ")]),_vm._v(" "+_vm._s(_vm.empleado.nombre_conyuge_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Teléfono del cónyugye: ")]),_vm._v(" "+_vm._s(_vm.empleado.tel_conyuge_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Hijos: ")]),_vm._v(" "+_vm._s(_vm.empleado.hijos_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Dependientes: ")]),_vm._v(" "+_vm._s(_vm.empleado.dependientes_emn)+"\n              ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"m-t-24",attrs:{"id":"corporal"}},[_c('div',{staticClass:"md-title"},[_c('md-icon',[_vm._v("accessibility")]),_vm._v(" Características corporales\n            ")],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Peso: ")]),_vm._v(" "+_vm._s(_vm.empleado.peso_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Estatura: ")]),_vm._v(" "+_vm._s(_vm.empleado.estatura_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Camisa: ")]),_vm._v(" "+_vm._s(_vm.empleado.camisa_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Pantalon: ")]),_vm._v(" "+_vm._s(_vm.empleado.pantalon_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Calzado: ")]),_vm._v(" "+_vm._s(_vm.empleado.calzado_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Complexion: ")]),_vm._v(" "+_vm._s(_vm.empleado.complexion_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Ojos: ")]),_vm._v(" "+_vm._s(_vm.empleado.ojos_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Piel: ")]),_vm._v(" "+_vm._s(_vm.empleado.piel_emn)+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('strong',[_vm._v("Cabello: ")]),_vm._v(" "+_vm._s(_vm.empleado.cabello_emn)+"\n              ")])],1)],1),_vm._v(" "),_c('p',[_vm._v("\n            \"experiencia_emn\":null,"),_c('br'),_vm._v(" \"anos_exp_emn\":null,\n            "),_c('br'),_vm._v(" \"observaciones_emn\":null,\n            "),_c('br')])]),_vm._v(" "),_c('md-tab',{attrs:{"id":"roles","md-label":"Roles"}},[_c('md-card',[_c('md-tabs',{staticClass:"md-accent",attrs:{"md-fixed":""}},[_c('md-tab',{attrs:{"id":"roles-activos","md-label":"Actuales"}},[_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Punto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Horario")]),_vm._v(" "),_c('md-table-head',[_vm._v("Toca")]),_vm._v(" "),_c('md-table-head',[_vm._v("L1")]),_vm._v(" "),_c('md-table-head',[_vm._v("M1")]),_vm._v(" "),_c('md-table-head',[_vm._v("M1")]),_vm._v(" "),_c('md-table-head',[_vm._v("J1")]),_vm._v(" "),_c('md-table-head',[_vm._v("V1")]),_vm._v(" "),_c('md-table-head',[_vm._v("S1")]),_vm._v(" "),_c('md-table-head',[_vm._v("D1")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.roles_activos),function(ra){return _c('md-table-row',{key:ra.id_rol},[_c('md-table-cell',[_vm._v(_vm._s(ra.nombre_pun))]),_vm._v(" "),_c('md-table-cell',[_vm._v(" "+_vm._s(_vm.moment(ra.inicio_ptu,'h:mm:ss').format('h:mm A'))+" - "+_vm._s(_vm.moment(ra.termino_ptu,'h:mm:ss').format('h:mm A')))]),_vm._v(" "),_c('md-table-cell',[_c('md-icon',[_vm._v(_vm._s(ra.cambio_rol === 'activo' ? 'filter_1' : 'filter_2'))]),_vm._v(" "),_c('md-tooltip',[_vm._v("Rol "+_vm._s(ra.cambio_rol === 'activo' ? 'esta' : 'la siguiente')+" semana")])],1),_vm._v(" "),_c('md-table-cell',[(ra.lun1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(ra.mar1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(ra.mie1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(ra.jue1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(ra.vie1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(ra.sab1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(ra.dom1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1)],1)}))],1)],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"roles-inactivos","md-label":"Pasados"}},[_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Punto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Horario")]),_vm._v(" "),_c('md-table-head',[_vm._v("L1")]),_vm._v(" "),_c('md-table-head',[_vm._v("M1")]),_vm._v(" "),_c('md-table-head',[_vm._v("M1")]),_vm._v(" "),_c('md-table-head',[_vm._v("J1")]),_vm._v(" "),_c('md-table-head',[_vm._v("V1")]),_vm._v(" "),_c('md-table-head',[_vm._v("S1")]),_vm._v(" "),_c('md-table-head',[_vm._v("D1")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.roles_inactivos),function(ri){return _c('md-table-row',{key:ri.id_rol},[_c('md-table-cell',[_vm._v(_vm._s(ri.nombre_pun))]),_vm._v(" "),_c('md-table-cell',[_vm._v(" "+_vm._s(_vm.moment(ri.inicio_ptu,'h:mm:ss').format('h:mm A'))+" - "+_vm._s(_vm.moment(ri.termino_ptu,'h:mm:ss').format('h:mm A')))]),_vm._v(" "),_c('md-table-cell',[(ri.lun1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(ri.mar1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(ri.mie1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(ri.jue1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(ri.vie1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(ri.sab1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(ri.dom1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1)],1)}))],1)],1)],1)],1)],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"sueldo","md-label":"Sueldo"}},[_c('div',{attrs:{"id":"sueldo-actual"}},[_c('div',{staticClass:"md-title"},[_vm._v("Salario semanal actual: "+_vm._s(_vm.numberFormat(_vm.empleado.salario_qnal_pnh)))]),_vm._v(" "),_c('md-layout',{staticClass:"m-t-24",attrs:{"md-flex":"100","md-gutter":"16"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"25"}},[_c('strong',[_vm._v("Falta justificada: ")]),_vm._v(_vm._s(_vm.numberFormat(_vm.empleado.falta_just_pnh))+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"25"}},[_c('strong',[_vm._v("Falta injustificada: ")]),_vm._v(_vm._s(_vm.numberFormat(_vm.empleado.falta_injust_pnh))+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"25"}},[_c('strong',[_vm._v("Permiso: ")]),_vm._v(_vm._s(_vm.numberFormat(_vm.empleado.permiso_pnh))+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"25"}},[_vm._v("\n                Permiso por fallecimiento "+_vm._s(_vm.numberFormat(_vm.empleado.permiso_falle_pnh))+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"25"}},[_c('strong',[_vm._v("Permiso por nacimiento: ")]),_vm._v(_vm._s(_vm.numberFormat(_vm.empleado.permiso_naci_pnh))+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"25"}},[_c('strong',[_vm._v("Hora de tiempo extra: ")]),_vm._v(_vm._s(_vm.numberFormat(_vm.empleado.hora_tie_ext_pnh))+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"25"}},[_c('strong',[_vm._v("Tiempo extra: ")]),_vm._v(_vm._s(_vm.numberFormat(_vm.empleado.tie_ext_pnh))+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"25"}},[_c('strong',[_vm._v("Dobre turno: ")]),_vm._v(_vm._s(_vm.numberFormat(_vm.empleado.doble_turno_pnh))+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"25"}},[_c('strong',[_vm._v("Día festivo: ")]),_vm._v(_vm._s(_vm.numberFormat(_vm.empleado.dia_festivo_pnh))+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"25"}},[_c('strong',[_vm._v("Día 31: ")]),_vm._v(_vm._s(_vm.numberFormat(_vm.empleado.dia_tresuno_pnh))+"\n              ")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"25"}},[_c('strong',[_vm._v("Día 28: ")]),_vm._v(_vm._s(_vm.numberFormat(_vm.empleado.dia_dosocho_pnh))+"\n              ")])],1)],1),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-accent",nativeOn:{"click":function($event){_vm.abrirModal('modalCambiarPlanPago')}}},[_vm._v("Cambiar plan de pago")]),_vm._v(" "),_c('md-table-card',{staticClass:"m-t-24"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Historial de salarios")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Asignado")]),_vm._v(" "),_c('md-table-head',[_vm._v("Desasignado")]),_vm._v(" "),_c('md-table-head',[_vm._v("Plan")]),_vm._v(" "),_c('md-table-head',[_vm._v("Salario semanal")]),_vm._v(" "),_c('md-table-head',[_vm._v("Desde plan")]),_vm._v(" "),_c('md-table-head',[_vm._v("Hasta plan")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.salarios_historial),function(s){return _c('md-table-row',{key:s.desde_eph},[_c('md-table-cell',[_vm._v(_vm._s(s.desde_eph))]),_vm._v(" "),_c('md-table-cell',[(s.hasta_eph)?_c('div',[_vm._v("\n                      "+_vm._s(s.hasta_eph)+"\n                    ")]):_vm._e()]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(s.nombre_pln))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.numberFormat(s.salario_qnal_pnh)))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.moment(s.desde_pnh).format('YYYY-MM-DD')))]),_vm._v(" "),_c('md-table-cell',[(s.hasta_pnh != '0000-00-00 00:00:00')?_c('div',[_vm._v("\n                      "+_vm._s(_vm.moment(s.hasta_pnh).format('YYYY-MM-DD'))+"\n                    ")]):_vm._e()])],1)}))],1)],1)],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"per-ded","md-label":"Percepciones y deducciones"}},[_c('md-card',{staticClass:"m-t-24"},[_c('md-tabs',{staticClass:"md-accent",attrs:{"md-fixed":""}},[_c('md-tab',{attrs:{"id":"pdn_activas","md-label":"Activas"}},[_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Concepto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Tipo")]),_vm._v(" "),_c('md-table-head',[_vm._v("Desde")]),_vm._v(" "),_c('md-table-head',[_vm._v("Sems")]),_vm._v(" "),_c('md-table-head',[_vm._v("Importe")]),_vm._v(" "),_c('md-table-head',[_vm._v("Restante")]),_vm._v(" "),(_vm.editar_nomina)?_c('md-table-head',[_vm._v("Acciones")]):_vm._e()],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.per_ded_activos),function(pda,index){return _c('md-table-row',{key:index},[_c('md-table-cell',[_vm._v(_vm._s(pda.desc_con))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(pda.tipo_con.toUpperCase()))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(pda.desde_pdn))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(pda.qnas_pdn))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.numberFormat(pda.importe_pdn)))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.numberFormat(pda.resto_pdn)))]),_vm._v(" "),(_vm.editar_nomina)?_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button"},[_c('md-icon',{nativeOn:{"click":function($event){_vm.cambiarEstatusConcepto(pda.id_pdn,'inactivo')}}},[_vm._v("pause")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Suspender concepto")])],1)],1):_vm._e()],1)}))],1)],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"pdn_inactivas","md-label":"Inactivas"}},[_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Concepto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Tipo")]),_vm._v(" "),_c('md-table-head',[_vm._v("Desde")]),_vm._v(" "),_c('md-table-head',[_vm._v("Hasta")]),_vm._v(" "),_c('md-table-head',[_vm._v("Sems")]),_vm._v(" "),_c('md-table-head',[_vm._v("Importe")]),_vm._v(" "),_c('md-table-head',[_vm._v("Restante")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.per_ded_inactivos),function(pdi,index){return _c('md-table-row',{key:index},[_c('md-table-cell',[_vm._v(_vm._s(pdi.desc_con))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(pdi.tipo_con.toUpperCase()))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(pdi.desde_pdn))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(pdi.hasta_pdn))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(pdi.qnas_pdn))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.numberFormat(pdi.importe_pdn)))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.numberFormat(pdi.resto_pdn)))]),_vm._v(" "),_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button"},[_c('md-icon',{nativeOn:{"click":function($event){_vm.cambiarEstatusConcepto(pdi.id_pdn,'activo')}}},[_vm._v("play_arrow")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Activar concepto")])],1)],1)],1)}))],1)],1),_vm._v(" "),_c('md-tab',{attrs:{"id":"books","md-label":"Agregar"}},[_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"45","md-flex-large":"45","md-flex-xlarge":"45"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_concepto }},[_c('label',{attrs:{"for":"concepto"}},[_vm._v("Conceptos")]),_vm._v(" "),_c('md-select',{attrs:{"name":"concepto","id":"concepto"},model:{value:(_vm.con_add.concepto),callback:function ($$v) {_vm.con_add.concepto=$$v},expression:"con_add.concepto"}},_vm._l((_vm.conceptosListado),function(c,index){return _c('md-option',{key:index,attrs:{"value":c.id_con},nativeOn:{"click":function($event){_vm.valoresConcepto(c)}}},[_vm._v("\n                            "+_vm._s(c.desc_con)+"\n                            "),_c('span',[_c('small',[_vm._v(", "+_vm._s(c.tipo_con.toUpperCase())+", "+_vm._s(Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(c.importe_cnh))+"\n                              ")])])])}))],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"40","md-flex-small":"40","md-flex-medium":"20","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_quincenas }},[_c('label',[_vm._v("Semanas")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"1","steps":"1"},nativeOn:{"blur":function($event){_vm.calcularImporteQuincenal()},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.agregarConcepto()}},model:{value:(_vm.con_add.quincenas),callback:function ($$v) {_vm.con_add.quincenas=$$v},expression:"con_add.quincenas"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"40","md-flex-small":"40","md-flex-medium":"20","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_importe_qnal }},[_c('label',[_vm._v("Importe sem.")]),_vm._v(" "),_c('md-input',{attrs:{"disabled":""},model:{value:(_vm.con_add.importe_qnal),callback:function ($$v) {_vm.con_add.importe_qnal=$$v},expression:"con_add.importe_qnal"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"rigth","md-flex-xsmall":"20","md-flex-small":"20","md-flex-medium":"15","md-flex-large":"15","md-flex-xlarge":"15"}},[_c('md-button',{staticClass:"md-icon-button md-raised md-accent",nativeOn:{"click":function($event){_vm.agregarConcepto()}}},[_c('md-icon',[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),(_vm.conceptosNomina.length > 0)?_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head'),_vm._v(" "),_c('md-table-head',[_vm._v("Concepto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Importe")]),_vm._v(" "),_c('md-table-head',[_vm._v("Semanas")]),_vm._v(" "),_c('md-table-head',[_vm._v("Importe sem.")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.conceptosNomina),function(con){return _c('md-table-row',{key:con.id_con},[_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.removerConcepto(con)}}},[_c('md-icon',[_vm._v("delete")])],1)],1),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(con.desc_con))]),_vm._v(" "),_c('md-table-cell',[_vm._v("$"+_vm._s(con.importe_con))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(con.quincenas_con))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(con.importe_qnal_con))])],1)}))],1):_vm._e(),_vm._v(" "),(_vm.conceptosNomina.length > 0)?_c('md-card-actions',[_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.guardarConceptos()}}},[_vm._v("Agregar conceptos")])],1):_vm._e()],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalCambiarPlanPago",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-title',[_vm._v("Cambiar plan de pago del empleado")]),_vm._v(" "),_c('md-dialog-content',[_c('md-input-container',[_c('label',{attrs:{"for":"id_pln_eph"}},[_vm._v("Plan de pago")]),_vm._v(" "),_c('md-select',{attrs:{"name":"id_pln_eph","id":"id_pln_eph","required":""},model:{value:(_vm.planDePago),callback:function ($$v) {_vm.planDePago=$$v},expression:"planDePago"}},_vm._l((_vm.planesListado),function(pln){return _c('md-option',{key:pln.id_pln,attrs:{"value":pln.id_pln}},[_vm._v("\n            "+_vm._s(pln.nombre_pln)+"\n            "),_c('span',[_c('small',[_vm._v(", "+_vm._s(_vm.numberFormat(pln.salario_qnal_pnh))+" ")])])])}))],1),_vm._v(" "),_c('p',[_c('small',[_vm._v("Para poder cambiar el plan de pago,"),_c('br'),_vm._v("debe seleccionar un plan de pago diferente al actual")])])],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModal('modalCambiarPlanPago')}}},[_vm._v("Cancelar")]),_vm._v(" "),(_vm.planDePago != _vm.planDePagoOld)?_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.cambiarPlanDePago()}}},[_vm._v("Cambiar plan de pago")]):_vm._e()],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalCambiarFotoEmpleado",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-content',[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_foto }},[_c('label',[_vm._v("Foto empleado")]),_vm._v(" "),_c('md-file',{attrs:{"accept":"image/*"},on:{"selected":function($event){_vm.prepararArchivoASubir($event)}},model:{value:(_vm.foto_emn),callback:function ($$v) {_vm.foto_emn=$$v},expression:"foto_emn"}})],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModal('modalCambiarFotoEmpleado')}}},[_vm._v("Cancelar")]),_vm._v(" "),(_vm.foto_subir)?_c('md-button',{nativeOn:{"click":function($event){_vm.subirFoto()}}},[_vm._v("Cambiar fotografía")]):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W0nm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConceptosNuevo_vue__ = __webpack_require__("LGdy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18429d4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ConceptosNuevo_vue__ = __webpack_require__("b4Jj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConceptosNuevo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18429d4b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ConceptosNuevo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W9YR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inicio"},[_c('md-layout',{staticClass:"m-t-16",attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"70","md-flex-xlarge":"50"}},[_c('div',{staticClass:"md-title"},[_vm._v("\n        Punto "+_vm._s(_vm.punto.nombre_pun)+"\n        "),_c('br'),_vm._v("Horario: "+_vm._s(_vm.moment(_vm.punto.inicio_ptu,'h:mm:ss').format('h:mm A'))+" a "+_vm._s(_vm.moment(_vm.punto.termino_ptu,'h:mm:ss').format('h:mm A'))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"md-subheading"},[_vm._v(_vm._s(_vm.punto.nombre))]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',[_c('md-checkbox',{attrs:{"id":"lun1","name":"lun1"},model:{value:(_vm.rol.lun1),callback:function ($$v) {_vm.rol.lun1=$$v},expression:"rol.lun1"}},[_vm._v("Lun")])],1),_vm._v(" "),_c('md-layout',[_c('md-checkbox',{attrs:{"id":"mar1","name":"mar1"},model:{value:(_vm.rol.mar1),callback:function ($$v) {_vm.rol.mar1=$$v},expression:"rol.mar1"}},[_vm._v("Mar")])],1),_vm._v(" "),_c('md-layout',[_c('md-checkbox',{attrs:{"id":"mie1","name":"mie1"},model:{value:(_vm.rol.mie1),callback:function ($$v) {_vm.rol.mie1=$$v},expression:"rol.mie1"}},[_vm._v("Mie")])],1),_vm._v(" "),_c('md-layout',[_c('md-checkbox',{attrs:{"id":"jue1","name":"jue1"},model:{value:(_vm.rol.jue1),callback:function ($$v) {_vm.rol.jue1=$$v},expression:"rol.jue1"}},[_vm._v("Jue")])],1),_vm._v(" "),_c('md-layout',[_c('md-checkbox',{attrs:{"id":"vie1","name":"vie1"},model:{value:(_vm.rol.vie1),callback:function ($$v) {_vm.rol.vie1=$$v},expression:"rol.vie1"}},[_vm._v("Vie")])],1),_vm._v(" "),_c('md-layout',[_c('md-checkbox',{attrs:{"id":"sab1","name":"sab1"},model:{value:(_vm.rol.sab1),callback:function ($$v) {_vm.rol.sab1=$$v},expression:"rol.sab1"}},[_vm._v("Sab")])],1),_vm._v(" "),_c('md-layout',[_c('md-checkbox',{attrs:{"id":"dom1","name":"dom1"},model:{value:(_vm.rol.dom1),callback:function ($$v) {_vm.rol.dom1=$$v},expression:"rol.dom1"}},[_vm._v("Dom")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100"}},[_c('md-button',{staticClass:"md-raised md-accent",nativeOn:{"click":function($event){_vm.agregarRol()}}},[_vm._v("Agregar rol")])],1)],1),_vm._v(" "),(_vm.roles.length > 0)?_c('md-card',{staticClass:"m-t-24 w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Roles por registrar")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"})]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head'),_vm._v(" "),_c('md-table-head',[_vm._v("L 1")]),_vm._v(" "),_c('md-table-head',[_vm._v("M 1")]),_vm._v(" "),_c('md-table-head',[_vm._v("M 1")]),_vm._v(" "),_c('md-table-head',[_vm._v("J 1")]),_vm._v(" "),_c('md-table-head',[_vm._v("V 1")]),_vm._v(" "),_c('md-table-head',[_vm._v("S 1")]),_vm._v(" "),_c('md-table-head',[_vm._v("D 1")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.roles),function(r,index){return _c('md-table-row',{key:index},[_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.borrarRolPreGuardado(index)}}},[_c('md-icon',[_vm._v("delete")])],1)],1),_vm._v(" "),_c('md-table-cell',[(r.lun1)?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(r.mar1)?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(r.mie1)?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(r.jue1)?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(r.vie1)?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(r.sab1)?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(r.dom1)?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1)],1)}))],1),_vm._v(" "),_c('md-card-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.abrirModalCancelarRoles()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{nativeOn:{"click":function($event){_vm.guardarRolesCapturados()}}},[_vm._v("Guardar Roles")])],1)],1):_vm._e(),_vm._v(" "),_c('md-card',{staticClass:"m-t-24 w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Roles registrados")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"})]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head'),_vm._v(" "),_c('md-table-head',[_vm._v("Empleado")]),_vm._v(" "),_c('md-table-head',[_vm._v("L 1")]),_vm._v(" "),_c('md-table-head',[_vm._v("M 1")]),_vm._v(" "),_c('md-table-head',[_vm._v("M 1")]),_vm._v(" "),_c('md-table-head',[_vm._v("J 1")]),_vm._v(" "),_c('md-table-head',[_vm._v("V 1")]),_vm._v(" "),_c('md-table-head',[_vm._v("S 1")]),_vm._v(" "),_c('md-table-head',[_vm._v("D 1")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.rolesRegistrados),function(rr,index){return _c('md-table-row',{key:index},[_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.borrarRol(rr,index)}}},[_c('md-icon',[_vm._v("delete")]),_vm._v(" "),_c('md-tooltip',[_vm._v("Eliminar rol")])],1),_vm._v(" "),(!rr.id_emn)?_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.buscarEmpleado(rr,index)}}},[_c('md-icon',[_vm._v("person_add")]),_vm._v(" "),_c('md-tooltip',[_vm._v("Asignar empleado")])],1):_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.buscarEmpleado(rr)}}},[_c('md-icon',[_vm._v("transfer_within_a_station")]),_vm._v(" "),_c('md-tooltip',[_vm._v("Cambiar empleado")])],1),_vm._v(" "),(rr.cambio_rol === 'activo')?_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.cambiarIntercaladoRol(rr)}}},[_c('md-icon',[_vm._v("filter_1")]),_vm._v(" "),_c('md-tooltip',[_vm._v("Rol esta semana")])],1):_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.cambiarIntercaladoRol(rr)}}},[_c('md-icon',[_vm._v("filter_2")]),_vm._v(" "),_c('md-tooltip',[_vm._v("Rol en siguiente semana")])],1)],1),_vm._v(" "),_c('md-table-cell',[(rr.id_emn)?_c('span',[_vm._v(_vm._s(rr.nombre))]):_vm._e()]),_vm._v(" "),_c('md-table-cell',[(rr.lun1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(rr.mar1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(rr.mie1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(rr.jue1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(rr.vie1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(rr.sab1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1),_vm._v(" "),_c('md-table-cell',[(rr.dom1_rol === '1')?_c('md-icon',[_vm._v("check")]):_c('md-icon',{staticClass:"md-warn"},[_vm._v("pause")])],1)],1)}))],1)],1)],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalBuscarEmpleado",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-content',[_c('p',[_vm._v("Ingrese el nombre del empleado a buscar")]),_vm._v(" "),_c('md-input-container',[_c('md-autocomplete',{attrs:{"fetch":_vm.fetchFunction,"print-attribute":"nombre","debounce":1000,"minChars":3},on:{"selected":function($event){_vm.funcionSelect($event)}},model:{value:(_vm.autocompleteValue),callback:function ($$v) {_vm.autocompleteValue=$$v},expression:"autocompleteValue"}})],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModalBuscarEmpleado()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised",nativeOn:{"click":function($event){_vm.confirmarEmpleado()}}},[_vm._v("Asignar Empleado")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalCancelarRoles",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-title',[_vm._v("¿Desea borrar los roles capturados?")]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModalCancelarRoles()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised",nativeOn:{"click":function($event){_vm.borrarRolesCapturados()}}},[_vm._v("Si, deseo borrarlos")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wc7H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AdelantosNominaSupervisor"},[_c('h1',[_vm._v("Adelantos de nómina supervisores")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wv/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmpleadosEditar_vue__ = __webpack_require__("omyV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6287562_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmpleadosEditar_vue__ = __webpack_require__("L4t1");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmpleadosEditar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6287562_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmpleadosEditar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XLfn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IncidenciasListado"},[_c('h1',[_vm._v("Incidencias")]),_vm._v(" "),_c('md-table-card',{staticClass:"w-100"},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Incidencias atendidas")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Fecha")]),_vm._v(" "),_c('md-table-head',[_vm._v("Incidencia")]),_vm._v(" "),_c('md-table-head',[_vm._v("Punto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Estatus")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.incidencias),function(i){return _c('md-table-row',{key:i},[_c('md-table-cell',[_vm._v(_vm._s(i.fecha_ipu))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(i.obs_ipu))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(i.nombre_pun))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(i.estatus_ipu.toUpperCase()))]),_vm._v(" "),_c('md-table-cell')],1)}))],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y7i6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ContratosNuevo",
  methods: {
    guardarContrato: function guardarContrato() {
      var _this = this;

      if (this.validarCamposContrato()) {
        this.$http.post("contratos/guardar", {
          token: this.$session.get("token"),
          data: this.contrato
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false
            });
            _this.$router.push({ name: "ContratosListado" });
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      }
    },
    validarCamposContrato: function validarCamposContrato() {
      !this.contrato.titulo_cnt ? this.val.v_titulo = true : this.val.v_titulo = false;
      this.contrato.contenido_cnt === "" ? this.val.v_contenido = true : this.val.v_contenido = false;
      !this.contrato.tipo_cnt ? this.val.v_tipo = true : this.val.v_tipo = false;
      !this.contrato.duracion_cnt ? this.val.v_duracion = true : this.val.v_duracion = false;
      if (this.val.v_titulo || this.val.v_contenido || this.val.v_tipo || this.val.v_duracion) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data: function data() {
    return {
      msg: "ContratosNuevo",
      contrato: {
        titulo_cnt: null,
        contenido_cnt: "",
        tipo_cnt: null,
        duracion_cnt: null
      },
      val: {
        v_titulo: null,
        v_contenido: null,
        v_tipo: null,
        v_duracion: null
      }
    };
  }
});

/***/ }),

/***/ "YFzl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuntosRoles_vue__ = __webpack_require__("ybhR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b6d24cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuntosRoles_vue__ = __webpack_require__("W9YR");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuntosRoles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b6d24cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuntosRoles_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YRJ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NominaDiasFestivos",
  methods: {
    obtenerDias: function obtenerDias() {
      var _this = this;

      this.$http.post("dias", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "dias" in response.body) {
          _this.dias = response.body.dias;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    abrirModal: function abrirModal() {
      this.$refs["modalNuevoDia"].open();
    },
    cerrarModalDia: function cerrarModalDia() {
      this.$refs["modalNuevoDia"].close();
      this.dia.fecha_dia = null;
      this.dia.motivo_dia = null;
    },
    guardarDia: function guardarDia() {
      var _this2 = this;

      if (this.validarCamposDia()) {
        this.$http.post("dias/guardar", {
          token: this.$session.get("token"),
          data: this.dia
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false
            });
            _this2.cerrarModalDia();
            _this2.obtenerDias();
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      }
    },
    eliminarDia: function eliminarDia(d) {
      var _this3 = this;

      this.$http.post("dias/eliminar", {
        token: this.$session.get("token"),
        dia: d
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false
          });
          _this3.obtenerDias();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor para eliminar el día",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    validarCamposDia: function validarCamposDia() {
      this.v.fecha_dia = !this.dia.fecha_dia ? true : false;
      this.v.motivo_dia = !this.dia.motivo_dia ? true : false;
      if (this.v.fecha_dia || this.v.motivo_dia) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Por favor llene todos los campos.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created: function created() {
    this.obtenerDias();
  },
  data: function data() {
    return {
      dias: [],
      dia: {
        fecha_dia: null,
        motivo_dia: null
      },
      v: {
        fecha_dia: null,
        motivo_dia: null
      }
    };
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Inicio__ = __webpack_require__("7FkD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_adelantos_AdelantosNominaAdministrativo__ = __webpack_require__("tme9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_adelantos_AdelantosNominaSupervisor__ = __webpack_require__("LAue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_adelantos_AdelantosNominaValidar__ = __webpack_require__("RDfC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_asistencias_AsistenciasPuntos__ = __webpack_require__("v2qJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_asistencias_AsistenciasPuntoSeleccionado__ = __webpack_require__("kmVm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_asistencias_AsistenciasTiemposExtra__ = __webpack_require__("LMGC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_asistencias_AsistenciasValidarTiemposExtra__ = __webpack_require__("MZaw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_clientes_ClientesListado__ = __webpack_require__("zqMi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_clientes_ClientesNuevo__ = __webpack_require__("l8Z8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_clientes_ClientesEditar__ = __webpack_require__("mGaK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_conceptos_ConceptosListado__ = __webpack_require__("GPGV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_conceptos_ConceptosNuevo__ = __webpack_require__("W0nm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_conceptos_ConceptosEditar__ = __webpack_require__("f/MS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_contratos_ContratosListado__ = __webpack_require__("cj7O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_contratos_ContratosNuevo__ = __webpack_require__("FVXa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_contratos_ContratosEditar__ = __webpack_require__("Rbrr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_empleados_EmpleadosListado__ = __webpack_require__("pg0g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_empleados_EmpleadosNuevo__ = __webpack_require__("KqSD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_empleados_EmpleadosEditar__ = __webpack_require__("Wv/4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_empleados_EmpleadosDetalle__ = __webpack_require__("KHUK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_incidencias_IncidenciasListado__ = __webpack_require__("Z8l/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_incidencias_IncidenciasAtendidasListado__ = __webpack_require__("N+BA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_incidencias_IncidenciasPendientesListado__ = __webpack_require__("AMwP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_incidencias_IncidenciasNueva__ = __webpack_require__("z+ub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_nomina_NominaResumen__ = __webpack_require__("HNY1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_nomina_NominaDiasFestivos__ = __webpack_require__("wiEd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_planes_PlanesListado__ = __webpack_require__("rYpc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_planes_PlanesNuevo__ = __webpack_require__("nN0q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_planes_PlanesEditar__ = __webpack_require__("J1pZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_planes_PlanesDetalle__ = __webpack_require__("2dYt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_puestos_PuestosListado__ = __webpack_require__("MFu0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_puestos_PuestosNuevo__ = __webpack_require__("erJZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_puntos_PuntosListado__ = __webpack_require__("jMm/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_puntos_PuntosSeleccionarCliente__ = __webpack_require__("u4lV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_puntos_PuntosNuevo__ = __webpack_require__("ZQiL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_puntos_PuntosEditar__ = __webpack_require__("AcWF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_puntos_PuntosDetalle__ = __webpack_require__("oG39");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_puntos_PuntosRoles__ = __webpack_require__("YFzl");






















































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */]
  }, {
    path: '/',
    name: 'Inicio',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Inicio__["a" /* default */]
  }, {
    path: '/inicio',
    name: 'Inicio2',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Inicio__["a" /* default */]
  },
  //Adelantos de nomina
  {
    path: '/adelantos/',
    name: 'AdelantosNominaAdministrativo',
    component: __WEBPACK_IMPORTED_MODULE_4__components_adelantos_AdelantosNominaAdministrativo__["a" /* default */]
  }, {
    path: '/adelantos-nomina',
    name: 'AdelantosNominaSupervisor',
    component: __WEBPACK_IMPORTED_MODULE_5__components_adelantos_AdelantosNominaSupervisor__["a" /* default */]
  }, {
    path: '/validar-adelantos/',
    name: 'AdelantosNominaValidar',
    component: __WEBPACK_IMPORTED_MODULE_6__components_adelantos_AdelantosNominaValidar__["a" /* default */]
  },
  //Asistencias y pases de lista
  {
    path: '/asistencias',
    name: 'AsistenciasPuntos',
    component: __WEBPACK_IMPORTED_MODULE_7__components_asistencias_AsistenciasPuntos__["a" /* default */]
  }, {
    path: '/asistencia/:turno',
    name: 'AsistenciasPuntoSeleccionado',
    component: __WEBPACK_IMPORTED_MODULE_8__components_asistencias_AsistenciasPuntoSeleccionado__["a" /* default */]
  }, {
    path: '/tiemposextra/asignar',
    name: 'AsistenciasTiemposExtra',
    component: __WEBPACK_IMPORTED_MODULE_9__components_asistencias_AsistenciasTiemposExtra__["a" /* default */]
  }, {
    path: '/tiemposextra/validar',
    name: 'AsistenciasValidarTiemposExtra',
    component: __WEBPACK_IMPORTED_MODULE_10__components_asistencias_AsistenciasValidarTiemposExtra__["a" /* default */]
  },
  //Clientes
  {
    path: '/clientes',
    name: 'ClientesListado',
    component: __WEBPACK_IMPORTED_MODULE_11__components_clientes_ClientesListado__["a" /* default */]
  }, {
    path: '/cliente',
    name: 'ClientesNuevo',
    component: __WEBPACK_IMPORTED_MODULE_12__components_clientes_ClientesNuevo__["a" /* default */]
  }, {
    path: '/cliente/:cliente/editar',
    name: 'ClientesEditar',
    component: __WEBPACK_IMPORTED_MODULE_13__components_clientes_ClientesEditar__["a" /* default */]
  },
  //Conceptos
  {
    path: '/conceptos',
    name: 'ConceptosListado',
    component: __WEBPACK_IMPORTED_MODULE_14__components_conceptos_ConceptosListado__["a" /* default */]
  }, {
    path: '/concepto',
    name: 'ConceptosNuevo',
    component: __WEBPACK_IMPORTED_MODULE_15__components_conceptos_ConceptosNuevo__["a" /* default */]
  }, {
    path: '/concepto/:concepto/editar',
    name: 'ConceptosEditar',
    component: __WEBPACK_IMPORTED_MODULE_16__components_conceptos_ConceptosEditar__["a" /* default */]
  },
  //Contratos laborales de guardias, prestación de servicios de monitoreo y alarmas y contrato de prestación de servicios de guardias de seguridad
  {
    path: '/contratos',
    name: 'ContratosListado',
    component: __WEBPACK_IMPORTED_MODULE_17__components_contratos_ContratosListado__["a" /* default */]
  }, {
    path: '/contrato/nuevo',
    name: 'ContratosNuevo',
    component: __WEBPACK_IMPORTED_MODULE_18__components_contratos_ContratosNuevo__["a" /* default */]
  }, {
    path: '/contrato/:contrato/editar',
    name: 'ContratosEditar',
    component: __WEBPACK_IMPORTED_MODULE_19__components_contratos_ContratosEditar__["a" /* default */]
  },
  //Empleados
  {
    path: '/empleados',
    name: 'EmpleadosListado',
    component: __WEBPACK_IMPORTED_MODULE_20__components_empleados_EmpleadosListado__["a" /* default */]
  }, {
    path: '/empleado/nuevo',
    name: 'EmpleadosNuevo',
    component: __WEBPACK_IMPORTED_MODULE_21__components_empleados_EmpleadosNuevo__["a" /* default */]
  }, {
    path: '/empleado/:empleado/editar',
    name: 'EmpleadosEditar',
    component: __WEBPACK_IMPORTED_MODULE_22__components_empleados_EmpleadosEditar__["a" /* default */]
  }, {
    path: '/empleado/:empleado/detalle',
    name: 'EmpleadosDetalle',
    component: __WEBPACK_IMPORTED_MODULE_23__components_empleados_EmpleadosDetalle__["a" /* default */]
  },
  //Incidencias
  {
    path: '/incidencias',
    name: 'IncidenciasListado',
    component: __WEBPACK_IMPORTED_MODULE_24__components_incidencias_IncidenciasListado__["a" /* default */]
  }, {
    path: '/incidencias/atendidas',
    name: 'IncidenciasAtendidasListado',
    component: __WEBPACK_IMPORTED_MODULE_25__components_incidencias_IncidenciasAtendidasListado__["a" /* default */]
  }, {
    path: '/incidencias/pendientes',
    name: 'IncidenciasPendientesListado',
    component: __WEBPACK_IMPORTED_MODULE_26__components_incidencias_IncidenciasPendientesListado__["a" /* default */]
  }, {
    path: '/incidencia/nueva',
    name: 'IncidenciasNueva',
    component: __WEBPACK_IMPORTED_MODULE_27__components_incidencias_IncidenciasNueva__["a" /* default */]
  },
  //Nomina
  {
    path: '/nomina/resumen',
    name: 'NominaResumen',
    component: __WEBPACK_IMPORTED_MODULE_28__components_nomina_NominaResumen__["a" /* default */]
  }, {
    path: '/nomina/diasfestivos',
    name: 'NominaDiasFestivos',
    component: __WEBPACK_IMPORTED_MODULE_29__components_nomina_NominaDiasFestivos__["a" /* default */]
  },
  //Planes de pago
  {
    path: '/planes',
    name: 'PlanesListado',
    component: __WEBPACK_IMPORTED_MODULE_30__components_planes_PlanesListado__["a" /* default */]
  }, {
    path: '/plan',
    name: 'PlanesNuevo',
    component: __WEBPACK_IMPORTED_MODULE_31__components_planes_PlanesNuevo__["a" /* default */]
  }, {
    path: '/plan/:id/editar',
    name: 'PlanesEditar',
    component: __WEBPACK_IMPORTED_MODULE_32__components_planes_PlanesEditar__["a" /* default */]
  }, {
    path: '/plan/:id/detalle',
    name: 'PlanesDetalle',
    component: __WEBPACK_IMPORTED_MODULE_32__components_planes_PlanesEditar__["a" /* default */]
  },
  //Puestos
  {
    path: '/puestos',
    name: 'PuestosListado',
    component: __WEBPACK_IMPORTED_MODULE_34__components_puestos_PuestosListado__["a" /* default */]
  }, {
    path: '/puesto',
    name: 'PuestosNuevo',
    component: __WEBPACK_IMPORTED_MODULE_35__components_puestos_PuestosNuevo__["a" /* default */]
  },
  //Puntos
  {
    path: '/puntos',
    name: 'PuntosListado',
    component: __WEBPACK_IMPORTED_MODULE_36__components_puntos_PuntosListado__["a" /* default */]
  }, {
    path: '/punto/cliente',
    name: 'PuntosSeleccionarCliente',
    component: __WEBPACK_IMPORTED_MODULE_37__components_puntos_PuntosSeleccionarCliente__["a" /* default */]
  }, {
    path: '/punto/nuevo/:cliente', //Es el id del cliente
    name: 'PuntosNuevo',
    component: __WEBPACK_IMPORTED_MODULE_38__components_puntos_PuntosNuevo__["a" /* default */]
  }, {
    path: '/punto/:punto/editar',
    name: 'PuntosEditar',
    component: __WEBPACK_IMPORTED_MODULE_39__components_puntos_PuntosEditar__["a" /* default */]
  }, {
    path: '/punto/:punto/detalle',
    name: 'PuntosDetalle',
    component: __WEBPACK_IMPORTED_MODULE_40__components_puntos_PuntosDetalle__["a" /* default */]
  }, {
    path: '/punto/:turno/rol',
    name: 'PuntosRoles',
    component: __WEBPACK_IMPORTED_MODULE_41__components_puntos_PuntosRoles__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Yfl6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ContratosListado"},[_c('md-layout',{staticClass:"m-t-24",attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"90","md-flex-xlarge":"70"}},[_c('md-table-card',{staticClass:"w-100"},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("\n            Contratos registrados\n          ")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Nombre")]),_vm._v(" "),_c('md-table-head',[_vm._v("Tipo")]),_vm._v(" "),_c('md-table-head',[_vm._v("Duración")]),_vm._v(" "),_c('md-table-head',[_vm._v("Estatus")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.contratos),function(contrato){return _c('md-table-row',{key:contrato.id_cnt},[_c('md-table-cell',[_vm._v(_vm._s(contrato.titulo_cnt))]),_vm._v(" "),_c('md-table-cell',[(contrato.tipo_cnt==='laboral_guardia')?_c('div',[_vm._v("CONTRATO LABORAL GUARDIA")]):_vm._e(),_vm._v(" "),(contrato.tipo_cnt==='servicios_monitoreo')?_c('div',[_vm._v("PRESTACIÓN SERVICIOS MONITOREO")]):_vm._e(),_vm._v(" "),(contrato.tipo_cnt==='servicios_guardias')?_c('div',[_vm._v("PRESTACIÓN SERVICIOS GUARDIAS")]):_vm._e()]),_vm._v(" "),_c('md-table-cell',[(contrato.duracion_cnt === '1')?_c('div',[_vm._v("1 MES")]):_vm._e(),_vm._v(" "),(contrato.duracion_cnt > 1)?_c('div',[_vm._v(_vm._s(contrato.duracion_cnt)+" MESES")]):_vm._e(),_vm._v(" "),(contrato.duracion_cnt==='indeterminado')?_c('div',[_vm._v("INDETERMINADO")]):_vm._e()]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(contrato.estatus_cnt.toUpperCase()))]),_vm._v(" "),_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.irAEditarContratos(contrato.id_cnt)}}},[_c('md-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.cambiarEstatusContrato(contrato)}}},[(contrato.estatus_cnt != 'activo')?_c('md-icon',[_vm._v("play")]):_c('md-icon',[_vm._v("pause")])],1)],1)],1)}))],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z8l/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidenciasListado_vue__ = __webpack_require__("uTO0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7046e846_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IncidenciasListado_vue__ = __webpack_require__("BH+U");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidenciasListado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7046e846_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IncidenciasListado_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZQiL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuntosNuevo_vue__ = __webpack_require__("A80F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57be4876_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuntosNuevo_vue__ = __webpack_require__("clpL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuntosNuevo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57be4876_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuntosNuevo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b4Jj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ConceptosNuevo"},[_c('md-layout',{attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"60","md-flex-medium":"60","md-flex-large":"40","md-flex-xlarge":"30"}},[_c('md-card',{staticClass:"w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Registrar concepto de nómina")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-column":"","md-flex":"100"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_desc }},[_c('label',[_vm._v("Concepto")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.concepto.desc_con),callback:function ($$v) {_vm.concepto.desc_con=$$v},expression:"concepto.desc_con"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tipo }},[_c('label',[_vm._v("Tipo")]),_vm._v(" "),_c('md-select',{attrs:{"name":"tipo_con","id":"tipo_con","required":""},model:{value:(_vm.concepto.tipo_con),callback:function ($$v) {_vm.concepto.tipo_con=$$v},expression:"concepto.tipo_con"}},[_c('md-option',{attrs:{"value":"percepcion"}},[_vm._v("Percepción")]),_vm._v(" "),_c('md-option',{attrs:{"value":"deduccion"}},[_vm._v("Deducción")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_importe }},[_c('label',[_vm._v("Importe")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","step":".01","required":""},model:{value:(_vm.concepto.importe_cnh),callback:function ($$v) {_vm.concepto.importe_cnh=$$v},expression:"concepto.importe_cnh"}})],1)],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('router-link',{attrs:{"tag":"md-button","to":"/conceptos"}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised",nativeOn:{"click":function($event){_vm.guardarConcepto()}}},[_vm._v("Guardar concepto")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "brux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AsistenciasPuntoSeleccionado"},[_c('md-table-card',{staticClass:"m-t-16"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.turno.nombre_pun))]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v(_vm._s(_vm.moment(_vm.turno.inicio_ptu,'h:mm:ss').format('h:mm A'))+" - "+_vm._s(_vm.moment(_vm.turno.termino_ptu,'h:mm:ss').format('h:mm A')))])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("# emp")]),_vm._v(" "),_c('md-table-head',[_vm._v("Empleado")]),_vm._v(" "),_c('md-table-head',[_vm._v("Teléfono")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.empleados),function(e,index){return _c('md-table-row',{key:index},[_c('md-table-cell',[(e.id_emn)?_c('div',[_vm._v("\n              #"+_vm._s(e.id_emn)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('md-table-cell',[(e.nombre)?_c('div',[_vm._v("\n              "+_vm._s(e.nombre)+"\n            ")]):_c('div',[_vm._v("\n              VACANTE\n            ")])]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(e.cel_emn))]),_vm._v(" "),_c('md-table-cell',[_c('md-input-container',[_c('label',{attrs:{"for":"asistencia"}},[_vm._v("Asistencia")]),_vm._v(" "),_c('md-select',{attrs:{"name":"asistencia","id":"asistencia"},on:{"selected":function($event){_vm.asignarPaseLista(e.id_emn,$event)}}},[_c('md-option',{attrs:{"value":"falta"}},[_vm._v("Falta")]),_vm._v(" "),_c('md-option',{attrs:{"value":"asistio"}},[_vm._v("Asistió")]),_vm._v(" "),_c('md-option',{attrs:{"value":"falta_just_pnh"}},[_vm._v("Falta justificada")]),_vm._v(" "),_c('md-option',{attrs:{"value":"falta_injust_pnh"}},[_vm._v("Falta injustificada")]),_vm._v(" "),_c('md-option',{attrs:{"value":"permiso_pnh"}},[_vm._v("Permiso")]),_vm._v(" "),_c('md-option',{attrs:{"value":"permiso_falle_pnh"}},[_vm._v("Permiso fallecimiento")]),_vm._v(" "),_c('md-option',{attrs:{"value":"permiso_naci_pnh"}},[_vm._v("Permiso nacimiento")]),_vm._v(" "),_c('md-option',{attrs:{"value":"hora_tie_ext_pnh"}},[_vm._v("Hora(s) extra(s)")])],1)],1)],1)],1)}))],1),_vm._v(" "),_c('md-card-actions',[_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.abrirModal('confirmarPaseListas')}}},[_vm._v("Guardar")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"confirmarPaseListas",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-title',[_vm._v("¿Esta seguro de guardar el pase de lista?")]),_vm._v(" "),_c('md-dialog-content',[_c('p',[_vm._v("Una vez guardado, este no podrá ser modificado.")]),_vm._v(" "),_c('p',[_vm._v("Recuerde, si no se indicó la asistencia de un empleado, será considerado como falta injustificada.")])]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModal('confirmarPaseListas')}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised",nativeOn:{"click":function($event){_vm.guardarPaseDeLista()}}},[_vm._v("Guardar pase de lista")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cj7O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContratosListado_vue__ = __webpack_require__("h+nz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_296e2368_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ContratosListado_vue__ = __webpack_require__("Yfl6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContratosListado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_296e2368_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ContratosListado_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "clpL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PuntosNuevo"},[_c('h1',[_vm._v("Punto nuevo")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"30","md-flex-large":"20","md-flex-xlarge":"15"}},[_c('div',{staticClass:"md-title w-100"},[_vm._v("Información del cliente")]),_vm._v(" "),_c('div',{staticClass:"m-t-16"},[_c('strong',[_vm._v("Cuenta:")]),_vm._v(" "+_vm._s(_vm.cliente.cuenta)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Razón social:")]),_vm._v(" "+_vm._s(_vm.cliente.nombre)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("R.F.C.:")]),_vm._v(" "+_vm._s(_vm.cliente.rfc)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Email_")]),_vm._v(" "+_vm._s(_vm.cliente.email)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Teléfono:")]),_vm._v(" "),_c('a',{attrs:{"href":("tel:" + (_vm.cliente.telefono))}},[_vm._v(_vm._s(_vm.cliente.telefono))]),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Domicilio:")]),_vm._v("\n        "+_vm._s(_vm.cliente.calle+' #'+_vm.cliente.numero)+"."),_c('br'),_vm._v(" Colonia "+_vm._s(_vm.cliente.colonia)+". CP "+_vm._s(_vm.cliente.codigo_postal)),_c('br'),_vm._v(" "+_vm._s(_vm.cliente.municipio)+", "+_vm._s(_vm.cliente.estado)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Notas:")]),_vm._v(" "+_vm._s(_vm.cliente.notas)),_c('br')])]),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"60","md-flex-large":"50","md-flex-xlarge":"30"}},[_c('md-card',{staticClass:"w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Información del punto")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex":"100"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nombre }},[_c('label',[_vm._v("Nombre del punto")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.punto.nombre_pun),callback:function ($$v) {_vm.punto.nombre_pun=$$v},expression:"punto.nombre_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_guardias }},[_c('label',[_vm._v("Guardias requeridos")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"1","required":""},model:{value:(_vm.punto.guardias_pun),callback:function ($$v) {_vm.punto.guardias_pun=$$v},expression:"punto.guardias_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_presupuesto }},[_c('label',[_vm._v("Presupuesto")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","step":".01","min":"0","required":""},model:{value:(_vm.punto.presupuesto_pun),callback:function ($$v) {_vm.punto.presupuesto_pun=$$v},expression:"punto.presupuesto_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"70","md-flex-medium":"70","md-flex-large":"70","md-flex-xlarge":"70"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_calle }},[_c('label',[_vm._v("Calle")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.punto.calle_pun),callback:function ($$v) {_vm.punto.calle_pun=$$v},expression:"punto.calle_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"30","md-flex-medium":"30","md-flex-large":"30","md-flex-xlarge":"30"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_num_ext }},[_c('label',[_vm._v("# ext")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.punto.num_ext_pun),callback:function ($$v) {_vm.punto.num_ext_pun=$$v},expression:"punto.num_ext_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"70","md-flex-medium":"70","md-flex-large":"70","md-flex-xlarge":"70"}},[_c('md-input-container',[_c('label',[_vm._v("Colonia")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.punto.colonia_pun),callback:function ($$v) {_vm.punto.colonia_pun=$$v},expression:"punto.colonia_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"30","md-flex-medium":"30","md-flex-large":"30","md-flex-xlarge":"30"}},[_c('md-input-container',[_c('label',[_vm._v("C.P.")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.punto.cp_pun),callback:function ($$v) {_vm.punto.cp_pun=$$v},expression:"punto.cp_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',[_c('label',[_vm._v("Municipio")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.punto.municipio_pun),callback:function ($$v) {_vm.punto.municipio_pun=$$v},expression:"punto.municipio_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',[_c('label',[_vm._v("Estado")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.punto.estado_pun),callback:function ($$v) {_vm.punto.estado_pun=$$v},expression:"punto.estado_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_id_cnt }},[_c('label',{attrs:{"for":"id_cnt_pun"}},[_vm._v("Contrato")]),_vm._v(" "),_c('md-select',{attrs:{"name":"id_cnt_pun","id":"id_cnt_pun","required":"","md-dense":""},model:{value:(_vm.punto.id_cnt_pun),callback:function ($$v) {_vm.punto.id_cnt_pun=$$v},expression:"punto.id_cnt_pun"}},_vm._l((_vm.contratos),function(cnt){return _c('md-option',{key:cnt.id_cnt,attrs:{"value":cnt.id_cnt}},[_vm._v("\n                    "+_vm._s(cnt.titulo_cnt)+"\n                  ")])}))],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100"}},[_c('md-input-container',[_c('label',[_vm._v("Notas")]),_vm._v(" "),_c('md-textarea',{model:{value:(_vm.punto.notas_pun),callback:function ($$v) {_vm.punto.notas_pun=$$v},expression:"punto.notas_pun"}})],1)],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.copiarInformacionCliente()}}},[_vm._v("\n            Usar información del cliente\n          ")])],1)],1),_vm._v(" "),_c('md-card',{staticClass:"w-100 m-t-24",attrs:{"m":""}},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Turnos")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24","md-align":"center"}},[_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"40","md-flex-small":"40","md-flex-medium":"25","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_inicio_tur }},[_c('label',{attrs:{"for":"inicio_tur"}},[_vm._v("Inicio")]),_vm._v(" "),_c('md-select',{attrs:{"name":"inicio_tur","id":"inicio_tur"},model:{value:(_vm.turno.inicio_tur),callback:function ($$v) {_vm.turno.inicio_tur=$$v},expression:"turno.inicio_tur"}},[_c('md-option',{attrs:{"value":"1 AM"}},[_vm._v("1 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"2 AM"}},[_vm._v("2 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3 AM"}},[_vm._v("3 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4 AM"}},[_vm._v("4 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5 AM"}},[_vm._v("5 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6 AM"}},[_vm._v("6 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7 AM"}},[_vm._v("7 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8 AM"}},[_vm._v("8 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9 AM"}},[_vm._v("9 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10 AM"}},[_vm._v("10 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11 AM"}},[_vm._v("11 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12 AM"}},[_vm._v("12 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"1 PM"}},[_vm._v("1 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"2 PM"}},[_vm._v("2 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3 PM"}},[_vm._v("3 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4 PM"}},[_vm._v("4 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5 PM"}},[_vm._v("5 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6 PM"}},[_vm._v("6 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7 PM"}},[_vm._v("7 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8 PM"}},[_vm._v("8 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9 PM"}},[_vm._v("9 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10 PM"}},[_vm._v("10 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11 PM"}},[_vm._v("11 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12 PM"}},[_vm._v("12 PM")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"40","md-flex-small":"40","md-flex-medium":"25","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_fin_tur }},[_c('label',{attrs:{"for":"fin_tur"}},[_vm._v("Fin")]),_vm._v(" "),_c('md-select',{attrs:{"name":"fin_tur","id":"fin_tur"},model:{value:(_vm.turno.fin_tur),callback:function ($$v) {_vm.turno.fin_tur=$$v},expression:"turno.fin_tur"}},[_c('md-option',{attrs:{"value":"1 AM"}},[_vm._v("1 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"2 AM"}},[_vm._v("2 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3 AM"}},[_vm._v("3 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4 AM"}},[_vm._v("4 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5 AM"}},[_vm._v("5 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6 AM"}},[_vm._v("6 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7 AM"}},[_vm._v("7 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8 AM"}},[_vm._v("8 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9 AM"}},[_vm._v("9 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10 AM"}},[_vm._v("10 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11 AM"}},[_vm._v("11 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12 AM"}},[_vm._v("12 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"1 PM"}},[_vm._v("1 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"2 PM"}},[_vm._v("2 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3 PM"}},[_vm._v("3 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4 PM"}},[_vm._v("4 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5 PM"}},[_vm._v("5 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6 PM"}},[_vm._v("6 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7 PM"}},[_vm._v("7 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8 PM"}},[_vm._v("8 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9 PM"}},[_vm._v("9 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10 PM"}},[_vm._v("10 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11 PM"}},[_vm._v("11 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12 PM"}},[_vm._v("12 PM")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"20","md-flex-small":"20","md-flex-medium":"15","md-flex-large":"15","md-flex-xlarge":"15"}},[_c('md-button',{staticClass:"md-icon-button md-raised md-accent",nativeOn:{"click":function($event){_vm.agregarTurno()}}},[_c('md-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"100","md-flex-xlarge":"100"}},[_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head'),_vm._v(" "),_c('md-table-head',[_vm._v("Turno")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.turnos),function(t){return _c('md-table-row',{key:t.id_tur},[_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.removerTurno(t)}}},[_c('md-icon',[_vm._v("delete")])],1)],1),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(t.inicio_tur)+" a "+_vm._s(t.fin_tur))])],1)}))],1)],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('router-link',{attrs:{"tag":"md-button","to":"/puntos"}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.guardarPunto()}}},[_vm._v("Guardar punto")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dJhL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AdelantosNominaValidar",
  methods: {
    nF: function nF(numerito) {
      return Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN"
      }).format(numerito);
    },
    obtenerAdelantosRegistrados: function obtenerAdelantosRegistrados() {
      var _this = this;

      this.$http.post("adelantos", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "adelantos" in response.body) {
          _this.adelantos = response.body.adelantos;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    guardarCambiosAdelanto: function guardarCambiosAdelanto(a, e) {
      if (a.autorizado_ano >= a.salario_qnal_pnh / 2) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "El adelanto de nómina autorizado para " + a.nombre_empleado + " es mayor a la mitad de su salario quincenal",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: true,
          backgroundColor: "#FFC107",
          textColor: "#000",
          actionTextColor: "#000"
        });
      }
      //id_ano, solicito_ano, autorizado_ano, empleado, nombre_empleado, nombre_pue, depto_pue, salario_qnal_pnh
      this.$http.post("adelantos/actualizar", {
        token: this.$session.get("token"),
        data: {
          adelanto: __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(a.id_ano)),
          autorizado: a.autorizado_ano
        }
      }).then(function (response) {}, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created: function created() {
    this.obtenerAdelantosRegistrados();
  },
  data: function data() {
    return {
      msg: "AdelantosNominaValidar",
      adelantos: []
    };
  }
});

/***/ }),

/***/ "dXWB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ContratosNuevo"},[_c('md-layout',{staticClass:"m-t-24",attrs:{"md-gutter":"24","md-align":"center","md-flex":"100"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"100","md-flex-xlarge":"70"}},[_c('md-card',{staticClass:"w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Edición del contrato "+_vm._s(_vm.contrato.titulo_cnt))])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-gutter":"24","md-align":"center","md-flex":"100"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"50","md-flex-large":"60","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_titulo }},[_c('label',[_vm._v("Nombre del contrato")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.contrato.titulo_cnt),callback:function ($$v) {_vm.contrato.titulo_cnt=$$v},expression:"contrato.titulo_cnt"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tipo }},[_c('label',{attrs:{"for":"tipo_cnt"}},[_vm._v("Tipo")]),_vm._v(" "),_c('md-select',{attrs:{"name":"tipo_cnt","id":"tipo_cnt","required":""},model:{value:(_vm.contrato.tipo_cnt),callback:function ($$v) {_vm.contrato.tipo_cnt=$$v},expression:"contrato.tipo_cnt"}},[_c('md-option',{attrs:{"value":"laboral_guardia"}},[_vm._v("Contrato laboral guardia")]),_vm._v(" "),_c('md-option',{attrs:{"value":"servicios_monitoreo"}},[_vm._v("Prestación servicios monitoreo")]),_vm._v(" "),_c('md-option',{attrs:{"value":"servicios_guardias"}},[_vm._v("Prestación servicios guardias")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_duracion }},[_c('label',{attrs:{"for":"duracion_cnt"}},[_vm._v("Duración")]),_vm._v(" "),_c('md-select',{attrs:{"name":"duracion_cnt","id":"duracion_cnt","required":""},model:{value:(_vm.contrato.duracion_cnt),callback:function ($$v) {_vm.contrato.duracion_cnt=$$v},expression:"contrato.duracion_cnt"}},[_c('md-option',{attrs:{"value":"indeterminado"}},[_vm._v("Indeterminado")]),_vm._v(" "),_c('md-option',{attrs:{"value":"1"}},[_vm._v("1 mes")]),_vm._v(" "),_c('md-option',{attrs:{"value":"2"}},[_vm._v("2 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3"}},[_vm._v("3 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4"}},[_vm._v("4 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5"}},[_vm._v("5 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6"}},[_vm._v("6 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7"}},[_vm._v("7 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8"}},[_vm._v("8 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9"}},[_vm._v("9 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10"}},[_vm._v("10 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11"}},[_vm._v("11 meses")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12"}},[_vm._v("12 meses")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-large":"100","md-flex-xlarge":"100"}},[_c('wysiwyg',{staticStyle:{"background":"white!important"},model:{value:(_vm.contrato.contenido_cnt),callback:function ($$v) {_vm.contrato.contenido_cnt=$$v},expression:"contrato.contenido_cnt"}})],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('router-link',{attrs:{"tag":"md-button","to":"/contratos"}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.actualizarContrato()}}},[_vm._v("Guardar")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dbcV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "IncidenciasNueva",
  methods: {
    irAIncidencias: function irAIncidencias() {
      this.$router.push("/incidencias");
    },
    obtenerPuntos: function obtenerPuntos() {
      var _this = this;

      this.$http.post("puntos", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "puntos" in response.body) {
          _this.puntos = response.body.puntos;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor para obtener los puntos.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    registrarIncidencia: function registrarIncidencia() {
      var _this2 = this;

      if (this.validarCamposIncidencia()) {
        this.$http.post("incidencias/guardar", {
          token: this.$session.get("token"),
          incidencia: this.incidencia
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: "Cerrar",
              pos: "top-right"
            });
            _this2.irAIncidencias();
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor para guardar las incidencias.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      }
    },
    validarCamposIncidencia: function validarCamposIncidencia() {
      !this.incidencia.obs_ipu ? this.v.v_obs = true : this.v.v_obs = false;
      !this.incidencia.id_pun_ipu ? this.v.v_id_pun = true : this.v.v_id_pun = false;
      if (this.v.v_obs || this.v.v_id_pun) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created: function created() {
    this.obtenerPuntos();
  },
  data: function data() {
    return {
      msg: "IncidenciasNueva",
      puntos: [],
      incidencia: {
        obs_ipu: null,
        id_pun_ipu: null
      },
      v: {
        v_id_pun: null,
        v_obs: null
      }
    };
  }
});

/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "erJZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuestosNuevo_vue__ = __webpack_require__("f3hf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014d5c59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuestosNuevo_vue__ = __webpack_require__("xJwv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuestosNuevo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_014d5c59_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuestosNuevo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f/MS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConceptosEditar_vue__ = __webpack_require__("t8t7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb3abe52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ConceptosEditar_vue__ = __webpack_require__("+9Ma");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConceptosEditar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb3abe52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ConceptosEditar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "f3hf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'inicio',
	methods: {
		guardarPuesto: function guardarPuesto() {
			var _this = this;

			if (this.validarCamposPuesto()) {
				this.$http.post('puestos/guardar', {
					token: this.$session.get('token'),
					data: this.puesto
				}).then(function (response) {
					if (response.status === 200 && 'msg' in response.body) {
						__WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
							text: response.body.msg,
							actionText: 'Cerrar',
							showAction: false,
							pos: 'top-right'
						});
						_this.$router.push('/puestos');
					} else {
						__WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
							text: response.body.error,
							actionText: 'Cerrar',
							showAction: false,
							pos: 'top-right',
							backgroundColor: '#F44336',
							actionTextColor: '#FFF'
						});
					}
				}, function (response) {
					__WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
						text: 'No se pudo establecer conexión con el servidor.',
						actionText: 'Cerrar',
						showAction: false,
						pos: 'top-right',
						backgroundColor: '#F44336',
						actionTextColor: '#FFF'
					});
				});
			}
		},
		validarCamposPuesto: function validarCamposPuesto() {
			!this.puesto.nombre_pue ? this.val.v_nombre = true : this.val.v_nombre = false;
			!this.puesto.descripcion_pue ? this.val.v_descripcion = true : this.val.v_descripcion = false;
			!this.puesto.depto_pue ? this.val.v_depto = true : this.val.v_depto = false;
			if (this.val.v_nombre || this.val.v_descripcion || this.val.v_depto) {
				__WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
					text: 'Por favor llene todos los campos marcados con *',
					actionText: 'Cerrar',
					showAction: false,
					pos: 'top-right',
					duration: 10000,
					backgroundColor: '#CC3D30',
					actionTextColor: '#FFF'
				});
				return false;
			} else {
				return true;
			}
		}
	},
	beforeCreate: function beforeCreate() {
		if (!this.$session.exists()) {
			this.$router.push('/login');
		}
	},
	data: function data() {
		return {
			puesto: {
				nombre_pue: null,
				descripcion_pue: null,
				depto_pue: null
			},
			val: {
				v_nombre: null,
				v_descripcion: null,
				v_depto: null
			}
		};
	}
});

/***/ }),

/***/ "fXg2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContratosNuevo',
  methods: {
    obtenerContrato: function obtenerContrato() {
      var _this = this;

      this.$http.post('contratos/', {
        token: this.$session.get('token'),
        contrato: this.$route.params.contrato
      }).then(function (response) {
        if (response.status === 200 && 'contrato' in response.body) {
          _this.contrato = response.body.contrato;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: 'Cerrar',
            pos: 'top-right',
            showAction: false,
            backgroundColor: '#F44336',
            actionTextColor: '#FFF'
          });
          _this.$router.push({ name: 'ContratosListado' });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: 'No se pudo establecer conexión con el servidor para obtener el contrato. Inténtelo de nuevo.',
          actionText: 'Cerrar',
          pos: 'top-right',
          showAction: false,
          backgroundColor: '#F44336',
          actionTextColor: '#FFF'
        });
        _this.$router.push({ name: 'ContratosListado' });
      });
    },
    actualizarContrato: function actualizarContrato() {
      var _this2 = this;

      if (this.validarCamposContrato()) {
        this.$http.post('contratos/actualizar', {
          token: this.$session.get('token'),
          contrato: this.$route.params.contrato,
          data: this.contrato
        }).then(function (response) {
          if (response.status === 200 && 'msg' in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: 'Cerrar',
              pos: 'top-right',
              showAction: false
            });
            _this2.$router.push({ name: 'ContratosListado' });
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: 'Cerrar',
              pos: 'top-right',
              showAction: false,
              backgroundColor: '#F44336',
              actionTextColor: '#FFF'
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: 'No se pudo establecer conexión con el servidor.',
            actionText: 'Cerrar',
            pos: 'top-right',
            showAction: false,
            backgroundColor: '#F44336',
            actionTextColor: '#FFF'
          });
        });
      }
    },
    validarCamposContrato: function validarCamposContrato() {
      !this.contrato.titulo_cnt ? this.val.v_titulo = true : this.val.v_titulo = false;
      this.contrato.contenido_cnt === '' ? this.val.v_contenido = true : this.val.v_contenido = false;
      !this.contrato.tipo_cnt ? this.val.v_tipo = true : this.val.v_tipo = false;
      !this.contrato.duracion_cnt ? this.val.v_duracion = true : this.val.v_duracion = false;
      if (this.val.v_titulo || this.val.v_contenido || this.val.v_tipo || this.val.v_duracion) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: 'Por favor llene todos los campos marcados con *',
          actionText: 'Cerrar',
          pos: 'top-right',
          showAction: false,
          backgroundColor: '#F44336',
          actionTextColor: '#FFF'
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.obtenerContrato();
  },
  data: function data() {
    return {
      msg: 'ContratosNuevo',
      contrato: {
        titulo_cnt: null,
        contenido_cnt: '',
        tipo_cnt: null,
        duracion_cnt: null
      },
      val: {
        v_titulo: null,
        v_contenido: null,
        v_tipo: null,
        v_duracion: null
      }
    };
  }
});

/***/ }),

/***/ "g+xY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"EmpleadosNuevo"},[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24","md-align":"center"}},[_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"50","md-flex-large":"45","md-flex-xlarge":"40"}},[_c('md-card',[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Información general del empleado")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nombre }},[_c('label',[_vm._v("Nombre")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.nombre_emn),callback:function ($$v) {_vm.empleado.nombre_emn=$$v},expression:"empleado.nombre_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_ap_pat }},[_c('label',[_vm._v("Ap. paterno")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.ap_pat_emn),callback:function ($$v) {_vm.empleado.ap_pat_emn=$$v},expression:"empleado.ap_pat_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_ap_mat }},[_c('label',[_vm._v("Ap. materno")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.ap_mat_emn),callback:function ($$v) {_vm.empleado.ap_mat_emn=$$v},expression:"empleado.ap_mat_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_fecha_nac }},[_c('label',[_vm._v("Formato día/mes/año")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],attrs:{"placeholder":"Fecha de nacimiento","required":""},model:{value:(_vm.empleado.fecha_nac_emn),callback:function ($$v) {_vm.empleado.fecha_nac_emn=$$v},expression:"empleado.fecha_nac_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_sexo }},[_c('label',{attrs:{"for":"sexo_emn"}},[_vm._v("Sexo")]),_vm._v(" "),_c('md-select',{attrs:{"name":"sexo_emn","id":"sexo_emn","required":""},model:{value:(_vm.empleado.sexo_emn),callback:function ($$v) {_vm.empleado.sexo_emn=$$v},expression:"empleado.sexo_emn"}},[_c('md-option',{attrs:{"value":"masculino"}},[_vm._v("Masculino")]),_vm._v(" "),_c('md-option',{attrs:{"value":"femenino"}},[_vm._v("Femenino")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_estado_civil }},[_c('label',{attrs:{"for":"estado_civil_emn"}},[_vm._v("Estado civíl")]),_vm._v(" "),_c('md-select',{attrs:{"name":"estado_civil_emn","id":"estado_civil_emn"},model:{value:(_vm.empleado.estado_civil_emn),callback:function ($$v) {_vm.empleado.estado_civil_emn=$$v},expression:"empleado.estado_civil_emn"}},[_c('md-option',{attrs:{"value":"soltero"}},[_vm._v("Soltero")]),_vm._v(" "),_c('md-option',{attrs:{"value":"casado"}},[_vm._v("Casado")]),_vm._v(" "),_c('md-option',{attrs:{"value":"divorciado"}},[_vm._v("Divorciado")]),_vm._v(" "),_c('md-option',{attrs:{"value":"unión libre"}},[_vm._v("Unión libre")]),_vm._v(" "),_c('md-option',{attrs:{"value":"viudo"}},[_vm._v("Viudo")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"80","md-flex-medium":"80","md-flex-large":"80","md-flex-xlarge":"80"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_direccion }},[_c('label',[_vm._v("Dirección")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.direccion_emn),callback:function ($$v) {_vm.empleado.direccion_emn=$$v},expression:"empleado.direccion_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"20","md-flex-medium":"20","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_num_ext }},[_c('label',[_vm._v("# ext.")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.num_ext_emn),callback:function ($$v) {_vm.empleado.num_ext_emn=$$v},expression:"empleado.num_ext_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"80","md-flex-medium":"80","md-flex-large":"80","md-flex-xlarge":"80"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_colonia }},[_c('label',[_vm._v("Colonia")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.colonia_emn),callback:function ($$v) {_vm.empleado.colonia_emn=$$v},expression:"empleado.colonia_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"20","md-flex-medium":"20","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_codigo_postal }},[_c('label',[_vm._v("C.P.")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.codigo_postal_emn),callback:function ($$v) {_vm.empleado.codigo_postal_emn=$$v},expression:"empleado.codigo_postal_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_municipio }},[_c('label',[_vm._v("Municipio")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.municipio_emn),callback:function ($$v) {_vm.empleado.municipio_emn=$$v},expression:"empleado.municipio_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_estado }},[_c('label',[_vm._v("Estado")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.estado_emn),callback:function ($$v) {_vm.empleado.estado_emn=$$v},expression:"empleado.estado_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"33","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tel }},[_c('label',[_vm._v("Teléfono")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],attrs:{"required":""},model:{value:(_vm.empleado.tel_emn),callback:function ($$v) {_vm.empleado.tel_emn=$$v},expression:"empleado.tel_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"33","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_cel }},[_c('label',[_vm._v("Celular")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],model:{value:(_vm.empleado.cel_emn),callback:function ($$v) {_vm.empleado.cel_emn=$$v},expression:"empleado.cel_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"33","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_email }},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.email_emn),callback:function ($$v) {_vm.empleado.email_emn=$$v},expression:"empleado.email_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"22"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_escolaridad }},[_c('label'),_vm._v(" "),_c('label',{attrs:{"for":"escolaridad_emn"}},[_vm._v("Escolaridad")]),_vm._v(" "),_c('md-select',{attrs:{"name":"escolaridad_emn","id":"escolaridad_emn"},model:{value:(_vm.empleado.escolaridad_emn),callback:function ($$v) {_vm.empleado.escolaridad_emn=$$v},expression:"empleado.escolaridad_emn"}},[_c('md-option',{attrs:{"value":"primaria"}},[_vm._v("Primaria")]),_vm._v(" "),_c('md-option',{attrs:{"value":"secundaria"}},[_vm._v("Secundaria")]),_vm._v(" "),_c('md-option',{attrs:{"value":"preparatoria"}},[_vm._v("Preparatoria")]),_vm._v(" "),_c('md-option',{attrs:{"value":"licenciatura"}},[_vm._v("Licenciatura")]),_vm._v(" "),_c('md-option',{attrs:{"value":"otro"}},[_vm._v("Otro")])],1)],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nss }},[_c('label',[_vm._v("NSS")]),_vm._v(" "),_c('md-input',{attrs:{"maxlength":"11","required":""},model:{value:(_vm.empleado.nss_emn),callback:function ($$v) {_vm.empleado.nss_emn=$$v},expression:"empleado.nss_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_curp }},[_c('label',[_vm._v("CURP")]),_vm._v(" "),_c('md-input',{attrs:{"maxlength":"18","required":""},model:{value:(_vm.empleado.curp_emn),callback:function ($$v) {_vm.empleado.curp_emn=$$v},expression:"empleado.curp_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_rfc }},[_c('label',[_vm._v("RFC")]),_vm._v(" "),_c('md-input',{attrs:{"maxlength":"13"},model:{value:(_vm.empleado.rfc_emn),callback:function ($$v) {_vm.empleado.rfc_emn=$$v},expression:"empleado.rfc_emn"}})],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_peso }},[_c('label',[_vm._v("Peso KGS")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","placeholder":"Peso"},model:{value:(_vm.empleado.peso_emn),callback:function ($$v) {_vm.empleado.peso_emn=$$v},expression:"empleado.peso_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_estatura }},[_c('label',[_vm._v("Estatura MTS")]),_vm._v(" "),_c('md-input',{attrs:{"placeholder":"Estatura","type":"number","step":".01"},model:{value:(_vm.empleado.estatura_emn),callback:function ($$v) {_vm.empleado.estatura_emn=$$v},expression:"empleado.estatura_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_camisa }},[_c('label',[_vm._v("Camisa")]),_vm._v(" "),_c('md-select',{attrs:{"name":"camisa_emn","id":"camisa_emn"},model:{value:(_vm.empleado.camisa_emn),callback:function ($$v) {_vm.empleado.camisa_emn=$$v},expression:"empleado.camisa_emn"}},[_c('md-option',{attrs:{"value":"32"}},[_vm._v("32")]),_vm._v(" "),_c('md-option',{attrs:{"value":"34"}},[_vm._v("34")]),_vm._v(" "),_c('md-option',{attrs:{"value":"36"}},[_vm._v("36")]),_vm._v(" "),_c('md-option',{attrs:{"value":"38"}},[_vm._v("38")]),_vm._v(" "),_c('md-option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('md-option',{attrs:{"value":"42"}},[_vm._v("42")]),_vm._v(" "),_c('md-option',{attrs:{"value":"44"}},[_vm._v("44")]),_vm._v(" "),_c('md-option',{attrs:{"value":"46"}},[_vm._v("46")]),_vm._v(" "),_c('md-option',{attrs:{"value":"48"}},[_vm._v("48")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_pantalon }},[_c('label',[_vm._v("Pantalón")]),_vm._v(" "),_c('md-select',{attrs:{"name":"pantalon_emn","id":"pantalon_emn"},model:{value:(_vm.empleado.pantalon_emn),callback:function ($$v) {_vm.empleado.pantalon_emn=$$v},expression:"empleado.pantalon_emn"}},[_c('md-option',{attrs:{"value":"28"}},[_vm._v("28")]),_vm._v(" "),_c('md-option',{attrs:{"value":"30"}},[_vm._v("30")]),_vm._v(" "),_c('md-option',{attrs:{"value":"32"}},[_vm._v("32")]),_vm._v(" "),_c('md-option',{attrs:{"value":"34"}},[_vm._v("34")]),_vm._v(" "),_c('md-option',{attrs:{"value":"36"}},[_vm._v("36")]),_vm._v(" "),_c('md-option',{attrs:{"value":"38"}},[_vm._v("38")]),_vm._v(" "),_c('md-option',{attrs:{"value":"40"}},[_vm._v("40")]),_vm._v(" "),_c('md-option',{attrs:{"value":"42"}},[_vm._v("42")]),_vm._v(" "),_c('md-option',{attrs:{"value":"44"}},[_vm._v("44")]),_vm._v(" "),_c('md-option',{attrs:{"value":"46"}},[_vm._v("46")]),_vm._v(" "),_c('md-option',{attrs:{"value":"48"}},[_vm._v("48")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_calzado }},[_c('label',[_vm._v("Calzado")]),_vm._v(" "),_c('md-select',{attrs:{"name":"calzado_emn","id":"calzado_emn"},model:{value:(_vm.empleado.calzado_emn),callback:function ($$v) {_vm.empleado.calzado_emn=$$v},expression:"empleado.calzado_emn"}},[_c('md-option',{attrs:{"value":"2"}},[_vm._v("2")]),_vm._v(" "),_c('md-option',{attrs:{"value":"2.5"}},[_vm._v("2.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3"}},[_vm._v("3")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3.5"}},[_vm._v("3.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4"}},[_vm._v("4")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4.5"}},[_vm._v("4.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5"}},[_vm._v("5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5.5"}},[_vm._v("5.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6"}},[_vm._v("6")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6.5"}},[_vm._v("6.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7"}},[_vm._v("7")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7.5"}},[_vm._v("7.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8"}},[_vm._v("8")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8.5"}},[_vm._v("8.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9"}},[_vm._v("9")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9.5"}},[_vm._v("9.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10"}},[_vm._v("10")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10.5"}},[_vm._v("10.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11"}},[_vm._v("11")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11.5"}},[_vm._v("11.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12"}},[_vm._v("12")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12.5"}},[_vm._v("12.5")]),_vm._v(" "),_c('md-option',{attrs:{"value":"13"}},[_vm._v("13")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_complexion }},[_c('label',[_vm._v("Complexión")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.complexion_emn),callback:function ($$v) {_vm.empleado.complexion_emn=$$v},expression:"empleado.complexion_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_ojos }},[_c('label',[_vm._v("Ojos")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.ojos_emn),callback:function ($$v) {_vm.empleado.ojos_emn=$$v},expression:"empleado.ojos_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_piel }},[_c('label',[_vm._v("Piel")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.piel_emn),callback:function ($$v) {_vm.empleado.piel_emn=$$v},expression:"empleado.piel_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_cabello }},[_c('label',[_vm._v("Cabello")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.cabello_emn),callback:function ($$v) {_vm.empleado.cabello_emn=$$v},expression:"empleado.cabello_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"33","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tipo_sangre }},[_c('label',[_vm._v("Sangre")]),_vm._v(" "),_c('md-select',{attrs:{"name":"tipo_sangre_emn","id":"tipo_sangre_emn"},model:{value:(_vm.empleado.tipo_sangre_emn),callback:function ($$v) {_vm.empleado.tipo_sangre_emn=$$v},expression:"empleado.tipo_sangre_emn"}},[_c('md-option',{attrs:{"value":"A−"}},[_vm._v("A−")]),_vm._v(" "),_c('md-option',{attrs:{"value":"A+"}},[_vm._v("A+")]),_vm._v(" "),_c('md-option',{attrs:{"value":"B−"}},[_vm._v("B−")]),_vm._v(" "),_c('md-option',{attrs:{"value":"B+"}},[_vm._v("B+")]),_vm._v(" "),_c('md-option',{attrs:{"value":"AB−"}},[_vm._v("AB−")]),_vm._v(" "),_c('md-option',{attrs:{"value":"AB+"}},[_vm._v("AB+")]),_vm._v(" "),_c('md-option',{attrs:{"value":"O-"}},[_vm._v("O-")]),_vm._v(" "),_c('md-option',{attrs:{"value":"O+"}},[_vm._v("O+")]),_vm._v(" "),_c('md-option',{attrs:{"value":"otro"}},[_vm._v("NO SABE")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"75","md-flex-small":"75","md-flex-medium":"75","md-flex-large":"75","md-flex-xlarge":"75"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_experiencia }},[_c('label',[_vm._v("Experiencia")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.experiencia_emn),callback:function ($$v) {_vm.empleado.experiencia_emn=$$v},expression:"empleado.experiencia_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"25","md-flex-small":"25","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_anos_exp }},[_c('label',[_vm._v("Años experiencia")]),_vm._v(" "),_c('md-input',{attrs:{"placeholder":"Años exp."},model:{value:(_vm.empleado.anos_exp_emn),callback:function ($$v) {_vm.empleado.anos_exp_emn=$$v},expression:"empleado.anos_exp_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"100","md-flex-xlarge":"100"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_foto }},[_c('label',[_vm._v("Foto empleado")]),_vm._v(" "),_c('md-file',{attrs:{"accept":"image/*"},on:{"selected":function($event){_vm.prepararArchivoASubir($event)}},model:{value:(_vm.foto_emn),callback:function ($$v) {_vm.foto_emn=$$v},expression:"foto_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"100","md-flex-xlarge":"100"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_observaciones }},[_c('label',[_vm._v("Observaciones")]),_vm._v(" "),_c('md-textarea',{model:{value:(_vm.empleado.observaciones_emn),callback:function ($$v) {_vm.empleado.observaciones_emn=$$v},expression:"empleado.observaciones_emn"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-column":"","md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"50","md-flex-large":"45","md-flex-xlarge":"40"}},[_c('md-card',[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Información familiar y de contacto")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nombre_conyuge }},[_c('label',[_vm._v("Nombre del cónyuge")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.nombre_conyuge_emn),callback:function ($$v) {_vm.empleado.nombre_conyuge_emn=$$v},expression:"empleado.nombre_conyuge_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tel_conyuge }},[_c('label',[_vm._v("Teléfono del cónyuge")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],model:{value:(_vm.empleado.tel_conyuge_emn),callback:function ($$v) {_vm.empleado.tel_conyuge_emn=$$v},expression:"empleado.tel_conyuge_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_hijos }},[_c('label',[_vm._v("Hijos")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","steps":"1"},model:{value:(_vm.empleado.hijos_emn),callback:function ($$v) {_vm.empleado.hijos_emn=$$v},expression:"empleado.hijos_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"30","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_dependientes }},[_c('label',[_vm._v("Dependientes")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","steps":"1"},model:{value:(_vm.empleado.dependientes_emn),callback:function ($$v) {_vm.empleado.dependientes_emn=$$v},expression:"empleado.dependientes_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"100","md-flex-large":"100","md-flex-xlarge":"100"}},[_c('md-button',{staticClass:"md-raised md-accent",nativeOn:{"click":function($event){_vm.conyugueCopiarAContacto()}}},[_vm._v("\n                Usar información de cónyugue como contacto\n              ")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"70","md-flex-medium":"70","md-flex-large":"70","md-flex-xlarge":"70"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_persona_contacto }},[_c('label',[_vm._v("Persona de contacto")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.persona_contacto_emn),callback:function ($$v) {_vm.empleado.persona_contacto_emn=$$v},expression:"empleado.persona_contacto_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"30","md-flex-medium":"30","md-flex-large":"30","md-flex-xlarge":"30"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_tel_contacto }},[_c('label',[_vm._v("Tel. contacto")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('(###) ###-####'),expression:"'(###) ###-####'"}],attrs:{"required":""},model:{value:(_vm.empleado.tel_contacto_emn),callback:function ($$v) {_vm.empleado.tel_contacto_emn=$$v},expression:"empleado.tel_contacto_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"75","md-flex-small":"75","md-flex-medium":"75","md-flex-large":"75","md-flex-xlarge":"75"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_direccion_contacto }},[_c('label',[_vm._v("Dirección de contacto")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.empleado.direccion_contacto_emn),callback:function ($$v) {_vm.empleado.direccion_contacto_emn=$$v},expression:"empleado.direccion_contacto_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"25","md-flex-small":"25","md-flex-medium":"25","md-flex-large":"25","md-flex-xlarge":"25"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_num_contacto }},[_c('label',[_vm._v("# ext")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.num_contacto_emn),callback:function ($$v) {_vm.empleado.num_contacto_emn=$$v},expression:"empleado.num_contacto_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"75","md-flex-medium":"75","md-flex-large":"75","md-flex-xlarge":"75"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_colonia_contacto }},[_c('label',[_vm._v("Colonia de contacto")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.colonia_contacto_emn),callback:function ($$v) {_vm.empleado.colonia_contacto_emn=$$v},expression:"empleado.colonia_contacto_emn"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('md-card',{staticClass:"m-t-24"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Configuración de nómina")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Seleccione el puesto y plan de pago del empleado")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_puesto }},[_c('label',{attrs:{"for":"puesto_epn"}},[_vm._v("Puesto")]),_vm._v(" "),_c('md-select',{attrs:{"name":"puesto_epn","id":"puesto_epn","required":""},model:{value:(_vm.empleado.puesto_epn),callback:function ($$v) {_vm.empleado.puesto_epn=$$v},expression:"empleado.puesto_epn"}},_vm._l((_vm.puestosListado),function(p){return _c('md-option',{key:p.id_pue,attrs:{"value":p.id_pue}},[_vm._v("\n                    "+_vm._s(p.nombre_pue)+"\n                    "),_c('span',[_c('small',[_vm._v(", "+_vm._s(p.depto_pue.toUpperCase())+" ")])])])}))],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_id_pln }},[_c('label',{attrs:{"for":"id_pln_eph"}},[_vm._v("Plan de pago")]),_vm._v(" "),_c('md-select',{attrs:{"name":"id_pln_eph","id":"id_pln_eph","required":""},model:{value:(_vm.empleado.id_pln_eph),callback:function ($$v) {_vm.empleado.id_pln_eph=$$v},expression:"empleado.id_pln_eph"}},_vm._l((_vm.planesListado),function(pln){return _c('md-option',{key:pln.id_pln,attrs:{"value":pln.id_pln}},[_vm._v("\n                    "+_vm._s(pln.nombre_pln)+"\n                    "),_c('span',[_c('small',[_vm._v(", "+_vm._s(Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(pln.salario_qnal_pnh))+" ")])])])}))],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.id_cnt_ecn }},[_c('label',{attrs:{"for":"id_cnt_ecn"}},[_vm._v("Contrato")]),_vm._v(" "),_c('md-select',{attrs:{"name":"id_cnt_ecn","id":"id_cnt_ecn","required":""},model:{value:(_vm.empleado.id_cnt_ecn),callback:function ($$v) {_vm.empleado.id_cnt_ecn=$$v},expression:"empleado.id_cnt_ecn"}},_vm._l((_vm.contratos),function(cnt){return _c('md-option',{key:cnt.id_cnt,attrs:{"value":cnt.id_cnt}},[_vm._v("\n                    "+_vm._s(cnt.titulo_cnt)+"\n                    "),_c('span',[_c('small',[_vm._v(", duración: "+_vm._s(cnt.duracion_cnt))])])])}))],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"33","md-flex-medium":"50","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_cuenta_ban }},[_c('label',[_vm._v("Cuenta bancaria")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.empleado.cuenta_ban_emn),callback:function ($$v) {_vm.empleado.cuenta_ban_emn=$$v},expression:"empleado.cuenta_ban_emn"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"40","md-flex-medium":"40","md-flex-large":"35","md-flex-xlarge":"33"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_fecha_ing }},[_c('label',[_vm._v("Fecha ingreso dia/mes/año")]),_vm._v(" "),_c('md-input',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],attrs:{"placeholder":"Fecha ingreso"},model:{value:(_vm.empleado.fecha_ing_emn),callback:function ($$v) {_vm.empleado.fecha_ing_emn=$$v},expression:"empleado.fecha_ing_emn"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('md-card',{staticClass:"m-t-24"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Percepciones y deducciones")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"45","md-flex-large":"45","md-flex-xlarge":"45"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_concepto }},[_c('label',{attrs:{"for":"concepto"}},[_vm._v("Conceptos")]),_vm._v(" "),_c('md-select',{attrs:{"name":"concepto","id":"concepto"},model:{value:(_vm.con_add.concepto),callback:function ($$v) {_vm.con_add.concepto=$$v},expression:"con_add.concepto"}},_vm._l((_vm.conceptosListado),function(c){return _c('md-option',{key:c.id_con,attrs:{"value":c.id_con},nativeOn:{"click":function($event){_vm.valoresConcepto(c)}}},[_vm._v("\n                    "+_vm._s(c.desc_con)+"\n                    "),_c('span',[_c('small',[_vm._v(", "+_vm._s(c.tipo_con.toUpperCase())+", "+_vm._s(Intl.NumberFormat("es-MX", {style: "currency", currency: "MXN"}).format(c.importe_cnh))+"\n                      ")])])])}))],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"40","md-flex-small":"40","md-flex-medium":"20","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_quincenas }},[_c('label',[_vm._v("Semanas")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"1","steps":"1"},nativeOn:{"blur":function($event){_vm.calcularImporteQuincenal()},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.agregarConcepto()}},model:{value:(_vm.con_add.quincenas),callback:function ($$v) {_vm.con_add.quincenas=$$v},expression:"con_add.quincenas"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"40","md-flex-small":"40","md-flex-medium":"20","md-flex-large":"20","md-flex-xlarge":"20"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_importe_qnal }},[_c('label',[_vm._v("Importe smna.")]),_vm._v(" "),_c('md-input',{attrs:{"disabled":""},model:{value:(_vm.con_add.importe_qnal),callback:function ($$v) {_vm.con_add.importe_qnal=$$v},expression:"con_add.importe_qnal"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-align":"rigth","md-flex-xsmall":"20","md-flex-small":"20","md-flex-medium":"15","md-flex-large":"15","md-flex-xlarge":"15"}},[_c('md-button',{staticClass:"md-icon-button md-raised md-accent",nativeOn:{"click":function($event){_vm.agregarConcepto()}}},[_c('md-icon',[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),(_vm.conceptosNomina.length >=1)?_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head'),_vm._v(" "),_c('md-table-head',[_vm._v("Concepto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Importe")]),_vm._v(" "),_c('md-table-head',[_vm._v("Quincenas")]),_vm._v(" "),_c('md-table-head',[_vm._v("Importe qnal")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.conceptosNomina),function(con){return _c('md-table-row',{key:con.id_con},[_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.removerConcepto(con)}}},[_c('md-icon',[_vm._v("delete")])],1)],1),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(con.desc_con))]),_vm._v(" "),_c('md-table-cell',[_vm._v("$"+_vm._s(con.importe_con))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(con.quincenas_con))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(con.importe_qnal_con))])],1)}))],1):_vm._e(),_vm._v(" "),_c('md-card-actions',[_c('md-button',[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.guardarEmpleado()}}},[_vm._v("Registrar empleado")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gbz0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AdelantosNominaSupervisor",
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data: function data() {
    return {
      msg: "AdelantosNominaSupervisor",
      autocompleteValue: null,
      editorTexto: "hola"
    };
  }
});

/***/ }),

/***/ "h+nz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net__ = __webpack_require__("FNwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContratosListado',
  methods: {
    obtenerContratos: function obtenerContratos() {
      var _this = this;

      this.$http.post('contratos', {
        token: this.$session.get('token')
      }).then(function (response) {
        if (response.status === 200 && 'contratos' in response.body) {
          _this.contratos = response.body.contratos;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: 'No se pudo establecer conexión con el servidor.',
          actionText: 'Cerrar',
          pos: 'top-right',
          showAction: false,
          backgroundColor: '#F44336',
          actionTextColor: '#FFF'
        });
      });
    },
    cambiarEstatusContrato: function cambiarEstatusContrato(c) {
      var _this2 = this;

      this.$http.post('contratos/estatus', {
        token: this.$session.get('token'),
        contrato: __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(c.id_cnt)),
        estatus: c.estatus_ctn
      }).then(function (response) {
        if (response.status === 200 && 'contratos' in response.body) {
          _this2.contratos = response.body.contratos;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: 'No se pudo establecer conexión con el servidor.',
          actionText: 'Cerrar',
          pos: 'top-right',
          showAction: false,
          backgroundColor: '#F44336',
          actionTextColor: '#FFF'
        });
      });
    },
    irAEditarContratos: function irAEditarContratos(id_cnt) {
      this.$router.push({ name: 'ContratosEditar', params: { contrato: __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(id_cnt)) } });
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.obtenerContratos();
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.md-table table').DataTable();
  },
  data: function data() {
    return {
      msg: 'ContratosListado',
      contratos: []
    };
  }
});

/***/ }),

/***/ "h5F4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AdelantosNominaAdministrativo"},[_c('md-table-card',{staticClass:"m-t-24"},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Empleados candidatos para adelanto de nómina")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v(" # emp ")]),_vm._v(" "),_c('md-table-head',[_vm._v(" Nombre ")]),_vm._v(" "),_c('md-table-head',[_vm._v(" Puesto ")]),_vm._v(" "),_c('md-table-head',[_vm._v(" Punto ")]),_vm._v(" "),_c('md-table-head')],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.empleados),function(empleado){return _c('md-table-row',{key:empleado.id_emn},[_c('md-table-cell',[_vm._v(_vm._s(empleado.id_emn)+" ")]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(empleado.nombre_empleado)+" ")]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(empleado.nombre_pue)+" ")]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(empleado.nombre_pun)+" ")]),_vm._v(" "),_c('md-table-cell',[_c('md-input-container',[_c('md-icon',[_vm._v("attach_money")]),_vm._v(" "),_c('label',[_vm._v("Importe")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"0","max":empleado.salario_qnal_pnh,"placeholder":"Solicitó"},on:{"blur":function($event){_vm.hizoBlur(empleado.nombre_empleado,empleado.id_emn,empleado.salario_qnal_pnh,$event)}}})],1)],1)],1)}))],1),_vm._v(" "),_c('md-card-actions',[_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.guardarAdelantos()}}},[_vm._v("Guardar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iQjG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PuntosSeleccionarCliente m-t-16"},[_c('md-table-card',[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Seleccione el cliente del punto")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Cuenta")]),_vm._v(" "),_c('md-table-head',[_vm._v("Razón social")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.clientes),function(cliente,index){return _c('md-table-row',{key:index},[_c('md-table-cell',[_vm._v(_vm._s(cliente.cuenta))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(cliente.nombre.toUpperCase()))]),_vm._v(" "),_c('md-table-cell',[_c('md-button',{staticClass:"md-raised md-accent",staticStyle:{"width":"auto!important"},nativeOn:{"click":function($event){_vm.irANuevoPlan(cliente.cliente)}}},[_vm._v("\n              Seleccionar\n            ")])],1)],1)}))],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jMm/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuntosListado_vue__ = __webpack_require__("mHlC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7525db5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuntosListado_vue__ = __webpack_require__("u9Nx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuntosListado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7525db5c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuntosListado_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jR06":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jmP/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PuntosNuevo',
  methods: {
    obtenerPunto: function obtenerPunto() {
      var _this = this;

      this.$http.post('puntos/obtener', {
        token: this.$session.get('token'),
        id: this.$route.params.punto
      }).then(function (response) {
        if (response.status === 200 && 'punto' in response.body) {
          _this.punto = response.body.punto;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: 'Cerrar',
            showAction: false,
            pos: 'top-right',
            backgroundColor: '#F44336',
            actionTextColor: '#FFF'
          });
          //this.$router.push('/puntos');
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: 'No se pudo establecer conexión con el servidor.',
          actionText: 'Cerrar',
          showAction: false,
          pos: 'top-right',
          backgroundColor: '#F44336',
          actionTextColor: '#FFF'
        });
        //this.$router.push('/puntos');
      });
    },
    actualizarPunto: function actualizarPunto() {
      var _this2 = this;

      if (this.validarInformacion()) {
        this.$http.post('puntos/actualizar', {
          token: this.$session.get('token'),
          data: this.punto,
          id: this.$route.params.punto
        }).then(function (response) {
          if (response.status === 200 && 'msg' in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: 'Cerrar',
              showAction: false,
              pos: 'top-right'
            });
            _this2.$router.push('/puntos');
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: 'Cerrar',
              showAction: false,
              pos: 'top-right',
              backgroundColor: '#F44336',
              actionTextColor: '#FFF'
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: 'No se pudo establecer conexión con el servidor.',
            actionText: 'Cerrar',
            showAction: false,
            pos: 'top-right',
            backgroundColor: '#F44336',
            actionTextColor: '#FFF'
          });
        });
      }
    },
    validarInformacion: function validarInformacion() {
      !this.punto.nombre_pun ? this.val.v_nombre = true : this.val.v_nombre = false;
      !this.punto.guardias_pun ? this.val.v_guardias = true : this.val.v_guardias = false;
      !this.punto.presupuesto_pun ? this.val.v_presupuesto = true : this.val.v_presupuesto = false;
      !this.punto.calle_pun ? this.val.v_calle = true : this.val.v_calle = false;
      !this.punto.num_ext_pun ? this.val.v_num_ext = true : this.val.v_num_ext = false;
      if (this.val.v_nombre || this.val.v_guardias || this.val.v_presupuesto || this.val.v_calle || this.val.v_num_ext) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: 'Por favor llene todos los campos marcados con *',
          actionText: 'Cerrar',
          showAction: false,
          pos: 'top-right',
          duration: 10000,
          backgroundColor: '#CC3D30',
          actionTextColor: '#FFF'
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push('/login');
    }
  },
  created: function created() {
    this.obtenerPunto();
  },
  data: function data() {
    return {
      msg: 'Inicio',
      punto: {
        id_cli_pun: null,
        nombre_pun: null,
        guardias_pun: null,
        presupuesto_pun: null,
        calle_pun: null,
        num_ext_pun: null,
        colonia_pun: null,
        cp_pun: null,
        municipio_pun: null,
        estado_pun: null,
        notas_pun: null,
        //Información del cliente
        cuenta: null,
        nombre: null,
        rfc: null,
        email: null,
        telefono: null,
        estado: null,
        municipio: null,
        ciudad: null,
        calle: null,
        colonia: null,
        numero: null,
        codigo_postal: null,
        notas: null
      },
      val: {
        v_nombre: null,
        v_guardias: null,
        v_presupuesto: null,
        v_calle: null,
        v_num_ext: null
      }
    };
  }
});

/***/ }),

/***/ "kmVm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AsistenciasPuntoSeleccionado_vue__ = __webpack_require__("wtFc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1fb56a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AsistenciasPuntoSeleccionado_vue__ = __webpack_require__("brux");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AsistenciasPuntoSeleccionado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1fb56a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AsistenciasPuntoSeleccionado_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l24A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "inicio",
  methods: {
    moment: function moment(a, b) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(a, b);
    },
    numberFormat: function numberFormat(importe) {
      return Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN"
      }).format(importe);
    },
    obtenerEmpleado: function obtenerEmpleado() {
      var _this = this;

      this.$http.post("empleados/detalle", {
        token: this.$session.get("token"),
        empleado: this.$route.params.empleado
      }).then(function (response) {
        if (response.status === 200 && "empleado" in response.body) {
          _this.empleado = response.body.empleado;
          _this.roles_activos = response.body.roles_activos;
          _this.roles_inactivos = response.body.roles_inactivos;
          _this.per_ded_activos = response.body.per_ded_activos;
          _this.per_ded_inactivos = response.body.per_ded_inactivos;
          _this.salarios_historial = response.body.salarios_historial;
          _this.planDePago = response.body.empleado.id_pln_pnh;
          _this.planDePagoOld = response.body.empleado.id_pln_pnh;
          if (_this.empleado.foto_emn) {
            _this.foto = "http://api.grupoalarcom.mx/archivos/" + _this.$route.params.empleado + "/" + _this.empleado.foto_emn;
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se encontró el empleado que busca. Inténtelo de nuevo.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
          _this.$router.push("/empleados");
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        _this.$router.push("/empleados");
      });
    },

    //FUNCIONES PARA CONCEPTOS
    obtenerConceptos: function obtenerConceptos() {
      var _this2 = this;

      this.$http.post("conceptos", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "conceptos" in response.body) {
          _this2.conceptosListado = response.body.conceptos;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudieron obtener los conceptos de nómina. Recargue la página.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    valoresConcepto: function valoresConcepto(c) {
      this.con_add.id = c.id_con;
      this.con_add.desc = c.desc_con;
      this.con_add.tipo = c.tipo_con;
      this.con_add.importe = c.importe_cnh;
      this.con_add.quincenas = 1;
      this.con_add.importe_qnal = c.importe_cnh;
    },
    calcularImporteQuincenal: function calcularImporteQuincenal() {
      this.con_add.importe_qnal = this.numberFormat(this.con_add.importe / this.con_add.quincenas);
    },
    agregarConcepto: function agregarConcepto() {
      this.conceptosNomina.push({
        id_con: this.con_add.id,
        desc_con: this.con_add.desc,
        tipo_con: this.con_add.tipo,
        importe_con: this.con_add.importe,
        quincenas_con: this.con_add.quincenas,
        importe_qnal_con: this.con_add.importe_qnal
      });
      this.con_add.concepto = null;
      this.con_add.quincenas = 1;
      this.con_add.importe_qnal = 0;
    },
    guardarConceptos: function guardarConceptos() {
      var _this3 = this;

      this.$http.post("conceptos/asignar", {
        token: this.$session.get("token"),
        empleado: this.empleado.id_emn,
        conceptos: this.conceptosNomina
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          _this3.per_ded_activos = response.body.per_ded_activos;
          _this3.per_ded_inactivos = response.body.per_ded_inactivos;
          _this3.conceptosNomina = [];
          _this3.con_add.concepto = null;
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            pos: "top-right"
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    validarConcepto: function validarConcepto() {},
    removerConcepto: function removerConcepto(c) {
      this.conceptosNomina.splice(c, 1);
    },

    //Suspención y activación de conceptos
    cambiarEstatusConcepto: function cambiarEstatusConcepto(id_pdn, estatus) {
      var _this4 = this;

      this.$http.post("conceptos/estatus", {
        token: this.$session.get("token"),
        concepto: id_pdn,
        estatus: estatus,
        empleado: this.$route.params.empleado
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          _this4.per_ded_activos = response.body.per_ded_activos;
          _this4.per_ded_inactivos = response.body.per_ded_inactivos;
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            pos: "top-right"
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },

    //Manejo de planes de pago
    obtenerPlanes: function obtenerPlanes() {
      var _this5 = this;

      this.$http.post("planes", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "planes" in response.body) {
          _this5.planesListado = response.body.planes;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor para obtener los planes de pago.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    cambiarPlanDePago: function cambiarPlanDePago() {
      var _this6 = this;

      this.$http.post("planes/asignar", {
        token: this.$session.get("token"),
        empleado: this.empleado.id_emn,
        plan: this.planDePago
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            pos: "top-right"
          });
          _this6.obtenerEmpleado();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
      this.cerrarModal("modalCambiarPlanPago");
    },

    //Otros
    irEditarEmpleado: function irEditarEmpleado() {
      this.$router.push({
        name: "EmpleadosEditar",
        params: { empleado: this.$route.params.empleado }
      });
    },
    abrirModal: function abrirModal(m) {
      this.$refs[m].open();
    },
    cerrarModal: function cerrarModal(m) {
      this.$refs[m].close();
    },

    //Manejo de imagen del empleado
    prepararArchivoASubir: function prepararArchivoASubir(e) {
      this.foto_subir = e[0];
    },
    subirFoto: function subirFoto() {
      var _this7 = this;

      var formData = new FormData();
      formData.append("token", this.$session.get("token"));
      formData.append("empleado", this.$route.params.empleado);
      formData.append("foto", this.foto_subir);
      this.$http.post("empleados/fotografia", formData).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false
          });
          _this7.$router.push("/empleados");
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudieron obtener los puestos de empleado. Recargue la página.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created: function created() {
    this.obtenerEmpleado();
  },
  mounted: function mounted() {
    //Lo hacemos despues ya que no es importante
    this.obtenerConceptos();
    this.obtenerPlanes();
  },
  data: function data() {
    return {
      msg: "Inicio",
      editar_nomina: this.$parent.permisos_editar_nomina,
      empleado: {},
      roles_activos: [],
      roles_inactivos: [],
      per_ded_activos: [],
      per_ded_inactivos: [],
      salarios_historial: [],
      planesListado: [],
      planDePago: null,
      val: {
        v_con_id: null,
        v_con_desc: null,
        v_con_importe: null,
        v_con_quincenas: null,
        v_con_importe_qnal: null
      },
      con_add: {
        id: null,
        desc: null,
        importe: 0,
        quincenas: 1,
        importe_qnal: 0
      },
      conceptosNomina: [],
      conceptosListado: [],
      foto_emn: null,
      foto_subir: null,
      foto: null
    };
  }
});

/***/ }),

/***/ "l2RU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net__ = __webpack_require__("FNwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PuntosSeleccionarCliente",
  methods: {
    obtenerClientes: function obtenerClientes() {
      var _this = this;

      this.$http.post("clientes", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "clientes" in response.body) {
          _this.clientes = response.body.clientes;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    irANuevoPlan: function irANuevoPlan(id) {
      this.$router.push({ name: "PuntosNuevo", params: { cliente: id } });
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  beforeMount: function beforeMount() {
    this.obtenerClientes();
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".md-table table").DataTable();
  },
  data: function data() {
    return {
      clientes: []
    };
  }
});

/***/ }),

/***/ "l8Z8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesNuevo_vue__ = __webpack_require__("vJd7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aba903f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesNuevo_vue__ = __webpack_require__("QlS8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesNuevo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aba903f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesNuevo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mAfs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PlanesNuevo",
  methods: {
    regresarAPlanes: function regresarAPlanes() {
      this.$router.push("/planes");
    },
    obtenerPlan: function obtenerPlan() {
      var _this = this;

      if (this.$route.params.id) {
        this.$http.post("planes", {
          data: this.plan,
          token: this.$session.get("token"),
          id: this.$route.params.id
        }).then(function (response) {
          if (response.status === 200 && "plan" in response.body) {
            _this.plan = response.body.plan;
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
            _this.$router.push("/inicio");
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
          _this.$router.push("/inicio");
        });
      }
    },
    actualizarPlan: function actualizarPlan() {
      var _this2 = this;

      if (this.validarCamposPlan()) {
        this.$http.post("planes/actualizar", {
          data: this.plan,
          token: this.$session.get("token"),
          id: this.$route.params.id
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false
            });
            _this2.$router.push("/planes");
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      }
    },
    validarCamposPlan: function validarCamposPlan() {
      !this.plan.salario_qnal_pnh ? this.val.v_salario_qnal = true : this.val.v_salario_qnal = false;
      !this.plan.falta_just_pnh ? this.val.v_falta_just = true : this.val.v_falta_just = false;
      !this.plan.falta_injust_pnh ? this.val.v_falta_injust = true : this.val.v_falta_injust = false;
      !this.plan.permiso_pnh ? this.val.v_permiso = true : this.val.v_permiso = false;
      !this.plan.permiso_falle_pnh ? this.val.v_permiso_falle = true : this.val.v_permiso_falle = false;
      !this.plan.permiso_naci_pnh ? this.val.v_permiso_naci = true : this.val.v_permiso_naci = false;
      !this.plan.hora_tie_ext_pnh ? this.val.v_hora_tie_ext = true : this.val.v_hora_tie_ext = false;
      !this.plan.tie_ext_pnh ? this.val.v_tie_ext = true : this.val.v_tie_ext = false;
      !this.plan.doble_turno_pnh ? this.val.v_doble_turno = true : this.val.v_doble_turno = false;
      !this.plan.dia_festivo_pnh ? this.val.v_dia_festivo = true : this.val.v_dia_festivo = false;
      !this.plan.dia_tresuno_pnh ? this.val.v_dia_tresuno = true : this.val.v_dia_tresuno = false;
      !this.plan.dia_dosocho_pnh ? this.val.v_dia_dosocho = true : this.val.v_dia_dosocho = false;
      if (this.val.v_salario_qnal || this.val.v_falta_just || this.val.v_falta_injust || this.val.v_permiso || this.val.v_permiso_falle || this.val.v_permiso_naci || this.val.v_hora_tie_ext || this.val.v_tie_ext || this.val.v_doble_turno || this.val.v_dia_festivo || this.val.v_dia_tresuno || this.val.v_dia_dosocho) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Por favor llene todos los campos",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        console.log("validacion de form trabajo retorno true");
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created: function created() {
    this.obtenerPlan();
  },
  data: function data() {
    return {
      msg: "Inicio",
      plan: {
        nombre_pln: null,
        salario_qnal_pnh: null,
        falta_just_pnh: null,
        falta_injust_pnh: null,
        permiso_pnh: null,
        permiso_falle_pnh: null,
        permiso_naci_pnh: null,
        hora_tie_ext_pnh: null,
        tie_ext_pnh: null,
        doble_turno_pnh: null,
        dia_festivo_pnh: null,
        dia_tresuno_pnh: null,
        dia_dosocho_pnh: null
      },
      val: {
        v_salario_qnal: null,
        v_falta_just: null,
        v_falta_injust: null,
        v_permiso: null,
        v_permiso_falle: null,
        v_permiso_naci: null,
        v_hora_tie_ext: null,
        v_tie_ext: null,
        v_doble_turno: null,
        v_dia_festivo: null,
        v_dia_tresuno: null,
        v_dia_dosocho: null
      }
    };
  }
});

/***/ }),

/***/ "mGaK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesEditar_vue__ = __webpack_require__("8NWe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d95d75d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesEditar_vue__ = __webpack_require__("JPfg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesEditar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d95d75d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesEditar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mHlC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net__ = __webpack_require__("FNwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PuntosListado",
  methods: {
    moment: function moment(a, b) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(a, b);
    },
    obtenerPuntos: function obtenerPuntos() {
      var _this = this;

      this.$http.post("puntos", {
        token: this.$session.get("token"),
        estatus: "activos"
      }).then(function (response) {
        if (response.status === 200 && "puntos" in response.body) {
          _this.puntos = response.body.puntos;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    obtenerContratos: function obtenerContratos() {
      var _this2 = this;

      this.$http.post("contratos", {
        token: this.$session.get("token"),
        tipo: "servicios_guardias"
      }).then(function (response) {
        if (response.status === 200 && "contratos" in response.body) {
          _this2.contratos = response.body.contratos;
        } else {
          /*
          Snackbar.show({ text: response.body.error, actionText: "Cerrar", showAction: false, pos: "top-right", backgroundColor: "#F44336", actionTextColor: "#FFF" });
          */
        }
      }, function (response) {
        /*
        Snackbar.show({ text: "No se pudo establecer conexión con el servidor para obtener los contratos.", actionText: "Cerrar", showAction: false, pos: "top-right", backgroundColor: "#F44336", actionTextColor: "#FFF" });
        */
      });
    },
    abrirModalEditarTurnos: function abrirModalEditarTurnos(punto) {
      this.punto = punto;
      this.obtenerTurnosPunto(punto.punto);
      this.abrirModal("modalEditarTurnos");
    },
    cerrarModalEditarTurnos: function cerrarModalEditarTurnos() {
      this.cerrarModal("modalEditarTurnos");
      this.turnosPunto = null;
      this.punto = null;
    },
    abrirModalAgregarTurnos: function abrirModalAgregarTurnos(punto) {
      this.punto = punto;
      this.abrirModal("modalAgregarTurnos");
    },
    cerrarModalAgregarTurnos: function cerrarModalAgregarTurnos(punto) {
      this.cerrarModal("modalAgregarTurnos");
      this.punto = null;
    },
    abrirModalSeleccionarTurno: function abrirModalSeleccionarTurno(punto) {
      this.punto = punto;
      this.obtenerTurnosPunto(punto);
      this.abrirModal("modalSeleccionarTurno");
    },
    cerrarModalSeleccionarTurno: function cerrarModalSeleccionarTurno() {
      this.turnosPunto = null;
      this.punto = null;
      this.cerrarModal("modalSeleccionarTurno");
    },

    //MANEJO DE CONTRATOS
    abrirModalSubirContrato: function abrirModalSubirContrato(punto) {
      this.punto = punto;
      this.abrirModal("modalSubirContrato");
    },
    abrirVentanaGenerarContrato: function abrirVentanaGenerarContrato(ep) {
      window.open("http://api.grupoalarcom.mx/contratos/pdf?a=p&n=" + ep, "_blank");
    },
    guardarArchivoContrato: function guardarArchivoContrato() {
      var _this3 = this;

      if (this.hayContratoAnexado()) {
        this.cerrarModal("modalSubirContrato");
        this.abrirModal("subiendoArchivo");
        var formData = new FormData();
        formData.append("token", this.$session.get("token"));
        formData.append("punto", this.punto.punto);
        formData.append("archivo", this.archivo_contrato);
        this.$http.post("puntos/subirContrato", formData).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              pos: "top-right",
              actionText: "Cerrar",
              showAction: false,
              duration: 20000
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#CC3D30",
              actionTextColor: "#FFF"
            });
          }
          _this3.cerrarModal("subiendoArchivo");
          _this3.obtenerPuntos();
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor. Inténtelo de nuevo.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#CC3D30",
            actionTextColor: "#FFF"
          });
          _this3.cerrarModal("subiendoArchivo");
          _this3.obtenerPuntos();
        });
      }
    },
    prepararContratoSubir: function prepararContratoSubir(e) {
      this.archivo_contrato = e[0];
    },
    hayContratoAnexado: function hayContratoAnexado() {
      if (this.archivo_contrato) {
        return true;
      } else {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Debe seleccionar el archivo de su investigación",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      }
    },
    abrirModalEdicionContratos: function abrirModalEdicionContratos(punto) {
      this.punto = punto;
      this.obtenerContratosPunto(punto.punto);
      this.abrirModal("modalEdicionContratos");
    },
    suspenderContrato: function suspenderContrato(p, c) {
      var _this4 = this;

      this.$http.post("contratos/suspenderDePunto", {
        token: this.$session.get("token"),
        punto: __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(p)),
        contrato: __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(c))
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right"
          });
          _this4.obtenerContratosPunto(__WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(p)));
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor para suspender los contratos.",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    anadirContrato: function anadirContrato(p) {
      var _this5 = this;

      this.$http.post("contratos/anadirContrato", {
        token: this.$session.get("token"),
        punto: p,
        contrato: this.contrato_nuevo
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right"
          });
          _this5.cerrarModal("modalEdicionContratos");
          _this5.contrato_nuevo = null;
          _this5.obtenerPuntos();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor para agregar contratos al punto.",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    obtenerContratosPunto: function obtenerContratosPunto(id_pun) {
      var _this6 = this;

      this.$http.post("contratos/punto", {
        token: this.$session.get("token"),
        punto: id_pun
      }).then(function (response) {
        if (response.status === 200 && "contratos" in response.body) {
          _this6.contratos_punto = response.body.contratos;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor para obtener los contratos del punto.",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },

    //FIN MANEJO DE CONTRATOS
    agregarTurno: function agregarTurno() {
      if (this.validarSelectsTurno()) {
        this.turnosNuevos.push({
          inicio_ptu: this.turno.inicio_ptu,
          termino_ptu: this.turno.termino_ptu
        });
        this.turno.inicio_ptu = null;
        this.turno.termino_ptu = null;
        this.val.v_inicio_tur = null;
        this.val.v_fin_tur = null;
      }
    },
    existenTurnosRegistrados: function existenTurnosRegistrados() {
      if (this.turnosNuevos.length > 0) {
        return true;
      } else {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Debe agregar por lo menos un turno",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      }
    },
    validarSelectsTurno: function validarSelectsTurno() {
      !this.turno.inicio_ptu ? this.val.v_inicio_tur = true : this.val.v_inicio_tur = false;
      !this.turno.termino_ptu ? this.val.v_fin_tur = true : this.val.v_fin_tur = false;
      if (this.val.v_fin_tur || this.val.v_inicio_tur) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Por favor seleccione los horarios del turno",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    },
    guardarTurnos: function guardarTurnos() {
      var _this7 = this;

      if (this.existenTurnosRegistrados()) {
        this.$http.post("turnos/guardar", {
          token: this.$session.get("token"),
          punto: this.punto.id_pun,
          turnos: this.turnosNuevos
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right"
            });
            _this7.$refs["modalAgregarTurnos"].close();
            _this7.punto = null;
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      }
    },
    obtenerTurnosPunto: function obtenerTurnosPunto(id) {
      var _this8 = this;

      this.$http.post("puntos/turnos", {
        token: this.$session.get("token"),
        id: id
      }).then(function (response) {
        if (response.status === 200 && "turnos" in response.body) {
          _this8.turnosPunto = response.body.turnos;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    removerTurnoNuevo: function removerTurnoNuevo(index) {
      this.turnosNuevos.splice(index, 1);
    },
    cambiarEstatusTurno: function cambiarEstatusTurno(turno, estatus) {
      var _this9 = this;

      this.$http.post("turnos/estatus", {
        token: this.$session.get("token"),
        turno: turno,
        estatus: estatus
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right"
          });
          _this9.obtenerTurnosPunto(_this9.punto.punto);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    irAEditarPunto: function irAEditarPunto(id) {
      this.$router.push({ name: "PuntosEditar", params: { punto: id } });
    },
    irEditarRolesTurno: function irEditarRolesTurno(id) {
      this.$router.push({
        name: "PuntosRoles",
        params: { turno: __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(id)) }
      });
    },
    abrirModal: function abrirModal(ref) {
      this.$refs[ref].open();
    },
    cerrarModal: function cerrarModal(ref) {
      this.$refs[ref].close();
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  beforeMount: function beforeMount() {
    this.obtenerPuntos();
    this.obtenerContratos();
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".md-table.tablita > table").DataTable();
  },
  data: function data() {
    return {
      editar: this.$parent.permisos_editar_nomina,
      single: null,
      puntos: [],
      contratos: [],
      contratos_punto: [],
      contrato_nuevo: null,
      punto: {},
      turnosPunto: [],
      turno: {
        inicio_ptu: null,
        termino_ptu: null
      },
      turnosNuevos: [],
      archivo_contrato: null,
      val: {
        v_inicio_tur: null,
        v_fin_tur: null
      }
    };
  }
});

/***/ }),

/***/ "n+S8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inicio"},[_c('h1',[_vm._v("Inicio")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n4ir":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PuntosDetalle',
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push('/login');
    }
  },
  data: function data() {
    return {
      msg: 'Inicio'
    };
  }
});

/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Login",
  beforeCreate: function beforeCreate() {
    this.$session.destroy();
  },
  created: function created() {
    this.$session.destroy();
  },

  methods: {
    hacerLogin: function hacerLogin() {
      var _this = this;

      this.$http.post("sesion/login", {
        u: __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(this.u)),
        p: __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(this.p))
      }).then(function (response) {
        if (response.status === 200 && "usuario" in response.body) {
          _this.$session.destroy();
          _this.$session.start();
          _this.$session.set("token", response.body.usuario.token), _this.$session.set("nombre", response.body.usuario.nombre), _this.$session.set("tipo", response.body.usuario.tipo), __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "BIENVENIDO " + response.body.usuario.nombre,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false
          });
          _this.$router.push("/");
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo hacer conexión",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    }
  },
  data: function data() {
    return {
      u: null,
      p: null
    };
  }
});

/***/ }),

/***/ "nN0q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanesNuevo_vue__ = __webpack_require__("5s3/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_134af0c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlanesNuevo_vue__ = __webpack_require__("3fve");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanesNuevo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_134af0c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlanesNuevo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nseC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IncidenciasListado"},[_c('h1',[_vm._v("Incidencias")]),_vm._v(" "),_c('md-table-card',{staticClass:"w-100"},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Incidencias pendientes")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Fecha")]),_vm._v(" "),_c('md-table-head',[_vm._v("Incidencia")]),_vm._v(" "),_c('md-table-head',[_vm._v("Punto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Estatus")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.incidencias),function(i){return _c('md-table-row',{key:i},[_c('md-table-cell',[_vm._v(_vm._s(i.fecha_ipu))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(i.obs_ipu))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(i.nombre_pun))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(i.estatus_ipu.toUpperCase()))]),_vm._v(" "),_c('md-table-cell')],1)}))],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "o7ya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Login"},[_c('form',[_c('md-layout',{attrs:{"md-align":"center","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"40","md-flex-medium":"35","md-flex-large":"30","md-flex-xlarge":"20"}},[_c('md-input-container',[_c('label',[_vm._v("Usuario")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.hacerLogin($event)}},model:{value:(_vm.u),callback:function ($$v) {_vm.u=$$v},expression:"u"}})],1),_vm._v(" "),_c('md-input-container',{attrs:{"md-has-password":""}},[_c('label',[_vm._v("Contraseña")]),_vm._v(" "),_c('md-input',{attrs:{"type":"password","required":""},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13)){ return null; }_vm.hacerLogin($event)}},model:{value:(_vm.p),callback:function ($$v) {_vm.p=$$v},expression:"p"}})],1),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-accent",nativeOn:{"click":function($event){_vm.hacerLogin($event)}}},[_vm._v("Iniciar sesión")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oG39":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuntosDetalle_vue__ = __webpack_require__("n4ir");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e670105_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuntosDetalle_vue__ = __webpack_require__("uHp8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuntosDetalle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e670105_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuntosDetalle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "omyV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_node_snackbar__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	name: "EmpleadosNuevo",
	methods: {
		conyugueCopiarAContacto: function conyugueCopiarAContacto() {
			this.empleado.persona_contacto_emn = this.empleado.nombre_conyuge_emn;
			this.empleado.tel_contacto_emn = this.empleado.tel_conyuge_emn;
		},
		obtenerEmpleado: function obtenerEmpleado() {
			var _this = this;

			this.$http.post("empleados/editar", {
				token: this.$session.get("token"),
				empleado: this.$route.params.empleado
			}).then(function (response) {
				if (response.status === 200 && "empleado" in response.body) {
					_this.empleado = response.body.empleado;
				} else {
					__WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
						text: "No se encontró el empleado que busca. Inténtelo de nuevo.",
						actionText: "Cerrar",
						pos: "top-right",
						showAction: false,
						backgroundColor: "#F44336",
						actionTextColor: "#FFF"
					});
					_this.$router.push("/empleados");
				}
			}, function (response) {
				__WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
					text: "No se pudo establecer conexión con el servidor.",
					actionText: "Cerrar",
					pos: "top-right",
					showAction: false,
					backgroundColor: "#F44336",
					actionTextColor: "#FFF"
				});
				_this.$router.push("/empleados");
			});
		},
		actualizarEmpleado: function actualizarEmpleado() {
			var _this2 = this;

			if (this.validarEmpleado()) {
				var formData = new FormData();
				formData.append("token", this.$session.get("token"));
				formData.append("empleado", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.empleado));
				formData.append("data", this.$route.params.empleado);
				this.$http.post("empleados/actualizar", formData).then(function (response) {
					if (response.status === 200 && "msg" in response.body) {
						__WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
							text: response.body.msg,
							actionText: "Cerrar",
							pos: "top-right",
							showAction: false
						});
						_this2.$router.push("/empleados");
					} else {
						__WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
							text: response.body.error,
							actionText: "Cerrar",
							pos: "top-right",
							showAction: false,
							backgroundColor: "#F44336",
							actionTextColor: "#FFF"
						});
					}
				}, function (response) {
					__WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
						text: "No se pudieron obtener los puestos de empleado. Recargue la página.",
						actionText: "Cerrar",
						pos: "top-right",
						showAction: false,
						backgroundColor: "#F44336",
						actionTextColor: "#FFF"
					});
				});
			}
		},
		validarEmpleado: function validarEmpleado() {
			!this.empleado.nombre_emn ? this.val.v_nombre = true : this.val.v_nombre = false;
			!this.empleado.ap_pat_emn ? this.val.v_ap_pat = true : this.val.v_ap_pat = false;
			!this.empleado.ap_mat_emn ? this.val.v_ap_mat = true : this.val.v_ap_mat = false;
			!this.empleado.fecha_nac_emn ? this.val.v_fecha_nac = true : this.val.v_fecha_nac = false;
			!this.empleado.sexo_emn ? this.val.v_sexo = true : this.val.v_sexo = false;
			!this.empleado.direccion_emn ? this.val.v_direccion = true : this.val.v_direccion = false;
			!this.empleado.num_ext_emn ? this.val.v_num_ext = true : this.val.v_num_ext = false;
			!this.empleado.colonia_emn ? this.val.v_colonia = true : this.val.v_colonia = false;
			!this.empleado.municipio_emn ? this.val.v_municipio = true : this.val.v_municipio = false;
			!this.empleado.estado_emn ? this.val.v_estado = true : this.val.v_estado = false;
			!this.empleado.tel_emn ? this.val.v_tel = true : this.val.v_tel = false;
			!this.empleado.curp_emn ? this.val.v_curp = true : this.val.v_curp = false;
			!this.empleado.nss_emn ? this.val.v_nss = true : this.val.v_nss = false;
			!this.empleado.persona_contacto_emn ? this.val.v_persona_contacto = true : this.val.v_persona_contacto = false;
			!this.empleado.tel_contacto_emn ? this.val.v_tel_contacto = true : this.val.v_tel_contacto = false;
			!this.empleado.direccion_contacto_emn ? this.val.v_direccion_contacto = true : this.val.v_direccion_contacto = false;
			if (this.val.v_nombre || this.val.v_ap_pat || this.val.v_ap_mat || this.val.v_fecha_nac || this.val.v_sexo || this.val.v_direccion || this.val.v_num_ext || this.val.v_colonia || this.val.v_municipio || this.val.v_estado || this.val.v_tel || this.val.v_curp || this.val.v_persona_contacto || this.val.v_tel_contacto || this.val.v_direccion_contacto) {
				__WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
					text: "Por favor llene todos los campos marcados con *",
					actionText: "Cerrar",
					pos: "top-right",
					showAction: false,
					backgroundColor: "#F44336",
					actionTextColor: "#FFF"
				});
				return false;
			} else {
				return true;
			}
		}
	},
	beforeCreate: function beforeCreate() {
		if (!this.$session.exists()) {
			this.$router.push("/login");
		}
	},
	created: function created() {
		this.obtenerEmpleado();
	},
	data: function data() {
		return {
			empleado: {
				nombre_emn: null,
				ap_pat_emn: null,
				ap_mat_emn: null,
				sexo_emn: null,
				estado_civil_emn: null,
				fecha_nac_emn: null,
				direccion_emn: null,
				num_ext_emn: null,
				codigo_postal_emn: null,
				colonia_emn: null,
				estado_emn: null,
				municipio_emn: null,
				tel_emn: null,
				cel_emn: null,
				email_emn: null,
				escolaridad_emn: null,
				fecha_ing_emn: null,
				nss_emn: null,
				curp_emn: null,
				rfc_emn: null,
				peso_emn: null,
				estatura_emn: null,
				camisa_emn: null,
				pantalon_emn: null,
				calzado_emn: null,
				complexion_emn: null,
				ojos_emn: null,
				piel_emn: null,
				cabello_emn: null,
				tipo_sangre_emn: null,
				experiencia_emn: null,
				anos_exp_emn: null,
				nombre_conyuge_emn: null,
				tel_conyuge_emn: null,
				hijos_emn: null,
				dependientes_emn: null,
				persona_contacto_emn: null,
				tel_contacto_emn: null,
				direccion_contacto_emn: null,
				num_contacto_emn: null,
				colonia_contacto_emn: null,
				puesto_epn: null,
				observaciones_emn: null,
				cuenta_ban_emn: null,
				//plan de pago
				id_pln_eph: null
			},
			val: {
				v_nombre: null,
				v_ap_pat: null,
				v_ap_mat: null,
				v_sexo: null,
				v_estado_civil: null,
				v_fecha_nac: null,
				v_direccion: null,
				v_num_ext: null,
				v_codigo_postal: null,
				v_colonia: null,
				v_estado: null,
				v_municipio: null,
				v_tel: null,
				v_cel: null,
				v_email: null,
				v_escolaridad: null,
				v_fecha_ing: null,
				v_nss: null,
				v_curp: null,
				v_rfc: null,
				v_peso: null,
				v_estatura: null,
				v_camisa: null,
				v_pantalon: null,
				v_calzado: null,
				v_complexion: null,
				v_ojos: null,
				v_piel: null,
				v_cabello: null,
				v_tipo_sangre: null,
				v_experiencia: null,
				v_anos_exp: null,
				v_nombre_conyuge: null,
				v_tel_conyuge: null,
				v_hijos: null,
				v_dependientes: null,
				v_persona_contacto: null,
				v_tel_contacto: null,
				v_direccion_contacto: null,
				v_num_contacto: null,
				v_colonia_contacto: null,
				v_puesto: null,
				v_observaciones: null,
				v_cuenta_ban: null,
				//plan de pago
				v_id_pln: null,
				//validaciones de conceptos
				v_con_id: null,
				v_con_desc: null,
				v_con_importe: null,
				v_con_quincenas: null,
				v_con_importe_qnal: null
			},
			con_add: {
				id: null,
				desc: null,
				importe: 0,
				quincenas: 1,
				importe_qnal: 0
			},
			conceptosNomina: [],
			conceptosListado: [],
			puestosListado: [],
			planesListado: []
		};
	}
});

/***/ }),

/***/ "p1l0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net__ = __webpack_require__("FNwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ConceptosListado",
  methods: {
    obtenerConceptos: function obtenerConceptos() {
      var _this = this;

      this.$http.post("conceptos", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "conceptos" in response.body) {
          _this.conceptos = response.body.conceptos;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    modalEditarConcepto: function modalEditarConcepto(concepto) {
      this.concepto = concepto;
      this.$refs["modalEditarConcepto"].open();
    },
    cerrarModalEditarConcepto: function cerrarModalEditarConcepto() {
      this.concepto = null;
      this.$refs["modalEditarConcepto"].close();
    },
    guardarCambiosConcepto: function guardarCambiosConcepto() {
      var _this2 = this;

      if (this.validarCamposConcepto()) {
        this.$http.post("conceptos/actualizar", {
          id: this.concepto.concepto,
          data: this.concepto,
          token: this.$session.get("token")
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false
            });
            _this2.cerrarModalEditarConcepto();
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              showAction: false,
              pos: "top-right",
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      }
    },
    validarCamposConcepto: function validarCamposConcepto() {
      !this.concepto.desc_con ? this.val.v_desc = true : this.val.v_desc = false;
      !this.concepto.importe_cnh ? this.val.v_importe = true : this.val.v_importe = false;
      !this.concepto.tipo_con ? this.val.v_tipo = true : this.val.v_tipo = false;
      if (this.val.v_desc || this.val.v_importe || this.val.v_tipo) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  beforeMount: function beforeMount() {
    this.obtenerConceptos();
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".md-table table").DataTable();
  },
  data: function data() {
    return {
      conceptos: [],
      concepto: {
        desc_con: null,
        tipo_con: null,
        estatus_con: null,
        id_con_cnh: null,
        desde_cnh: null,
        hasta_cnh: null,
        importe_cnh: null,
        concepto: null
      },
      val: {
        v_desc: null,
        v_tipo: null,
        v_estatus: null,
        v_importe: null
      }
    };
  }
});

/***/ }),

/***/ "pg0g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmpleadosListado_vue__ = __webpack_require__("7Wrc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e78bdea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmpleadosListado_vue__ = __webpack_require__("Tgpj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmpleadosListado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e78bdea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_EmpleadosListado_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pjhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IncidenciasNueva"},[_c('md-layout',{staticClass:"m-t-24",attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"50","md-flex-large":"30","md-flex-xlarge":"20"}},[_c('md-card',{staticClass:"w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Registrar incidencia")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Por favor llene todos los campos")])]),_vm._v(" "),_c('md-card-content',[_c('md-input-container',{class:{ 'md-input-invalid': _vm.v.v_id_pun }},[_c('label',{attrs:{"for":"id_pun_ipu"}},[_vm._v("Punto")]),_vm._v(" "),_c('md-select',{attrs:{"name":"id_pun_ipu","id":"id_pun_ipu","required":""},model:{value:(_vm.incidencia.id_pun_ipu),callback:function ($$v) {_vm.incidencia.id_pun_ipu=$$v},expression:"incidencia.id_pun_ipu"}},_vm._l((_vm.puntos),function(p){return _c('md-option',{key:p.id_pun,attrs:{"value":p.id_pun}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(p.nombre_pun)+"\n\t\t\t\t\t\t\t\t"),_c('span',[_c('small',[_vm._v(", "+_vm._s(p.nombre.toUpperCase())+" ")])])])}))],1),_vm._v(" "),_c('md-input-container',{class:{ 'md-input-invalid': _vm.v.v_obs }},[_c('label',[_vm._v("Observaciones")]),_vm._v(" "),_c('md-textarea',{attrs:{"required":""},model:{value:(_vm.incidencia.obs_ipu),callback:function ($$v) {_vm.incidencia.obs_ipu=$$v},expression:"incidencia.obs_ipu"}})],1)],1),_vm._v(" "),_c('md-card-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.irAIncidencias()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{nativeOn:{"click":function($event){_vm.registrarIncidencia()}}},[_vm._v("Registrar")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qUo6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net__ = __webpack_require__("FNwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_print_js__ = __webpack_require__("P8fo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_print_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_print_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "NominaPreliminar",
  methods: {
    nF: function nF(numerito) {
      return Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN"
      }).format(numerito);
    },
    printJS: function printJS(a, b) {
      return __WEBPACK_IMPORTED_MODULE_5_print_js___default()(a, b);
    },
    calcularTotal: function calcularTotal(conceptos) {},
    obtenerEmpleados: function obtenerEmpleados() {
      var _this = this;

      this.$http.post("nomina/resumen", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "empleados" in response.body) {
          _this.empleados = response.body.empleados;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    obtenerDetalleNominaEmpleado: function obtenerDetalleNominaEmpleado(e, nombre, a, b) {
      var _this2 = this;

      this.empleado = nombre;
      this.desde = a;
      this.hasta = b;
      this.id_emp = e;
      this.$http.post("nomina/detalle", {
        token: this.$session.get("token"),
        empleado: __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(e))
      }).then(function (response) {
        if (response.status === 200 && "conceptos" in response.body) {
          _this2.conceptos = response.body.conceptos;
          _this2.total = response.body.total;
          _this2.$refs["modalDetalleNominaEmpleado"].open();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    abrirModal: function abrirModal(ref) {
      this.$refs[ref].open();
    },
    cerrarModal: function cerrarModal(ref) {
      this.$refs[ref].close();
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  beforeMount: function beforeMount() {
    this.obtenerEmpleados();
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".md-table.tablita > table").DataTable();
  },
  data: function data() {
    return {
      empleados: [],
      id_emp: null,
      desde: null,
      hasta: null,
      total: 0,
      empleado: null,
      conceptos: [],
      observaciones_ene: null,
      estatus_old: null
    };
  }
});

/***/ }),

/***/ "rYpc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanesListado_vue__ = __webpack_require__("tAxg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbc29f48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlanesListado_vue__ = __webpack_require__("N5Y+");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PlanesListado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbc29f48_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PlanesListado_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sgaX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net__ = __webpack_require__("FNwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'IncidenciasListado',
	methods: {
		obtenerIncidencias: function obtenerIncidencias() {
			var _this = this;

			this.$http.post('incidencias', {
				'token': this.$session.get('token'),
				estatus: 'atendidas'
			}).then(function (response) {
				if (response.status === 200 && 'incidencias' in response.body) {
					_this.incidencias = response.body.incidencias;
				}
			}, function (response) {
				__WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
					text: 'No se pudo establecer conexión con el servidor al obtener las incidencias.',
					actionText: 'Cerrar',
					pos: 'top-right',
					showAction: false,
					backgroundColor: '#F44336',
					actionTextColor: '#FFF'
				});
			});
		}
	},
	beforeCreate: function beforeCreate() {
		if (!this.$session.exists()) {
			this.$router.push('/login');
		}
	},
	created: function created() {
		this.obtenerIncidencias();
	},
	updated: function updated() {
		this.tabla = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.md-table table').DataTable();
	},
	data: function data() {
		return {
			msg: 'IncidenciasListado',
			incidencias: [],
			tabla: null
		};
	}
});

/***/ }),

/***/ "t8t7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConceptosEditar',
  methods: {
    guardarConcepto: function guardarConcepto() {
      var _this = this;

      if (this.validarCamposConcepto()) {
        this.$http.post('conceptos/guardar', {
          data: this.concepto,
          token: this.$session.get('token')
        }).then(function (response) {
          if (response.status === 200 && 'msg' in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: 'Bienvenido ' + response.body.msg,
              actionText: 'Cerrar',
              pos: 'top-right',
              showAction: false
            });
            _this.$router.push('/conceptos');
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: 'Cerrar',
              showAction: false,
              pos: 'top-right',
              backgroundColor: '#F44336',
              actionTextColor: '#FFF'
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: 'No se pudo establecer conexión con el servidor.',
            actionText: 'Cerrar',
            showAction: false,
            pos: 'top-right',
            backgroundColor: '#F44336',
            actionTextColor: '#FFF'
          });
        });
      }
    },
    validarCamposConcepto: function validarCamposConcepto() {
      !this.concepto.desc_con ? this.val.v_desc = true : this.val.v_desc = false;
      !this.concepto.importe_cnh ? this.val.v_importe = true : this.val.v_importe = false;
      !this.concepto.tipo_con ? this.val.v_tipo = true : this.val.v_tipo = false;
      if (this.val.v_desc || this.val.v_importe || this.val.v_tipo) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: 'Por favor llene todos los campos marcados con *',
          actionText: 'Cerrar',
          showAction: false,
          pos: 'top-right',
          duration: 10000,
          backgroundColor: '#CC3D30',
          actionTextColor: '#FFF'
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push('/login');
    }
  },
  data: function data() {
    return {
      msg: 'Inicio',
      concepto: {
        desc_con: null,
        importe_cnh: null,
        tipo_con: null
      },
      val: {
        v_desc: null,
        v_importe: null,
        v_tipo: null
      }
    };
  }
});

/***/ }),

/***/ "tAxg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net__ = __webpack_require__("FNwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PlanesListado",
  methods: {
    obtenerPlanes: function obtenerPlanes() {
      var _this = this;

      this.$http.post("planes", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "planes" in response.body) {
          _this.planes = response.body.planes;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    irEditarPlan: function irEditarPlan(id) {
      this.$router.push({ name: "PlanesEditar", params: { id: id } });
    },
    irDetallePlan: function irDetallePlan(id) {
      this.$router.push({ name: "PlanesDetalle", params: { id: id } });
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  beforeMount: function beforeMount() {
    this.obtenerPlanes();
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_3_jquery___default()(".md-table table").DataTable();
  },
  data: function data() {
    return {
      planes: []
    };
  }
});

/***/ }),

/***/ "tHtd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(this.$session.get('token'))?_c('md-sidenav',{ref:"leftSidenav",staticClass:"md-left",attrs:{"md-swipeable":true}},[_c('md-toolbar',{staticClass:"md-accent md-dense"},[_c('div',{staticClass:"md-toolbar-container"},[_c('h3',{staticClass:"md-title"},[_vm._v("Menú")])])]),_vm._v(" "),_c('md-list',[_c('md-list-item',[_c('router-link',{attrs:{"to":"/inicio"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_c('md-icon',[_vm._v("home")]),_vm._v(" "),_c('span',[_vm._v("Inicio")])],1)],1),_vm._v(" "),_c('md-list-item',[_c('router-link',{attrs:{"to":"/adelantos-nomina"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_c('md-icon',[_vm._v("money")]),_vm._v(" "),_c('span',[_vm._v("Adelanto de nomina")])],1)],1),_vm._v(" "),_c('md-list-item',[_c('md-icon',[_vm._v("playlist_add_check")]),_vm._v(" "),_c('span',[_vm._v("Asistencias")]),_vm._v(" "),_c('md-list-expand',[_c('md-list',[_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/asistencias"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Tomar asistencia")])],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/tiemposextra/asignar"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Asignar tiempos extra")])],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/tiemposextra/validar"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Validar tiempos extra")])],1)],1)],1)],1),_vm._v(" "),_c('md-list-item',[_c('md-icon',[_vm._v("contacts")]),_vm._v(" "),_c('span',[_vm._v("Clientes")]),_vm._v(" "),_c('md-list-expand',[_c('md-list',[_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/clientes"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Clientes registrados")])],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/cliente"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Registrar cliente")])],1)],1)],1)],1),_vm._v(" "),_c('md-list-item',[_c('md-icon',[_vm._v("description")]),_vm._v(" "),_c('span',[_vm._v("Contratos")]),_vm._v(" "),_c('md-list-expand',[_c('md-list',[_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/contratos"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Contratos registrados")])],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/contrato/nuevo"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Registrar contrato")])],1)],1)],1)],1),_vm._v(" "),_c('md-list-item',[_c('md-icon',[_vm._v("people")]),_vm._v(" "),_c('span',[_vm._v("Empleados")]),_vm._v(" "),_c('md-list-expand',[_c('md-list',[_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/empleados"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Empleados registrados")])],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/empleado/nuevo"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Registrar empleado")])],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('span',[_vm._v("Puestos")]),_vm._v(" "),_c('md-list-expand',[_c('md-list',[_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/puestos"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Puestos registrados")])],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/puesto/"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Registrar puesto")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('md-list-item',[_c('md-icon',[_vm._v("attach_money")]),_vm._v(" "),_c('span',[_vm._v("Nómina")]),_vm._v(" "),_c('md-list-expand',[_c('md-list',[_c('md-list-item',{staticClass:"md-inset"},[_c('span',[_vm._v("Adelantos de nómina")]),_vm._v(" "),_c('md-list-expand',[_c('md-list',[_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/adelantos"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Registrar adelantos")])],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/validar-adelantos"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Validar adelantos")])],1)],1)],1)],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('span',[_vm._v("Conceptos")]),_vm._v(" "),_c('md-list-expand',[_c('md-list',[_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/conceptos"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Conceptos registrados")])],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/concepto"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Registrar concepto")])],1)],1)],1)],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/nomina/diasfestivos"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Días festivos")])],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('span',[_vm._v("Planes de pago")]),_vm._v(" "),_c('md-list-expand',[_c('md-list',[_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/planes"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Planes de pago registrados")])],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/plan"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Registrar registrar plan de pago")])],1)],1)],1)],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/nomina/resumen"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Ver cálculo de nomina ")])],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset",nativeOn:{"click":function($event){_vm.abrirModalCalcularNomina()}}},[_vm._v(" Calcular nomina ")]),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Cerrar nómina")])],1)],1)],1)],1),_vm._v(" "),_c('md-list-item',[_c('md-icon',[_vm._v("location_searching")]),_vm._v(" "),_c('span',[_vm._v("Puntos")]),_vm._v(" "),_c('md-list-expand',[_c('md-list',[_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/puntos"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Puntos registrados")])],1),_vm._v(" "),_c('md-list-item',{staticClass:"md-inset"},[_c('router-link',{attrs:{"to":"/punto/cliente"},nativeOn:{"click":function($event){_vm.cerrarNav()}}},[_vm._v("Registrar punto")])],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"main-header fixed-toolbar"},[_c('md-whiteframe',{attrs:{"md-elevation":"2"}},[_c('md-toolbar',{staticClass:"md-dense"},[_c('div',{staticClass:"md-toolbar-container"},[(this.$session.get('token'))?_c('md-button',{staticClass:"md-icon-button",staticStyle:{"color":"white"},nativeOn:{"click":function($event){_vm.abrirSideNavLeft()}}},[_c('md-icon',[_vm._v("menu")])],1):_vm._e(),_vm._v(" "),_c('h2',{staticClass:"md-title",staticStyle:{"flex":"1","color":"white"}},[_vm._v("Grupo Alarcom")])],1)])],1)],1),_vm._v(" "),_c('router-view',{staticClass:"main-content"}),_vm._v(" "),_c('md-dialog',{ref:"modalCalcularNomina",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-content',[_c('div',{staticClass:"md-headline"},[_vm._v("¿Está seguro desea recalcular la nómina?")])]),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModalCalcularNomina(false)}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.cerrarModalCalcularNomina(true)}}},[_vm._v("Calcular")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalCargando",staticStyle:{"z-index":"9999!important"},attrs:{"md-open-from":"#custom","md-close-to":"#custom","md-click-outside-to-close":false,"md-esc-to-close":false}},[_c('md-progress',{staticClass:"md-warn",attrs:{"md-indeterminate":""}},[_vm._v("Cargando")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tme9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdelantosNominaAdministrativo_vue__ = __webpack_require__("9TiH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_739933a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AdelantosNominaAdministrativo_vue__ = __webpack_require__("h5F4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdelantosNominaAdministrativo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_739933a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AdelantosNominaAdministrativo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tzNG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u4lV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuntosSeleccionarCliente_vue__ = __webpack_require__("l2RU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a6c0f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuntosSeleccionarCliente_vue__ = __webpack_require__("iQjG");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PuntosSeleccionarCliente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a6c0f64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_PuntosSeleccionarCliente_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u9Nx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PuntosListado"},[_c('md-table-card',{staticClass:"m-t-16"},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Puntos registrados")])]),_vm._v(" "),_c('md-table',{staticClass:"tablita"},[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Punto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Domicilio")]),_vm._v(" "),_c('md-table-head',[_vm._v("Cliente")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.puntos),function(punto){return _c('md-table-row',{key:punto.punto},[_c('md-table-cell',[_vm._v(_vm._s(punto.nombre_pun))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(punto.domicilio_pun))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(punto.nombre_cli))]),_vm._v(" "),_c('md-table-cell',[(punto.pdf_pco != null)?_c('div',[_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.irAEditarPunto(punto.punto)}}},[_c('md-icon',[_vm._v("edit")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Editar punto")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.abrirModalEditarTurnos(punto)}}},[_c('md-icon',[_vm._v("access_time")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Editar turnos")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.abrirModalAgregarTurnos(punto)}}},[_c('md-icon',[_vm._v("add")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Agregar turnos")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.abrirModalSeleccionarTurno(punto.punto)}}},[_c('md-icon',[_vm._v("today")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Editar roles")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",nativeOn:{"click":function($event){_vm.abrirModalEdicionContratos(punto)}}},[_c('md-icon',[_vm._v("description")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Contratos")])],1)],1):_c('div',[_c('md-button',{staticClass:"md-raised md-icon-button md-warn",nativeOn:{"click":function($event){_vm.abrirModalSubirContrato(punto)}}},[_c('md-icon',[_vm._v("description")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Subir contrato firmado")])],1)],1)])],1)}))],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalEditarTurnos",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.punto.nombre_pun))]),_vm._v(" "),_c('md-dialog-content',_vm._l((_vm.turnosPunto),function(t){return _c('md-list',{key:t.id_ptu,staticClass:"md-double-line"},[_c('md-list-item',[_c('div',{staticClass:"md-list-text-container"},[_c('span',[_vm._v(_vm._s(_vm.moment(t.inicio_ptu,'h:mm:ss').format('h:mm A'))+" a "+_vm._s(_vm.moment(t.termino_ptu,'h:mm:ss').format('h:mm A'))+" ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(t.estatus_ptu.toUpperCase()))])]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button md-list-action md-primary"},[(t.estatus_ptu != 'activo')?_c('md-icon',{staticClass:"md-primary",nativeOn:{"click":function($event){_vm.cambiarEstatusTurno(t.id_ptu,'activo')}}},[_vm._v("play_arrow")]):_c('md-icon',{staticClass:"md-primary",nativeOn:{"click":function($event){_vm.cambiarEstatusTurno(t.id_ptu,'inactivo')}}},[_vm._v("pause")])],1)],1)],1)})),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModalEditarTurnos()}}},[_vm._v("Cerrar")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalAgregarTurnos",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-title',[_vm._v(_vm._s(_vm.punto.nombre_pun))]),_vm._v(" "),_c('md-dialog-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_inicio_tur }},[_c('label',{attrs:{"for":"inicio_tur"}},[_vm._v("Inicio")]),_vm._v(" "),_c('md-select',{attrs:{"name":"inicio_tur","id":"inicio_tur"},model:{value:(_vm.turno.inicio_ptu),callback:function ($$v) {_vm.turno.inicio_ptu=$$v},expression:"turno.inicio_ptu"}},[_c('md-option',{attrs:{"value":"1 AM"}},[_vm._v("1 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"2 AM"}},[_vm._v("2 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3 AM"}},[_vm._v("3 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4 AM"}},[_vm._v("4 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5 AM"}},[_vm._v("5 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6 AM"}},[_vm._v("6 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7 AM"}},[_vm._v("7 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8 AM"}},[_vm._v("8 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9 AM"}},[_vm._v("9 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10 AM"}},[_vm._v("10 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11 AM"}},[_vm._v("11 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12 AM"}},[_vm._v("12 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"1 PM"}},[_vm._v("1 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"2 PM"}},[_vm._v("2 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3 PM"}},[_vm._v("3 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4 PM"}},[_vm._v("4 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5 PM"}},[_vm._v("5 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6 PM"}},[_vm._v("6 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7 PM"}},[_vm._v("7 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8 PM"}},[_vm._v("8 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9 PM"}},[_vm._v("9 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10 PM"}},[_vm._v("10 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11 PM"}},[_vm._v("11 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12 PM"}},[_vm._v("12 PM")])],1)],1)],1),_vm._v(" "),_c('md-layout',[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_fin_tur }},[_c('label',{attrs:{"for":"fin_tur"}},[_vm._v("Fin")]),_vm._v(" "),_c('md-select',{attrs:{"name":"fin_tur","id":"fin_tur"},model:{value:(_vm.turno.termino_ptu),callback:function ($$v) {_vm.turno.termino_ptu=$$v},expression:"turno.termino_ptu"}},[_c('md-option',{attrs:{"value":"1 AM"}},[_vm._v("1 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"2 AM"}},[_vm._v("2 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3 AM"}},[_vm._v("3 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4 AM"}},[_vm._v("4 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5 AM"}},[_vm._v("5 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6 AM"}},[_vm._v("6 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7 AM"}},[_vm._v("7 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8 AM"}},[_vm._v("8 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9 AM"}},[_vm._v("9 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10 AM"}},[_vm._v("10 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11 AM"}},[_vm._v("11 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12 AM"}},[_vm._v("12 AM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"1 PM"}},[_vm._v("1 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"2 PM"}},[_vm._v("2 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"3 PM"}},[_vm._v("3 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"4 PM"}},[_vm._v("4 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"5 PM"}},[_vm._v("5 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"6 PM"}},[_vm._v("6 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"7 PM"}},[_vm._v("7 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"8 PM"}},[_vm._v("8 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"9 PM"}},[_vm._v("9 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"10 PM"}},[_vm._v("10 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"11 PM"}},[_vm._v("11 PM")]),_vm._v(" "),_c('md-option',{attrs:{"value":"12 PM"}},[_vm._v("12 PM")])],1)],1)],1),_vm._v(" "),_c('md-layout',[_c('md-button',{staticClass:"md-icon-button md-raised md-accent",nativeOn:{"click":function($event){_vm.agregarTurno()}}},[_c('md-icon',[_vm._v("add")])],1)],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100","md-align":"center"}},_vm._l((_vm.turnosNuevos),function(tn){return _c('md-list',{key:tn.id_ptu,staticClass:"md-double-line"},[_c('md-list-item',[_c('div',{staticClass:"md-list-text-container"},[_c('span',[_vm._v(_vm._s(tn.inicio_ptu)+" a "+_vm._s(tn.termino_ptu))])]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button md-list-action md-primary"},[_c('md-icon',{nativeOn:{"click":function($event){_vm.removerTurnoNuevo(tn)}}},[_vm._v("delete")])],1)],1)],1)}))],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModalAgregarTurnos()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.guardarTurnos()}}},[_vm._v("Guardar turnos")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalSeleccionarTurno",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-title',[_vm._v("VER ROLES DEL PUNTO")]),_vm._v(" "),_c('md-dialog-content',_vm._l((_vm.turnosPunto),function(t){return _c('md-list',{key:t.id_ptu,staticClass:"md-double-line"},[_c('md-list-item',[_c('div',{staticClass:"md-list-text-container"},[_c('span',[_vm._v(_vm._s(_vm.moment(t.inicio_ptu,'h:mm:ss').format('h:mm A'))+" a "+_vm._s(_vm.moment(t.termino_ptu,'h:mm:ss').format('h:mm A')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(t.estatus_ptu.toUpperCase()))])]),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button md-list-action md-primary"},[_c('md-icon',{staticClass:"md-primary",nativeOn:{"click":function($event){_vm.irEditarRolesTurno(t.id_ptu)}}},[_vm._v("edit")])],1)],1)],1)})),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModalSeleccionarTurno()}}},[_vm._v("Cerrar")])],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalSubirContrato",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-title',[_vm._v("PUNTO "+_vm._s(_vm.punto.nombre_pun))]),_vm._v(" "),_c('md-dialog-content',[_c('div',{staticClass:"md-subheading"},[_vm._v("CONTRATO "+_vm._s(_vm.punto.titulo_cnt)),_c('br'),_c('br')]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-accent",nativeOn:{"click":function($event){_vm.abrirVentanaGenerarContrato(_vm.punto.punto)}}},[_vm._v("Generar contrato en PDF")]),_vm._v(" "),_c('md-input-container',[_c('label',[_vm._v("Subir contrato firmado")]),_vm._v(" "),_c('md-file',{attrs:{"accept":"application/pdf"},on:{"selected":function($event){_vm.prepararContratoSubir($event)}},model:{value:(_vm.single),callback:function ($$v) {_vm.single=$$v},expression:"single"}})],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModal('modalSubirContrato')}}},[_vm._v("Cerrar")]),_vm._v(" "),(_vm.archivo_contrato != null)?_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.guardarArchivoContrato()}}},[_vm._v("Subir contrato")]):_vm._e()],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalEdicionContratos",attrs:{"md-open-from":"#custom","md-close-to":"#custom"}},[_c('md-dialog-title',[_vm._v("PUNTO "+_vm._s(_vm.punto.nombre_pun))]),_vm._v(" "),_c('table',{staticClass:"md-table md-theme-default"},[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Contrato")]),_vm._v(" "),_c('md-table-head',[_vm._v("Desde")]),_vm._v(" "),_c('md-table-head',[_vm._v("Hasta")]),_vm._v(" "),_c('md-table-head',[_vm._v("Acciones")])],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.contratos_punto),function(pco){return _c('md-table-row',{key:pco.id_cnt_pco},[_c('md-table-cell',[_vm._v(_vm._s(pco.titulo_cnt))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.moment(pco.desde_pco,'YYYY-MM-DD h:mm:ss').format('YYYY-MM-DD h:mm A')))]),_vm._v(" "),_c('md-table-cell',[(pco.hasta_pco)?_c('div',[_vm._v(" "+_vm._s(_vm.moment(pco.hasta_pco,'YYYY-MM-DD h:mm:ss').format('YYYY-MM-DD h:mm A'))+" ")]):_c('div',[_vm._v("\n              ACTIVO\n            ")])]),_vm._v(" "),_c('md-table-cell',[(pco.hasta_pco === null)?_c('div',[_c('md-button',{staticClass:"md-raised md-warn",staticStyle:{"width":"auto"},nativeOn:{"click":function($event){_vm.suspenderContrato(pco.id_pun_pco,pco.id_cnt_pco)}}},[_vm._v("\n                Suspender\n              ")])],1):_vm._e()])],1)}))],1),_vm._v(" "),_c('md-dialog-content',{staticClass:"m-t-24"},[_c('div',{staticClass:"md-subheading"},[_vm._v("¿Desea cambiar el tipo de contrato?")]),_vm._v(" "),_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_id_cnt }},[_c('label',{attrs:{"for":"id_cnt_pun"}},[_vm._v("Contrato")]),_vm._v(" "),_c('md-select',{attrs:{"name":"id_cnt_pun","id":"id_cnt_pun","required":""},model:{value:(_vm.contrato_nuevo),callback:function ($$v) {_vm.contrato_nuevo=$$v},expression:"contrato_nuevo"}},_vm._l((_vm.contratos),function(cnt){return _c('md-option',{key:cnt.id_cnt,attrs:{"value":cnt.id_cnt}},[_vm._v("\n            "+_vm._s(cnt.titulo_cnt)+"\n          ")])}))],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.cerrarModal('modalEdicionContratos')}}},[_vm._v("Cerrar")]),_vm._v(" "),(_vm.contrato_nuevo!=null)?_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.anadirContrato(_vm.punto.id_pun)}}},[_vm._v("Cambiar contrato")]):_vm._e()],1)],1),_vm._v(" "),_c('md-dialog',{ref:"subiendoArchivo",attrs:{"md-open-from":"#custom","md-close-to":"#custom","md-click-outside-to-close":false,"md-esc-to-close":false}},[_c('md-progress',{attrs:{"md-indeterminate":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uHp8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PuntosDetalle"},[_c('h1',[_vm._v("Información del punto")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uTO0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__("7t+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net__ = __webpack_require__("FNwM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_datatables_net___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_datatables_net__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'IncidenciasListado',
	methods: {
		obtenerIncidencias: function obtenerIncidencias() {
			var _this = this;

			this.$http.post('incidencias', {
				'token': this.$session.get('token')
			}).then(function (response) {
				if (response.status === 200 && 'incidencias' in response.body) {
					_this.incidencias = response.body.incidencias;
				}
			}, function (response) {
				__WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
					text: 'No se pudo establecer conexión con el servidor al obtener las incidencias.',
					actionText: 'Cerrar',
					pos: 'top-right',
					showAction: false,
					backgroundColor: '#F44336',
					actionTextColor: '#FFF'
				});
			});
		},
		abrirModalEstatusIncidencia: function abrirModalEstatusIncidencia(i) {
			this.incidencia = i;
			this.estatus_ipu_previo = i.estatus_ipu;
			this.abrirModal('modalEstatusIncidencia');
		},
		guardarEstatus: function guardarEstatus() {
			var _this2 = this;

			this.$http.post('incidencias/estatus', {
				'token': this.$session.get('token'),
				'incidencia': this.incidencia.incidencia,
				'estatus': this.incidencia.estatus_ipu
			}).then(function (response) {
				if (response.status === 200 && 'msg' in response.body) {
					__WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
						text: response.body.msg,
						actionText: 'Cerrar',
						pos: 'top-right'
					});
				} else {
					_this2.incidencia.estatus_ipu = _this2.estatus_ipu_previo;
					__WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
						text: response.body.error,
						actionText: 'Cerrar',
						pos: 'top-right',
						showAction: false,
						backgroundColor: '#F44336',
						actionTextColor: '#FFF'
					});
				}
			}, function (response) {
				__WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
					text: 'No se pudo establecer conexión con el servidor al obtener las incidencias.',
					actionText: 'Cerrar',
					pos: 'top-right',
					showAction: false,
					backgroundColor: '#F44336',
					actionTextColor: '#FFF'
				});
			});
			this.cerraModal('modalEstatusIncidencia');
		},
		abrirModal: function abrirModal(ref) {
			this.$refs[ref].open();
		},
		cerraModal: function cerraModal(ref) {
			this.$refs[ref].close();
		}
	},

	beforeCreate: function beforeCreate() {
		if (!this.$session.exists()) {
			this.$router.push('/login');
		}
	},
	created: function created() {
		this.obtenerIncidencias();
	},
	updated: function updated() {
		this.tabla = __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.md-table table').DataTable();
	},
	data: function data() {
		return {
			msg: 'IncidenciasListado',
			incidencias: [],
			incidencia: {
				obs_ipu: null,
				estatus_ipu: null
			},
			estatus_ipu_previo: null,
			tabla: null
		};
	}
});

/***/ }),

/***/ "ugFE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NominaPreliminar"},[_c('md-table-card',{staticClass:"m-t-16"},[_c('md-toolbar',[_c('h1',{staticClass:"md-title"},[_vm._v("Nomina preliminar")])]),_vm._v(" "),_c('md-table',{staticClass:"tablita"},[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("# emp")]),_vm._v(" "),_c('md-table-head',[_vm._v("Nombre")]),_vm._v(" "),_c('md-table-head',[_vm._v("Percepciones")]),_vm._v(" "),_c('md-table-head',[_vm._v("Deducciones")]),_vm._v(" "),_c('md-table-head',[_vm._v("Total")]),_vm._v(" "),_c('md-table-head')],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.empleados),function(n,index){return _c('md-table-row',{key:index},[_c('md-table-cell',[_vm._v(_vm._s(n.empleado))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(n.nombre_empleado))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.nF(n.percepciones)))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.nF(n.deducciones)))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(_vm.nF(n.percepciones - n.deducciones)))]),_vm._v(" "),_c('md-table-cell',[_c('md-button',{staticClass:"md-icon-button",staticStyle:{"width":"auto"},nativeOn:{"click":function($event){_vm.obtenerDetalleNominaEmpleado(n.empleado,n.nombre_empleado, n.desde_npe, n.hasta_npe)}}},[_c('md-icon',[_vm._v("more_vert")]),_vm._v(" "),_c('md-tooltip',{attrs:{"md-direction":"left"}},[_vm._v("Detalle")])],1)],1)],1)}))],1)],1),_vm._v(" "),_c('md-dialog',{ref:"modalDetalleNominaEmpleado",attrs:{"md-open-from":"#fab","md-close-to":"#fab"}},[_c('md-dialog-content',{attrs:{"id":"recibo-nomina"}},[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.empleado))]),_vm._v(" "),_c('div',{staticClass:"md-subheading"},[_vm._v("Periodo del "+_vm._s(_vm.desde)+" al "+_vm._s(_vm.hasta))]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v("Concepto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Tipo")]),_vm._v(" "),_c('md-table-head',[_vm._v("Desde")]),_vm._v(" "),_c('md-table-head',[_vm._v("Total")]),_vm._v(" "),_c('md-table-head',[_vm._v("Resto")]),_vm._v(" "),_c('md-table-head',[_vm._v("Quincenas")]),_vm._v(" "),_c('md-table-head',[_vm._v("Importe qnal")])],1)],1),_vm._v(" "),_c('md-table-body',[_vm._l((_vm.conceptos),function(c,index){return _c('md-table-row',{key:index},[_c('md-table-cell',[_vm._v(_vm._s(c.desc_con))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(c.tipo_con.toUpperCase()))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s(c.desde_pdn))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s((!c.desde_pdn) ? _vm.nF(c.importe_npr) : _vm.nF(c.importe_pdn)))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s((!c.desde_pdn) ? null : _vm.nF(c.resto_pdn)))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s((!c.desde_pdn) ? null : c.qnas_pdn))]),_vm._v(" "),_c('md-table-cell',[_vm._v(_vm._s((!c.desde_pdn) ? _vm.nF(c.importe_npr) : _vm.nF(c.importe_qnal_pdn)))])],1)}),_vm._v(" "),_c('md-table-row',[_c('md-table-cell'),_vm._v(" "),_c('md-table-cell'),_vm._v(" "),_c('md-table-cell'),_vm._v(" "),_c('md-table-cell'),_vm._v(" "),_c('md-table-cell'),_vm._v(" "),_c('md-table-cell',[_vm._v("TOTAL")]),_vm._v(" "),_c('md-table-cell',[_vm._v("$"+_vm._s(_vm.total))])],1)],2)],1)],1),_vm._v(" "),_c('md-dialog-actions',[_c('md-button',{nativeOn:{"click":function($event){_vm.printJS('recibo-nomina', 'html')}}},[_c('md-icon',[_vm._v("print")]),_vm._v("\n        Imprimir\n      ")],1),_vm._v(" "),_c('md-button',{staticClass:"md-accent md-raised",nativeOn:{"click":function($event){_vm.cerrarModal('modalDetalleNominaEmpleado')}}},[_vm._v("Cerrar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v2qJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AsistenciasPuntos_vue__ = __webpack_require__("06Xo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_683d07b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AsistenciasPuntos_vue__ = __webpack_require__("IZr/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AsistenciasPuntos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_683d07b6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_AsistenciasPuntos_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vJd7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ClientesNuevo",
  methods: {
    guardarCliente: function guardarCliente() {
      var _this = this;

      if (this.validarCamposCliente()) {
        this.$http.post("clientes/guardar", {
          token: this.$session.get("token"),
          data: this.cliente
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false
            });
            _this.$router.push("/clientes");
          } else {
            __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      }
    },
    validarCamposCliente: function validarCamposCliente() {
      !this.cliente.nombre ? this.val.v_nombre = true : this.val.v_nombre = false;
      !this.cliente.cuenta ? this.val.v_cuenta = true : this.val.v_cuenta = false;
      if (this.val.v_nombre || this.val.v_cuenta) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          duration: 10000,
          backgroundColor: "#CC3D30",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data: function data() {
    return {
      cliente: {
        cuenta: null,
        nombre: null,
        rfc: null,
        email: null,
        telefono: null,
        estado: null,
        municipio: null,
        ciudad: null,
        calle: null,
        colonia: null,
        numero: null,
        codigo_postal: null,
        fecha_ingreso: null,
        notas: null,
        ruta: null
      },
      val: {
        v_cuenta: null,
        v_nombre: null
      }
    };
  }
});

/***/ }),

/***/ "vMTS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AdelantosNominaValidar"},[_c('md-card',{staticClass:"m-t-24"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Validación de adelantos de nómina")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Conforme vaya realizando los cambios, estos se irán guardando automáticamente")])]),_vm._v(" "),_c('md-table',[_c('md-table-header',[_c('md-table-row',[_c('md-table-head',[_vm._v(" # emp ")]),_vm._v(" "),_c('md-table-head',[_vm._v(" Nombre ")]),_vm._v(" "),_c('md-table-head',[_vm._v(" Puesto ")]),_vm._v(" "),_c('md-table-head',[_vm._v(" Punto ")]),_vm._v(" "),_c('md-table-head',[_vm._v(" Sal. Qnal ")]),_vm._v(" "),_c('md-table-head',[_vm._v(" Solicitado ")]),_vm._v(" "),_c('md-table-head')],1)],1),_vm._v(" "),_c('md-table-body',_vm._l((_vm.adelantos),function(adelanto){return _c('md-table-row',{key:adelanto.id_emn_ano},[_c('md-table-cell',[_vm._v(" "+_vm._s(adelanto.id_emn)+" ")]),_vm._v(" "),_c('md-table-cell',[_vm._v(" "+_vm._s(adelanto.nombre_empleado)+" ")]),_vm._v(" "),_c('md-table-cell',[_vm._v(" "+_vm._s(adelanto.nombre_pue))]),_vm._v(" "),_c('md-table-cell',[_vm._v(" "+_vm._s(adelanto.nombre_pun))]),_vm._v(" "),_c('md-table-cell',[_vm._v(" "+_vm._s(_vm.nF(adelanto.salario_qnal_pnh))+" ")]),_vm._v(" "),_c('md-table-cell',[_vm._v(" "+_vm._s(_vm.nF(adelanto.solicito_ano))+" ")]),_vm._v(" "),_c('md-table-cell',[_c('md-input-container',[_c('md-icon',[_vm._v("attach_money")]),_vm._v(" "),_c('label',[_vm._v("Importe")]),_vm._v(" "),_c('md-input',{staticStyle:{"width":"auto!important"},attrs:{"type":"number","min":"0","max":adelanto.salario_qnal_pnh,"placeholder":"Autorizado"},on:{"blur":function($event){_vm.guardarCambiosAdelanto(adelanto,$event)}},model:{value:(adelanto.autorizado_ano),callback:function ($$v) {adelanto.autorizado_ano=$$v},expression:"adelanto.autorizado_ano"}})],1)],1)],1)}))],1),_vm._v(" "),_c('md-card-actions',[_c('md-button',{staticClass:"md-raised md-primary",nativeOn:{"click":function($event){_vm.obtenerAdelantosRegistrados()}}},[_vm._v("Actualizar contenido")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wNPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'inicio',
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push('/login');
    }
  },
  data: function data() {
    return {
      msg: 'Inicio'
    };
  }
});

/***/ }),

/***/ "wiEd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominaDiasFestivos_vue__ = __webpack_require__("YRJ6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3f9ceec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NominaDiasFestivos_vue__ = __webpack_require__("STfl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NominaDiasFestivos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e3f9ceec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NominaDiasFestivos_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wp6J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PuntosNuevo"},[_c('h1',[_vm._v("Punto nuevo")]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100","md-align":"center"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"40","md-flex-large":"30","md-flex-xlarge":"30"}},[_c('div',{staticClass:"md-title"},[_vm._v("Información del cliente")]),_c('br'),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Cuenta:")]),_vm._v(" "+_vm._s(_vm.punto.cuenta)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Razón social:")]),_vm._v(" "+_vm._s(_vm.punto.nombre)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("R.F.C.:")]),_vm._v(" "+_vm._s(_vm.punto.rfc)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Email_")]),_vm._v(" "+_vm._s(_vm.punto.email)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Teléfono:")]),_vm._v(" "),_c('a',{attrs:{"href":("tel:" + (_vm.punto.telefono))}},[_vm._v(_vm._s(_vm.punto.telefono))]),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Domicilio:")]),_vm._v("\n        "+_vm._s(_vm.punto.calle+' #'+_vm.punto.numero)+"."),_c('br'),_vm._v(" Colonia "+_vm._s(_vm.punto.colonia)+". CP "+_vm._s(_vm.punto.codigo_postal)),_c('br'),_vm._v("\n        "+_vm._s(_vm.punto.municipio)+", "+_vm._s(_vm.punto.estado)),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Notas:")]),_vm._v(" "+_vm._s(_vm.punto.notas)),_c('br')])]),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"60","md-flex-large":"70","md-flex-xlarge":"50"}},[_c('md-card',{staticClass:"w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Información del punto")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-layout',{attrs:{"md-flex":"100","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex":"100"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nombre }},[_c('label',[_vm._v("Nombre del punto")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.punto.nombre_pun),callback:function ($$v) {_vm.punto.nombre_pun=$$v},expression:"punto.nombre_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_guardias }},[_c('label',[_vm._v("Guardias requeridos")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","min":"1","required":""},model:{value:(_vm.punto.guardias_pun),callback:function ($$v) {_vm.punto.guardias_pun=$$v},expression:"punto.guardias_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_presupuesto }},[_c('label',[_vm._v("Presupuesto")]),_vm._v(" "),_c('md-input',{attrs:{"type":"number","step":".01","min":"0","required":""},model:{value:(_vm.punto.presupuesto_pun),callback:function ($$v) {_vm.punto.presupuesto_pun=$$v},expression:"punto.presupuesto_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"70","md-flex-medium":"70","md-flex-large":"70","md-flex-xlarge":"70"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_calle }},[_c('label',[_vm._v("Calle")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.punto.calle_pun),callback:function ($$v) {_vm.punto.calle_pun=$$v},expression:"punto.calle_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"30","md-flex-medium":"30","md-flex-large":"30","md-flex-xlarge":"30"}},[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_num_ext }},[_c('label',[_vm._v("# ext")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.punto.num_ext_pun),callback:function ($$v) {_vm.punto.num_ext_pun=$$v},expression:"punto.num_ext_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"70","md-flex-small":"70","md-flex-medium":"70","md-flex-large":"70","md-flex-xlarge":"70"}},[_c('md-input-container',[_c('label',[_vm._v("Colonia")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.punto.colonia_pun),callback:function ($$v) {_vm.punto.colonia_pun=$$v},expression:"punto.colonia_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"30","md-flex-small":"30","md-flex-medium":"30","md-flex-large":"30","md-flex-xlarge":"30"}},[_c('md-input-container',[_c('label',[_vm._v("C.P.")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.punto.cp_pun),callback:function ($$v) {_vm.punto.cp_pun=$$v},expression:"punto.cp_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',[_c('label',[_vm._v("Municipio")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.punto.municipio_pun),callback:function ($$v) {_vm.punto.municipio_pun=$$v},expression:"punto.municipio_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"50","md-flex-small":"50","md-flex-medium":"50","md-flex-large":"50","md-flex-xlarge":"50"}},[_c('md-input-container',[_c('label',[_vm._v("Estado")]),_vm._v(" "),_c('md-input',{model:{value:(_vm.punto.estado_pun),callback:function ($$v) {_vm.punto.estado_pun=$$v},expression:"punto.estado_pun"}})],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex":"100"}},[_c('md-input-container',[_c('label',[_vm._v("Notas")]),_vm._v(" "),_c('md-textarea',{model:{value:(_vm.punto.notas_pun),callback:function ($$v) {_vm.punto.notas_pun=$$v},expression:"punto.notas_pun"}})],1)],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('router-link',{attrs:{"tag":"md-button","to":"/puntos"}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised",nativeOn:{"click":function($event){_vm.actualizarPunto()}}},[_vm._v("Guardar cambios")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wtFc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AsistenciasPuntoSeleccionado",
  methods: {
    moment: function moment(a, b) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(a, b);
    },
    abrirModal: function abrirModal(ref) {
      this.$refs[ref].open();
    },
    cerrarModal: function cerrarModal(ref) {
      this.$refs[ref].close();
    },
    obtenerEmpleadosPaseDeLista: function obtenerEmpleadosPaseDeLista() {
      var _this = this;

      this.$http.post("asistencias/turno", {
        token: this.$session.get("token"),
        turno: this.$route.params.turno
      }).then(function (response) {
        if (response.status === 200 && "turno" in response.body) {
          _this.turno = response.body.turno;
          _this.empleados = response.body.empleados;
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
          _this.$router.push("/asistencias");
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    asignarPaseLista: function asignarPaseLista(empleado, evento) {
      this.asistencias[empleado] = evento;
    },
    guardarPaseDeLista: function guardarPaseDeLista() {
      var _this2 = this;

      this.$http.post("asistencias/guardar", {
        token: this.$session.get("token"),
        turno: this.turno.id_ptu,
        pase: this.asistencias,
        empleados: this.empleados
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            pos: "top-right"
          });
          _this2.$router.push("/asistencias");
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    }
  },
  created: function created() {
    this.obtenerEmpleadosPaseDeLista();
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data: function data() {
    return {
      msg: "Inicio",
      autocompleteValue: null,
      empleados: [],
      asistencias: [],
      turno: {
        nombre_pun: null,
        inicio_ptu: null,
        termino_ptu: null
      }
    };
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_node_snackbar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    return {
      permisos_editar_nomina: true,
      hay_sesion: this.$session.exists()
    };
  },

  methods: {
    abrirSideNavLeft: function abrirSideNavLeft() {
      this.$refs.leftSidenav.toggle();
    },
    cerrarNav: function cerrarNav() {
      this.$refs.leftSidenav.close();
    },
    abrirModalCalcularNomina: function abrirModalCalcularNomina() {
      this.cerrarNav();
      this.$refs["modalCalcularNomina"].open();
    },
    cerrarModalCalcularNomina: function cerrarModalCalcularNomina(opcion) {
      this.cerrarNav();
      this.$refs["modalCalcularNomina"].close();
      if (opcion === true) {
        this.calcularNomina();
      }
    },
    calcularNomina: function calcularNomina() {
      var _this = this;

      this.$refs["modalCargando"].open();
      this.$http.post("nomina/calcular", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          __WEBPACK_IMPORTED_MODULE_0_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false
          });
          _this.$router.push("/nomina/resumen");
        } else {
          __WEBPACK_IMPORTED_MODULE_0_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
        _this.$refs["modalCargando"].close();
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_0_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        _this.$refs["modalCargando"].close();
      });
    }
  }
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc285dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("o7ya");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bc285dc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJwv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inicio"},[_c('md-layout',{attrs:{"md-flex":"100","md-align":"center","md-gutter":"24"}},[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"65","md-flex-medium":"40","md-flex-large":"30","md-flex-xlarge":"20"}},[_c('md-card',{staticClass:"w-100"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Registrar puesto")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Los campos marcados con * son obligatorios")])]),_vm._v(" "),_c('md-card-content',[_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_nombre }},[_c('label',[_vm._v("Puesto")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.puesto.nombre_pue),callback:function ($$v) {_vm.puesto.nombre_pue=$$v},expression:"puesto.nombre_pue"}})],1),_vm._v(" "),_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_descripcion }},[_c('label',[_vm._v("Descripción")]),_vm._v(" "),_c('md-input',{attrs:{"required":""},model:{value:(_vm.puesto.descripcion_pue),callback:function ($$v) {_vm.puesto.descripcion_pue=$$v},expression:"puesto.descripcion_pue"}})],1),_vm._v(" "),_c('md-input-container',{class:{ 'md-input-invalid': _vm.val.v_depto }},[_c('label',{attrs:{"for":"depto_pue"}},[_vm._v("Departamento")]),_vm._v(" "),_c('md-select',{attrs:{"name":"depto_pue","id":"depto_pue","required":""},model:{value:(_vm.puesto.depto_pue),callback:function ($$v) {_vm.puesto.depto_pue=$$v},expression:"puesto.depto_pue"}},[_c('md-option',{attrs:{"value":"administrativo"}},[_vm._v("Administrativo")]),_vm._v(" "),_c('md-option',{attrs:{"value":"operativo"}},[_vm._v("Operativo")]),_vm._v(" "),_c('md-option',{attrs:{"value":"otro"}},[_vm._v("Otro")])],1)],1)],1),_vm._v(" "),_c('md-card-actions',[_c('router-link',{attrs:{"tag":"md-button","to":"/puestos"}},[_vm._v("Cancelar")]),_vm._v(" "),_c('md-button',{staticClass:"md-primary md-raised",nativeOn:{"click":function($event){_vm.guardarPuesto()}}},[_vm._v("Guardar")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yZBI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_node_snackbar__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EmpleadosNuevo",
  methods: {
    prepararArchivoASubir: function prepararArchivoASubir(e) {
      this.empleado.foto_emn = e[0];
    },
    conyugueCopiarAContacto: function conyugueCopiarAContacto() {
      this.empleado.persona_contacto_emn = this.empleado.nombre_conyuge_emn;
      this.empleado.tel_contacto_emn = this.empleado.tel_conyuge_emn;
    },
    obtenerConceptos: function obtenerConceptos() {
      var _this = this;

      this.$http.post("conceptos", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "conceptos" in response.body) {
          _this.conceptosListado = response.body.conceptos;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
          text: "No se pudieron obtener los conceptos de nómina. Recargue la página.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    valoresConcepto: function valoresConcepto(c) {
      this.con_add.id = c.id_con;
      this.con_add.desc = c.desc_con;
      this.con_add.tipo = c.tipo_con;
      this.con_add.importe = c.importe_cnh;
      this.con_add.quincenas = 1;
      this.con_add.importe_qnal = c.importe_cnh;
    },
    calcularImporteQuincenal: function calcularImporteQuincenal() {
      this.con_add.importe_qnal = Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN"
      }).format(this.con_add.importe / this.con_add.quincenas);
    },
    agregarConcepto: function agregarConcepto() {
      this.conceptosNomina.push({
        id_con: this.con_add.id,
        desc_con: this.con_add.desc,
        tipo_con: this.con_add.tipo,
        importe_con: this.con_add.importe,
        quincenas_con: this.con_add.quincenas,
        importe_qnal_con: this.con_add.importe_qnal
      });
      this.con_add.concepto = null;
      this.con_add.quincenas = 1;
      this.con_add.importe_qnal = 0;
    },
    validarConcepto: function validarConcepto() {},
    removerConcepto: function removerConcepto(c) {
      this.conceptosNomina.splice(c, 1);
    },
    obtenerPuestos: function obtenerPuestos() {
      var _this2 = this;

      this.$http.post("puestos", {
        token: this.$session.get("token"),
        estatus: "activo"
      }).then(function (response) {
        if (response.status === 200 && "puestos" in response.body) {
          _this2.puestosListado = response.body.puestos;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
          text: "No se pudieron obtener los puestos de empleado. Recargue la página.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    obtenerPlanes: function obtenerPlanes() {
      var _this3 = this;

      this.$http.post("planes", {
        token: this.$session.get("token")
      }).then(function (response) {
        if (response.status === 200 && "planes" in response.body) {
          _this3.planesListado = response.body.planes;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
          text: "No se pudieron obtener los planes de empleado. Recargue la página.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    obtenerContratos: function obtenerContratos() {
      var _this4 = this;

      this.$route.params.id;
      this.$http.post("contratos", {
        token: this.$session.get("token"),
        tipo: "laboral_guardia"
      }).then(function (response) {
        if (response.status === 200 && "contratos" in response.body) {
          _this4.contratos = response.body.contratos;
        } else {
          __WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            showAction: false,
            pos: "top-right",
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          showAction: false,
          pos: "top-right",
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    guardarEmpleado: function guardarEmpleado() {
      var _this5 = this;

      if (this.validarEmpleado()) {
        var formData = new FormData();
        formData.append("token", this.$session.get("token"));
        formData.append("empleado", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.empleado));
        formData.append("conceptos", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.conceptosNomina));
        formData.append("foto", this.empleado.foto_emn);
        this.$http.post("empleados/guardar", formData).then(function (response) {
          if (response.status === 200 && "empleado" in response.body) {
            window.open("http://api.grupoalarcom.mx/contratos/pdf?a=e&n=" + response.body.empleado, "_blank");
            __WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
              text: response.body.msg,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false
            });
            _this5.$router.push("/empleados");
          } else {
            __WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
              text: response.body.error,
              actionText: "Cerrar",
              pos: "top-right",
              showAction: false,
              backgroundColor: "#F44336",
              actionTextColor: "#FFF"
            });
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
            text: "Sucedió un error al intentar conectarse con el servidor para guardar el empleado.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      }
    },
    validarEmpleado: function validarEmpleado() {
      this.val.id_cnt_ecn = !this.empleado.id_cnt_ecn ? true : false;
      this.val.v_nombre = !this.empleado.nombre_emn ? true : false;
      this.val.v_ap_pat = !this.empleado.ap_pat_emn ? true : false;
      this.val.v_ap_mat = !this.empleado.ap_mat_emn ? true : false;
      this.val.v_fecha_nac = !this.empleado.fecha_nac_emn ? true : false;
      this.val.v_sexo = !this.empleado.sexo_emn ? true : false;
      this.val.v_direccion = !this.empleado.direccion_emn ? true : false;
      this.val.v_num_ext = !this.empleado.num_ext_emn ? true : false;
      this.val.v_colonia = !this.empleado.colonia_emn ? true : false;
      this.val.v_municipio = !this.empleado.municipio_emn ? true : false;
      this.val.v_estado = !this.empleado.estado_emn ? true : false;
      this.val.v_tel = !this.empleado.tel_emn ? true : false;
      this.val.v_nss = !this.empleado.nss_emn ? true : false;
      this.val.v_curp = !this.empleado.curp_emn ? true : false;
      this.val.v_persona_contacto = !this.empleado.persona_contacto_emn ? true : false;
      this.val.v_tel_contacto = !this.empleado.tel_contacto_emn ? true : false;
      this.val.v_direccion_contacto = !this.empleado.direccion_contacto_emn ? true : false;
      this.val.v_puesto = !this.empleado.puesto_epn ? true : false;
      this.val.v_id_pln = !this.empleado.id_pln_eph ? true : false;
      if (this.val.v_nombre || this.val.v_ap_pat || this.val.v_ap_mat || this.val.v_fecha_nac || this.val.v_sexo || this.val.v_direccion || this.val.v_num_ext || this.val.v_colonia || this.val.v_municipio || this.val.v_estado || this.val.v_tel || this.val.v_curp || this.val.v_persona_contacto || this.val.v_tel_contacto || this.val.v_direccion_contacto || this.val.v_puesto || this.val.v_id_pln) {
        __WEBPACK_IMPORTED_MODULE_3_node_snackbar___default.a.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created: function created() {
    this.obtenerConceptos();
    this.obtenerPuestos();
    this.obtenerPlanes();
    this.obtenerContratos();
  },
  data: function data() {
    return {
      foto_emn: null,
      empleado: {
        nombre_emn: null,
        ap_pat_emn: null,
        ap_mat_emn: null,
        sexo_emn: null,
        estado_civil_emn: null,
        fecha_nac_emn: null,
        direccion_emn: null,
        num_ext_emn: null,
        codigo_postal_emn: null,
        colonia_emn: null,
        estado_emn: null,
        municipio_emn: null,
        tel_emn: null,
        cel_emn: null,
        email_emn: null,
        escolaridad_emn: null,
        fecha_ing_emn: null,
        nss_emn: null,
        curp_emn: null,
        rfc_emn: null,
        peso_emn: null,
        estatura_emn: null,
        camisa_emn: null,
        pantalon_emn: null,
        calzado_emn: null,
        complexion_emn: null,
        ojos_emn: null,
        piel_emn: null,
        cabello_emn: null,
        tipo_sangre_emn: null,
        experiencia_emn: null,
        anos_exp_emn: null,
        foto_emn: null,
        nombre_conyuge_emn: null,
        tel_conyuge_emn: null,
        hijos_emn: null,
        dependientes_emn: null,
        persona_contacto_emn: null,
        tel_contacto_emn: null,
        direccion_contacto_emn: null,
        num_contacto_emn: null,
        colonia_contacto_emn: null,
        puesto_epn: null,
        observaciones_emn: null,
        cuenta_ban_emn: null,
        //plan de pago
        id_pln_eph: null,
        //contrato
        id_cnt_ecn: null
      },
      val: {
        v_nombre: null,
        v_ap_pat: null,
        v_ap_mat: null,
        v_sexo: null,
        v_estado_civil: null,
        v_fecha_nac: null,
        v_direccion: null,
        v_num_ext: null,
        v_codigo_postal: null,
        v_colonia: null,
        v_estado: null,
        v_municipio: null,
        v_tel: null,
        v_cel: null,
        v_email: null,
        v_escolaridad: null,
        v_fecha_ing: null,
        v_nss: null,
        v_curp: null,
        v_rfc: null,
        v_peso: null,
        v_estatura: null,
        v_camisa: null,
        v_pantalon: null,
        v_calzado: null,
        v_complexion: null,
        v_ojos: null,
        v_piel: null,
        v_cabello: null,
        v_tipo_sangre: null,
        v_experiencia: null,
        v_anos_exp: null,
        v_foto: null,
        v_nombre_conyuge: null,
        v_tel_conyuge: null,
        v_hijos: null,
        v_dependientes: null,
        v_persona_contacto: null,
        v_tel_contacto: null,
        v_direccion_contacto: null,
        v_num_contacto: null,
        v_colonia_contacto: null,
        v_puesto: null,
        v_observaciones: null,
        v_cuenta_ban: null,
        //plan de pago
        v_id_pln: null,
        //validaciones de conceptos
        v_con_id: null,
        v_con_desc: null,
        v_con_importe: null,
        v_con_quincenas: null,
        v_con_importe_qnal: null,
        id_cnt_ecn: null
      },
      con_add: {
        id: null,
        desc: null,
        importe: 0,
        quincenas: 1,
        importe_qnal: 0
      },
      conceptosNomina: [],
      conceptosListado: [],
      puestosListado: [],
      planesListado: [],
      contratos: []
    };
  }
});

/***/ }),

/***/ "ybhR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1__ = __webpack_require__("B0Pk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_sha1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_sha1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5__ = __webpack_require__("AJcs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar__ = __webpack_require__("3157");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_node_snackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "inicio",
  methods: {
    moment: function moment(a, b) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(a, b);
    },
    obtenerPunto: function obtenerPunto() {
      var _this = this;

      this.$http.post("turnos", {
        token: this.$session.get("token"),
        turno: this.$route.params.turno
      }).then(function (response) {
        if (response.status === 200 && "turno" in response.body) {
          _this.punto = response.body.turno;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    obtenerRolesRegistrados: function obtenerRolesRegistrados() {
      var _this2 = this;

      this.$http.post("roles", {
        token: this.$session.get("token"),
        turno: this.$route.params.turno
      }).then(function (response) {
        if (response.status === 200 && "roles" in response.body) {
          _this2.rolesRegistrados = response.body.roles;
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    guardarRolesCapturados: function guardarRolesCapturados() {
      var _this3 = this;

      this.$http.post("roles/guardar", {
        token: this.$session.get("token"),
        turno: this.punto.id_ptu,
        roles: this.roles
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false
          });
          _this3.roles = [];
          _this3.rolesRegistrados = null;
          _this3.obtenerRolesRegistrados();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    validarCheckDias: function validarCheckDias() {
      if (this.rol.lun1 === true || this.rol.mar1 === true || this.rol.mie1 === true || this.rol.jue1 === true || this.rol.vie1 === true || this.rol.sab1 === true || this.rol.dom1 === true) {
        return true;
      } else {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Se debe seleccionar por lo menos un día de trabajo.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        return false;
      }
    },
    agregarRol: function agregarRol() {
      if (this.validarCheckDias()) {
        this.roles.push({
          lun1: this.rol.lun1,
          mar1: this.rol.mar1,
          mie1: this.rol.mie1,
          jue1: this.rol.jue1,
          vie1: this.rol.vie1,
          sab1: this.rol.sab1,
          dom1: this.rol.dom1
        });
        this.rol.lun1 = null;
        this.rol.mar1 = null;
        this.rol.mie1 = null;
        this.rol.jue1 = null;
        this.rol.vie1 = null;
        this.rol.sab1 = null;
        this.rol.dom1 = null;
      }
    },
    abrirModalCancelarRoles: function abrirModalCancelarRoles() {
      this.$refs["modalCancelarRoles"].open();
    },
    cerrarModalCancelarRoles: function cerrarModalCancelarRoles() {
      this.$refs["modalCancelarRoles"].close();
    },
    borrarRolesCapturados: function borrarRolesCapturados() {
      this.roles = [];
      this.cerrarModalCancelarRoles();
    },
    borrarRolPreGuardado: function borrarRolPreGuardado(index) {
      this.roles.splice(index, 1);
    },
    borrarRol: function borrarRol(rol, index) {
      var _this4 = this;

      this.$http.post("roles/borrar", {
        token: this.$session.get("token"),
        rol: __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(rol.id_rol))
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false
          });
          _this4.rolesRegistrados.splice(index, 1);
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    },
    buscarEmpleado: function buscarEmpleado(rol, index) {
      this.rolEditado = rol.id_rol;
      this.$refs["modalBuscarEmpleado"].open();
    },
    confirmarEmpleado: function confirmarEmpleado() {
      var _this5 = this;

      if (this.rolEmpleado) {
        this.$http.post("roles/asignar", {
          token: this.$session.get("token"),
          rol: __WEBPACK_IMPORTED_MODULE_0_js_sha1___default()(__WEBPACK_IMPORTED_MODULE_1_blueimp_md5___default()(this.rolEditado)),
          empleado: this.rolEmpleado.id_emn
        }).then(function (response) {
          if (response.status === 200 && "msg" in response.body) {
            console.log(response.body.msg);
            _this5.obtenerRolesRegistrados();
            _this5.autocompleteValue = null;
          }
        }, function (response) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: "No se pudo establecer conexión con el servidor.",
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "Debe seleccionar un empleado.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      }
      this.obtenerRolesRegistrados();
      this.cerrarModalBuscarEmpleado();
    },
    cerrarModalBuscarEmpleado: function cerrarModalBuscarEmpleado() {
      this.rolEmpleado = null;
      this.rolEditado = null;
      this.$refs["modalBuscarEmpleado"].close();
    },
    funcionSelect: function funcionSelect(e) {
      this.rolEmpleado = e;
    },
    fetchFunction: function fetchFunction(param) {
      return this.$http.post("empleados/buscar", {
        token: this.$session.get("token"),
        query: param.q
      }).then(function (response) {
        return response.body;
      }, function (response) {
        console.log("error?");
      });
    },
    cambiarIntercaladoRol: function cambiarIntercaladoRol(rr) {
      var _this6 = this;

      this.$http.post("roles/cambiarsemana", {
        token: this.$session.get("token"),
        rol: rr.id_rol,
        estatus: rr.cambio_rol
      }).then(function (response) {
        if (response.status === 200 && "msg" in response.body) {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.msg,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false
          });
          _this6.obtenerRolesRegistrados();
        } else {
          __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
            text: response.body.error,
            actionText: "Cerrar",
            pos: "top-right",
            showAction: false,
            backgroundColor: "#F44336",
            actionTextColor: "#FFF"
          });
        }
      }, function (response) {
        __WEBPACK_IMPORTED_MODULE_2_node_snackbar___default.a.show({
          text: "No se pudo establecer conexión con el servidor.",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
      });
    }
  },
  beforeCreate: function beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  created: function created() {
    this.obtenerPunto();
    this.obtenerRolesRegistrados();
  },
  data: function data() {
    return {
      punto: [],
      rol: {
        lun1: null,
        mar1: null,
        mie1: null,
        jue1: null,
        vie1: null,
        sab1: null,
        dom1: null
      },
      roles: [],
      rolesRegistrados: [],
      /*asignación de empleados a roles*/
      rolEmpleado: null,
      rolEditado: null,
      /*fin de asignación de empleados a roles*/
      autocompleteValue: null
    };
  }
});

/***/ }),

/***/ "z+ub":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidenciasNueva_vue__ = __webpack_require__("dbcV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83625bbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IncidenciasNueva_vue__ = __webpack_require__("pjhA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncidenciasNueva_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83625bbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_IncidenciasNueva_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zqMi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesListado_vue__ = __webpack_require__("Af+t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19de24c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesListado_vue__ = __webpack_require__("0EqS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesListado_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19de24c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesListado_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.4c9dbc511eb3841f789b.js